var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNftAmico(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-104"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-104",
    d: "M84.62,248.9c-91.36,52.75-91.36,138.27,0,191s239.5,52.74,330.86,0,91.35-138.27,0-191S176,196.15,84.62,248.9Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coins-3--inject-104"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--falling-coins--inject-104"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Coin--inject-104"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.86,65.59l1.78.71-1.46,3.64h0a5.1,5.1,0,0,1-.69,1.22c-.1.13-.21.26-.32.38a6.9,6.9,0,0,1-2,1.49c-.28.14-.58.26-.88.38s-.64.22-1,.32a12.44,12.44,0,0,1-1.36.3c-.5.08-1,.14-1.54.18s-.8.05-1.2.05A30.49,30.49,0,0,1,91,67.75c-.34-.27-.67-.55-1-.83s-.88-.83-1.28-1.26-.64-.7-.92-1-.46-.61-.67-.91-.39-.6-.55-.9h0a9.18,9.18,0,0,1-1-2.58c0-.18-.07-.35-.09-.53a5.63,5.63,0,0,1,.12-2.18,4.48,4.48,0,0,1,.2-.62h0l1.38-3.44,1.63.64a6.31,6.31,0,0,1,.58-.25,11.81,11.81,0,0,1,2.55-.7,15.49,15.49,0,0,1,1.7-.2,19.58,19.58,0,0,1,2.3,0,31.11,31.11,0,0,1,15.85,5.67q1,.74,1.92,1.53c.5.44,1,.9,1.41,1.37a16.09,16.09,0,0,1,1.73,2.17A11.13,11.13,0,0,1,117.86,65.59Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.68,57.61c-.44-.47-.92-.93-1.42-1.37a24.13,24.13,0,0,0-1.91-1.53A31.16,31.16,0,0,0,97.5,49a19.51,19.51,0,0,0-2.3,0c-.59,0-1.15.1-1.71.19a12.41,12.41,0,0,0-2.55.7,7.74,7.74,0,0,0-2.19,1.3A5.28,5.28,0,0,0,87,53.94a5.64,5.64,0,0,0-.11,2.18,5.34,5.34,0,0,0,.09.53,9.3,9.3,0,0,0,1,2.58h0c.17.3.35.59.56.89a11.17,11.17,0,0,0,.67.91c.28.36.58.71.91,1.06s.84.85,1.29,1.26.64.56,1,.83a30.56,30.56,0,0,0,18.17,6.51c.41,0,.81,0,1.21,0s1-.1,1.54-.18.93-.19,1.36-.31.67-.2,1-.31a9,9,0,0,0,.88-.39,6.79,6.79,0,0,0,2-1.48c.11-.13.22-.25.32-.39a5,5,0,0,0,.91-1.89,6.22,6.22,0,0,0-.2-3.39,10.24,10.24,0,0,0-1.23-2.52A16.15,16.15,0,0,0,116.68,57.61Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.27,58.15c-3.94-4.19-11.22-6.91-16.61-6.29-.23,0-.46.06-.68.09-5.44.94-6.52,5.24-2.42,9.6s11.85,7.14,17.29,6.2l.65-.14C116.37,66.45,117.21,62.33,113.27,58.15Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.83,58.22l-.39-.4c-3.84-3.77-10.5-6.17-15.48-5.61l-.14,0-.51.07a7.79,7.79,0,0,0-2.6.9,3.85,3.85,0,0,0-2,4.29,7.72,7.72,0,0,0,1.72,3.33q.27.33.57.66c.19.2.39.39.59.59.43.4.89.79,1.37,1.16a22,22,0,0,0,12.12,4.34,13.25,13.25,0,0,0,1.68-.07c.26,0,.51-.06.76-.11s.42-.08.62-.12l.16,0a5.79,5.79,0,0,0,3-1.66c1.12-1.25,1.25-3,.32-4.9A10.64,10.64,0,0,0,112.83,58.22Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.83,58.22l-.39-.4c-3.84-3.77-10.5-6.17-15.48-5.61l-.14,0-.51.07a7.79,7.79,0,0,0-2.6.9,3.85,3.85,0,0,0-2,4.29,7.72,7.72,0,0,0,1.72,3.33q.27.33.57.66c.19.2.39.39.59.59.43.4.89.79,1.37,1.16a22,22,0,0,0,12.12,4.34,13.25,13.25,0,0,0,1.68-.07c.26,0,.51-.06.76-.11s.42-.08.62-.12l.16,0a5.79,5.79,0,0,0,3-1.66c1.12-1.25,1.25-3,.32-4.9A10.64,10.64,0,0,0,112.83,58.22Z",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.9,59.18l.39.4A10.15,10.15,0,0,1,114.05,62a5,5,0,0,1,.56,3.1,3.46,3.46,0,0,1-.34.44,5.79,5.79,0,0,1-3,1.66l-.16,0c-.2,0-.41.09-.62.12s-.5.08-.76.11a13.25,13.25,0,0,1-1.68.07A22,22,0,0,1,96,63.23c-.48-.37-.94-.76-1.37-1.16-.2-.2-.4-.39-.59-.59s-.39-.44-.57-.66a7.72,7.72,0,0,1-1.72-3.33,4.11,4.11,0,0,1,0-1.56,4.53,4.53,0,0,1,1.49-1.38,8,8,0,0,1,2.6-.89l.52-.07.13,0C101.4,53,108.06,55.41,111.9,59.18Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.6,68c-3.47,3.34-9.25,2.91-13.73,2-6.72-1.63-13.34-5.16-16.81-10.75h0a7.22,7.22,0,0,1-1-5.26A7.28,7.28,0,0,0,88,59.27h0c2.74,4.65,7.82,7.84,13.12,9.79S114.1,72.26,118.6,68Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.55,60.19a7.48,7.48,0,0,0,5.26,1.92l-.61.27-.75,1.87a8.19,8.19,0,0,0,3,1.33,11.11,11.11,0,0,0,3.41.21l1.32,1.3,2.66-.46.75-1.87-.34-.33-.07-.07a1.67,1.67,0,0,0,.22-.42l0-.15c.06-.24.53-1.27.7-1.71a1.24,1.24,0,0,0,0-.16c.15-.54-.1-1.18-.84-1.91h0a6.22,6.22,0,0,0-2.68-1.51l-.25-.06h0l-.27-.06-.24,0h-.09l-.18,0a13.59,13.59,0,0,0-1.53-.14h-.67l.8-.37.75-1.86a9.68,9.68,0,0,0-6-1.39l-1.32-1.29-2.65.5-.75,1.86.42.41a1.4,1.4,0,0,0-.19.33v0c-.1.29-.62,1.52-.74,1.85h0C94.51,58.75,94.77,59.42,95.55,60.19Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.11,62.16c-.19.48-.6,1.41-.66,1.63l0,.15a1.67,1.67,0,0,1-.22.42l-.94-.93A2.33,2.33,0,0,0,111.11,62.16Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.64,57.54c-.4-.39-.33-.79.77-1a3.8,3.8,0,0,1,2.93.55L106,55.89l-.75,1.86-.8.37H103a12.35,12.35,0,0,1-2.14-.06,2.19,2.19,0,0,1-.84-.27A1.31,1.31,0,0,1,99.64,57.54Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.64,56l-.41-.41L96,53.71,97.29,55A3.25,3.25,0,0,0,95.64,56Z",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.92,65.22l2.67-.46-.75,1.87-2.67.46-1.31-1.3a11.11,11.11,0,0,1-3.41-.21,8.68,8.68,0,0,1-2-.7,10.29,10.29,0,0,1-1-.63l.75-1.87a8.14,8.14,0,0,0,1,.63,8.94,8.94,0,0,0,2,.7,11.11,11.11,0,0,0,3.41.22Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.86,65.79a8.17,8.17,0,0,1-2.79,0,6.94,6.94,0,0,1-2.58-.93,13.28,13.28,0,0,0,2.63.71c.45.07.9.12,1.36.15S105.4,65.78,105.86,65.79Z",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7,58.19h0c.12-.33.64-1.55.74-1.85-.18.56.07,1.22.85,2,1.74,1.71,4,2,6.15,1.94,2,0,3.55-.24,4.39.58.53.52.18.87-.68,1a4.08,4.08,0,0,1-3.17-.72l-2.17,1h0a7.55,7.55,0,0,1-5.26-1.92C94.76,59.42,94.51,58.76,94.7,58.19Z",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.6 58.94 103.34 57.08 105.97 55.89 105.22 57.75 102.6 58.94",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.6 58.94 103.34 57.08 105.97 55.89 105.22 57.75 102.6 58.94",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.97 53.71 97.29 55 95.64 55.98 95.22 55.58 95.97 53.71",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.97 53.71 97.29 55 95.64 55.98 95.22 55.58 95.97 53.71",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.25,64.43l-1-1a2.32,2.32,0,0,0,1.91-1.35,1.24,1.24,0,0,0,0-.16c.15-.54-.1-1.18-.84-1.91h0a6.22,6.22,0,0,0-2.68-1.51l-.25-.06h0l-.27-.06-.24,0h-.09l-.18,0a13.59,13.59,0,0,0-1.53-.14c-.24,0-.49,0-.73,0H103a12.33,12.33,0,0,1-2.15-.07,2.38,2.38,0,0,1-.83-.26,2.1,2.1,0,0,1-.33-.26c-.4-.39-.33-.79.77-1a3.71,3.71,0,0,1,2.93.55L106,55.89a9.68,9.68,0,0,0-6-1.39l-1.32-1.29-2.65.5L97.29,55a2.67,2.67,0,0,0-1.84,1.31v0c-.18.56.07,1.22.85,2,1.73,1.71,4,2,6.15,1.94,2,0,3.55-.24,4.39.58.53.52.18.87-.69,1a4.08,4.08,0,0,1-3.16-.72l-2.78,1.23a7.59,7.59,0,0,0,1,.63,8.52,8.52,0,0,0,2,.7,11.11,11.11,0,0,0,3.41.22l1.31,1.29,2.67-.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.25,64.43l-1-1a2.32,2.32,0,0,0,1.91-1.35,1.24,1.24,0,0,0,0-.16c.15-.54-.1-1.18-.84-1.91h0a6.22,6.22,0,0,0-2.68-1.51l-.25-.06h0l-.27-.06-.24,0h-.09l-.18,0a13.59,13.59,0,0,0-1.53-.14c-.24,0-.49,0-.73,0H103a12.33,12.33,0,0,1-2.15-.07,2.38,2.38,0,0,1-.83-.26,2.1,2.1,0,0,1-.33-.26c-.4-.39-.33-.79.77-1a3.71,3.71,0,0,1,2.93.55L106,55.89a9.68,9.68,0,0,0-6-1.39l-1.32-1.29-2.65.5L97.29,55a2.67,2.67,0,0,0-1.84,1.31v0c-.18.56.07,1.22.85,2,1.73,1.71,4,2,6.15,1.94,2,0,3.55-.24,4.39.58.53.52.18.87-.69,1a4.08,4.08,0,0,1-3.16-.72l-2.78,1.23a7.59,7.59,0,0,0,1,.63,8.52,8.52,0,0,0,2,.7,11.11,11.11,0,0,0,3.41.22l1.31,1.29,2.67-.46Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.29,58.32a6.42,6.42,0,0,0,2.32,1.38,10.17,10.17,0,0,0,2.75.48c.93,0,1.88,0,2.82,0a9.66,9.66,0,0,1,1.42.08,2.25,2.25,0,0,1,1.23.58,2.27,2.27,0,0,0-1.24-.52,8.31,8.31,0,0,0-1.41,0c-.94,0-1.89.07-2.83,0a9.62,9.62,0,0,1-2.78-.51,6.49,6.49,0,0,1-1.24-.61A6.18,6.18,0,0,1,96.29,58.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.92 65.22 107.18 67.09 105.86 65.79 106.61 63.93 107.92 65.22",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.92 65.22 107.18 67.09 105.86 65.79 106.61 63.93 107.92 65.22",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "110.59 64.76 108.01 65.02 106.61 63.93 107.92 65.22 110.59 64.76",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.94 54.5 98.56 53.4 95.97 53.71 98.62 53.21 99.94 54.5",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-104"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.72,78.49,48,79,47,81.64h0a3.75,3.75,0,0,1-.5.89l-.23.27a5.1,5.1,0,0,1-1.48,1.08c-.2.1-.41.19-.63.28l-.71.23a9,9,0,0,1-1,.22c-.36.06-.74.1-1.12.13l-.87,0a22.23,22.23,0,0,1-13.17-4.72l-.71-.6c-.33-.3-.64-.6-.93-.91s-.46-.52-.66-.77-.34-.44-.49-.66a7.6,7.6,0,0,1-.4-.65h0a6.49,6.49,0,0,1-.74-1.87c0-.13-.05-.26-.06-.38a3.81,3.81,0,0,1,.23-2h0l1-2.5,1.18.47a4.08,4.08,0,0,1,.42-.18,8.42,8.42,0,0,1,1.85-.51,9.84,9.84,0,0,1,1.23-.14,13.26,13.26,0,0,1,1.67,0,22.44,22.44,0,0,1,11.48,4.11,16.9,16.9,0,0,1,1.39,1.11c.36.32.71.65,1,1A12,12,0,0,1,46,77.1,7.85,7.85,0,0,1,46.72,78.49Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.86,72.71q-.48-.51-1-1a16.9,16.9,0,0,0-1.39-1.11A22.51,22.51,0,0,0,32,66.5a13.11,13.11,0,0,0-1.66,0,9.79,9.79,0,0,0-1.24.14,8.58,8.58,0,0,0-1.85.51,5.35,5.35,0,0,0-1.59.94,3.89,3.89,0,0,0-1.25,2,4.14,4.14,0,0,0-.08,1.58c0,.13,0,.25.07.38a6.75,6.75,0,0,0,.73,1.87h0c.12.22.26.43.4.65s.31.44.49.66.42.51.66.77.61.61.93.91l.72.6a22.13,22.13,0,0,0,13.16,4.72c.3,0,.59,0,.88,0s.75-.07,1.11-.13a9,9,0,0,0,1-.22,6.57,6.57,0,0,0,.71-.23,6.18,6.18,0,0,0,.64-.28,4.9,4.9,0,0,0,1.47-1.07l.24-.28a3.84,3.84,0,0,0,.65-1.37A4.46,4.46,0,0,0,48,76.11a7.67,7.67,0,0,0-.89-1.83A11.29,11.29,0,0,0,45.86,72.71Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.39,73.1a15.93,15.93,0,0,0-12-4.56l-.5.07c-3.94.68-4.72,3.8-1.75,7s8.59,5.17,12.53,4.48c.16,0,.32-.06.47-.09C45.64,79.12,46.24,76.13,43.39,73.1Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.07,73.15l-.28-.29A15.27,15.27,0,0,0,31.57,68.8h-.09l-.38.06a5.68,5.68,0,0,0-1.88.64,2.81,2.81,0,0,0-1.45,3.12A5.59,5.59,0,0,0,29,75a5.74,5.74,0,0,0,.41.47l.43.43q.47.44,1,.84a15.86,15.86,0,0,0,8.78,3.14,9.82,9.82,0,0,0,1.22,0l.55-.08.45-.09.12,0a4.25,4.25,0,0,0,2.15-1.2,3.05,3.05,0,0,0,.23-3.55A7.44,7.44,0,0,0,43.07,73.15Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.07,73.15l-.28-.29A15.27,15.27,0,0,0,31.57,68.8h-.09l-.38.06a5.68,5.68,0,0,0-1.88.64,2.81,2.81,0,0,0-1.45,3.12A5.59,5.59,0,0,0,29,75a5.74,5.74,0,0,0,.41.47l.43.43q.47.44,1,.84a15.86,15.86,0,0,0,8.78,3.14,9.82,9.82,0,0,0,1.22,0l.55-.08.45-.09.12,0a4.25,4.25,0,0,0,2.15-1.2,3.05,3.05,0,0,0,.23-3.55A7.44,7.44,0,0,0,43.07,73.15Z",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4,73.85a3.83,3.83,0,0,1,.28.29A7.44,7.44,0,0,1,44,75.92a3.66,3.66,0,0,1,.4,2.24,2.43,2.43,0,0,1-.24.32A4.25,4.25,0,0,1,42,79.68l-.12,0-.45.09-.55.08a9.82,9.82,0,0,1-1.22,0,15.86,15.86,0,0,1-8.78-3.14q-.53-.41-1-.84l-.43-.43A5.74,5.74,0,0,1,29,75a5.59,5.59,0,0,1-1.25-2.41,3.14,3.14,0,0,1,0-1.14,3.15,3.15,0,0,1,1.08-1,5.62,5.62,0,0,1,1.88-.65l.38,0,.09,0A15.28,15.28,0,0,1,42.4,73.85Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.25,80.22c-2.51,2.42-6.7,2.11-9.94,1.43-4.88-1.18-9.67-3.75-12.18-7.8h0a5.26,5.26,0,0,1-.76-3.81,5.26,5.26,0,0,0,.68,3.86h0c2,3.38,5.66,5.69,9.51,7.1S44,83.32,47.25,80.22Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.55,74.58A5.44,5.44,0,0,0,34.36,76l-.44.2-.54,1.35a5.4,5.4,0,0,0,.75.46,6.5,6.5,0,0,0,1.42.5,8.11,8.11,0,0,0,2.47.16l1,.94,1.93-.33.54-1.36-.24-.24-.06-.05a1.08,1.08,0,0,0,.16-.3.76.76,0,0,0,0-.11c0-.18.38-.93.5-1.24a.76.76,0,0,0,0-.11c.1-.4-.08-.86-.61-1.39h0a4.44,4.44,0,0,0-1.94-1.09l-.18,0h0l-.2,0a.86.86,0,0,0-.17,0l-.07,0-.13,0a10.45,10.45,0,0,0-1.1-.1H37l.58-.27.54-1.35a7,7,0,0,0-4.37-1l-.95-.94-1.92.36-.54,1.36.3.29a1,1,0,0,0-.14.24h0c-.08.22-.45,1.1-.54,1.34h0C29.8,73.54,30,74,30.55,74.58Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.83,76c-.14.35-.44,1-.48,1.18a.49.49,0,0,1,0,.11,1.08,1.08,0,0,1-.16.3l-.68-.67A1.7,1.7,0,0,0,41.83,76Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.51,72.66c-.28-.28-.23-.58.56-.73a2.71,2.71,0,0,1,2.13.4l1.9-.87-.54,1.35-.58.27h0c-.25,0-.5,0-.73,0h-.29a9,9,0,0,1-1.55,0,1.7,1.7,0,0,1-.6-.2A1.44,1.44,0,0,1,33.51,72.66Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.61,71.53l-.29-.3.54-1.35.95.94A2.39,2.39,0,0,0,30.61,71.53Z",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.52,78.23l1.93-.34-.54,1.36L39,79.58l-1-.94a8.09,8.09,0,0,1-2.47-.16,6.33,6.33,0,0,1-1.42-.5,7.57,7.57,0,0,1-.75-.46l.54-1.35a5.32,5.32,0,0,0,.75.45,6.06,6.06,0,0,0,1.42.51,8.09,8.09,0,0,0,2.47.16Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38,78.64a6,6,0,0,1-2,0A5,5,0,0,1,34.13,78a9.61,9.61,0,0,0,1.91.51,7.94,7.94,0,0,0,1,.11C37.35,78.63,37.69,78.63,38,78.64Z",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.94,73.13h0c.09-.24.46-1.12.54-1.34-.14.41,0,.89.61,1.45a6,6,0,0,0,4.46,1.4c1.45,0,2.57-.18,3.18.42.38.38.13.63-.5.75a3,3,0,0,1-2.3-.53l-1.57.7h0a5.44,5.44,0,0,1-3.81-1.39C30,74,29.8,73.54,29.94,73.13Z",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "35.66 73.68 36.2 72.33 38.1 71.46 37.56 72.81 35.66 73.68",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "35.66 73.68 36.2 72.33 38.1 71.46 37.56 72.81 35.66 73.68",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "30.86 69.88 31.81 70.82 30.62 71.53 30.32 71.24 30.86 69.88",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "30.86 69.88 31.81 70.82 30.62 71.53 30.32 71.24 30.86 69.88",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.21,77.65l-.74-.72a1.68,1.68,0,0,0,1.38-1,.76.76,0,0,0,0-.11c.1-.4-.08-.86-.61-1.39h0a4.44,4.44,0,0,0-1.94-1.09l-.18,0h0l-.2,0a.86.86,0,0,0-.17,0l-.07,0-.13,0a10.45,10.45,0,0,0-1.1-.1h-.53c-.26,0-.51,0-.75,0h-.28a9,9,0,0,1-1.55,0,1.63,1.63,0,0,1-.6-.2,1.44,1.44,0,0,1-.25-.18c-.28-.28-.23-.58.56-.73a2.71,2.71,0,0,1,2.13.4l1.9-.87a7,7,0,0,0-4.37-1l-.95-.94-1.92.36.95.94c-.72.23-1.19.55-1.33,1h0c-.14.41,0,.89.61,1.45a5.92,5.92,0,0,0,4.45,1.4c1.46,0,2.58-.18,3.19.42.38.38.13.63-.5.75a3,3,0,0,1-2.3-.53l-2,.9a6.47,6.47,0,0,0,.75.45,6.06,6.06,0,0,0,1.42.51,8.11,8.11,0,0,0,2.47.16l1,.94,1.93-.34Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.21,77.65l-.74-.72a1.68,1.68,0,0,0,1.38-1,.76.76,0,0,0,0-.11c.1-.4-.08-.86-.61-1.39h0a4.44,4.44,0,0,0-1.94-1.09l-.18,0h0l-.2,0a.86.86,0,0,0-.17,0l-.07,0-.13,0a10.45,10.45,0,0,0-1.1-.1h-.53c-.26,0-.51,0-.75,0h-.28a9,9,0,0,1-1.55,0,1.63,1.63,0,0,1-.6-.2,1.44,1.44,0,0,1-.25-.18c-.28-.28-.23-.58.56-.73a2.71,2.71,0,0,1,2.13.4l1.9-.87a7,7,0,0,0-4.37-1l-.95-.94-1.92.36.95.94c-.72.23-1.19.55-1.33,1h0c-.14.41,0,.89.61,1.45a5.92,5.92,0,0,0,4.45,1.4c1.46,0,2.58-.18,3.19.42.38.38.13.63-.5.75a3,3,0,0,1-2.3-.53l-2,.9a6.47,6.47,0,0,0,.75.45,6.06,6.06,0,0,0,1.42.51,8.11,8.11,0,0,0,2.47.16l1,.94,1.93-.34Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.09,73.23a4.82,4.82,0,0,0,1.68,1,7,7,0,0,0,2,.35c.68,0,1.36,0,2.05,0a6.9,6.9,0,0,1,1,.06,1.68,1.68,0,0,1,.9.42,1.61,1.61,0,0,0-.9-.37,5.8,5.8,0,0,0-1,0c-.68,0-1.37.06-2.06,0a7.21,7.21,0,0,1-2-.37,5,5,0,0,1-.9-.44A6.5,6.5,0,0,1,31.09,73.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "39.52 78.23 38.98 79.58 38.02 78.64 38.56 77.29 39.52 78.23",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "39.52 78.23 38.98 79.58 38.02 78.64 38.56 77.29 39.52 78.23",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "41.45 77.89 39.58 78.08 38.56 77.29 39.52 78.23 41.45 77.89",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "33.73 70.46 32.73 69.66 30.86 69.88 32.78 69.52 33.73 70.46",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-104"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M386.36,115.74l1.64.65-1.34,3.34h0a4.69,4.69,0,0,1-.64,1.13c-.09.12-.19.23-.29.35a6.48,6.48,0,0,1-1.88,1.37c-.25.12-.52.24-.81.35s-.58.2-.9.29-.81.2-1.25.28-.93.13-1.42.17-.73,0-1.11,0a28.11,28.11,0,0,1-16.71-6c-.31-.25-.61-.51-.9-.77a16.34,16.34,0,0,1-1.19-1.16c-.3-.32-.58-.65-.84-1s-.43-.56-.62-.84-.35-.55-.51-.82h0a8.42,8.42,0,0,1-.93-2.37c0-.17-.06-.33-.08-.49a5.11,5.11,0,0,1,.1-2,5.62,5.62,0,0,1,.19-.58h0l1.27-3.16,1.5.59.53-.24a11.29,11.29,0,0,1,2.35-.64,13,13,0,0,1,1.56-.18,16.64,16.64,0,0,1,2.12,0,28.55,28.55,0,0,1,14.58,5.22,20.4,20.4,0,0,1,1.76,1.4c.46.41.9.83,1.3,1.26a14.48,14.48,0,0,1,1.59,2A10.08,10.08,0,0,1,386.36,115.74Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.27,108.39c-.4-.43-.84-.85-1.3-1.26a20.4,20.4,0,0,0-1.76-1.4,28.52,28.52,0,0,0-14.58-5.22,16.64,16.64,0,0,0-2.12,0,13,13,0,0,0-1.56.18,11.29,11.29,0,0,0-2.35.64,7.2,7.2,0,0,0-2,1.2A4.84,4.84,0,0,0,358,105a5.32,5.32,0,0,0-.1,2c0,.16.05.33.08.49a8.61,8.61,0,0,0,.93,2.37h0a9.29,9.29,0,0,0,.51.83c.18.27.39.55.61.83s.54.65.84,1,.77.78,1.19,1.15.59.52.9.77a28.15,28.15,0,0,0,16.71,6c.38,0,.75,0,1.12-.05s.95-.09,1.41-.17a11,11,0,0,0,1.25-.28,8.07,8.07,0,0,0,.91-.29c.28-.11.55-.22.81-.35a6.43,6.43,0,0,0,1.87-1.37l.3-.35a4.66,4.66,0,0,0,.83-1.74,5.72,5.72,0,0,0-.18-3.12,9.5,9.5,0,0,0-1.13-2.32A14.48,14.48,0,0,0,385.27,108.39Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.14,108.89c-3.63-3.85-10.32-6.35-15.28-5.79l-.63.09c-5,.87-6,4.82-2.22,8.83s10.9,6.56,15.9,5.7l.6-.12C385,116.53,385.76,112.74,382.14,108.89Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.73,109a4.17,4.17,0,0,0-.36-.37c-3.53-3.47-9.66-5.68-14.24-5.16l-.12,0-.47.06a7.37,7.37,0,0,0-2.39.82,3.54,3.54,0,0,0-1.84,4,7.13,7.13,0,0,0,1.58,3.06c.16.2.34.4.53.6a6.88,6.88,0,0,0,.54.54,14.77,14.77,0,0,0,1.26,1.07,20.21,20.21,0,0,0,11.14,4,13.13,13.13,0,0,0,1.55-.06c.24,0,.47-.06.7-.1l.57-.11.15,0a5.33,5.33,0,0,0,2.73-1.52,3.88,3.88,0,0,0,.29-4.51A9.34,9.34,0,0,0,381.73,109Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.73,109a4.17,4.17,0,0,0-.36-.37c-3.53-3.47-9.66-5.68-14.24-5.16l-.12,0-.47.06a7.37,7.37,0,0,0-2.39.82,3.54,3.54,0,0,0-1.84,4,7.13,7.13,0,0,0,1.58,3.06c.16.2.34.4.53.6a6.88,6.88,0,0,0,.54.54,14.77,14.77,0,0,0,1.26,1.07,20.21,20.21,0,0,0,11.14,4,13.13,13.13,0,0,0,1.55-.06c.24,0,.47-.06.7-.1l.57-.11.15,0a5.33,5.33,0,0,0,2.73-1.52,3.88,3.88,0,0,0,.29-4.51A9.34,9.34,0,0,0,381.73,109Z",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.88,109.84l.36.37a9.63,9.63,0,0,1,1.62,2.25,4.66,4.66,0,0,1,.51,2.85,2.94,2.94,0,0,1-.31.41,5.33,5.33,0,0,1-2.73,1.52l-.15,0-.57.11c-.23,0-.46.08-.7.1a13.13,13.13,0,0,1-1.55.06,20.21,20.21,0,0,1-11.14-4,14.77,14.77,0,0,1-1.26-1.07,6.88,6.88,0,0,1-.54-.54c-.19-.2-.37-.4-.53-.6a7.13,7.13,0,0,1-1.58-3.06,3.9,3.9,0,0,1,0-1.44,4.11,4.11,0,0,1,1.37-1.27,7.37,7.37,0,0,1,2.39-.82l.48-.07h.12C371.22,104.16,377.35,106.37,380.88,109.84Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387,117.92c-3.19,3.08-8.51,2.68-12.63,1.82-6.18-1.5-12.27-4.75-15.46-9.89h0a6.72,6.72,0,0,1-1-4.84,6.69,6.69,0,0,0,.87,4.9h0c2.52,4.28,7.19,7.21,12.07,9S382.9,121.87,387,117.92Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.84,110.77a6.92,6.92,0,0,0,4.83,1.77l-.56.25-.68,1.71a8.63,8.63,0,0,0,.95.58,7.83,7.83,0,0,0,1.81.64,10.22,10.22,0,0,0,3.13.2l1.21,1.19,2.45-.42.69-1.71-.31-.31-.06-.07a1.94,1.94,0,0,0,.2-.38.74.74,0,0,0,0-.14c.06-.22.49-1.17.64-1.58l.05-.14c.13-.5-.1-1.09-.77-1.75h0a5.85,5.85,0,0,0-2.46-1.39,2.1,2.1,0,0,1-.24-.06h0l-.25-.06-.22,0-.09,0-.16,0a13.82,13.82,0,0,0-1.4-.14H374l.73-.33.69-1.72a9,9,0,0,0-5.54-1.28l-1.22-1.19-2.43.47-.69,1.71.38.38a1,1,0,0,0-.17.3v0c-.09.27-.57,1.39-.68,1.7h0C364.88,109.45,365.12,110.06,365.84,110.77Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.15,112.58c-.17.44-.55,1.29-.61,1.5a.74.74,0,0,1,0,.14,1.79,1.79,0,0,1-.2.39l-.87-.86A2.14,2.14,0,0,0,380.15,112.58Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.6,108.33c-.37-.36-.3-.73.71-.93a3.47,3.47,0,0,1,2.7.51l2.41-1.1-.69,1.72-.73.33h-1.36a11.44,11.44,0,0,1-2-.06,2.06,2.06,0,0,1-.76-.25A1.19,1.19,0,0,1,369.6,108.33Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.92,106.89l-.38-.37.69-1.71,1.21,1.19A3.05,3.05,0,0,0,365.92,106.89Z",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.22,115.4l2.45-.43-.68,1.72-2.46.43-1.21-1.2a10.22,10.22,0,0,1-3.13-.2,8.32,8.32,0,0,1-1.81-.64,7.33,7.33,0,0,1-.95-.58l.68-1.71a7.34,7.34,0,0,0,1,.57,7.79,7.79,0,0,0,1.8.65,10,10,0,0,0,3.14.19Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.32,115.92a7.91,7.91,0,0,1-2.57,0,6.31,6.31,0,0,1-2.37-.86,12,12,0,0,0,2.42.65c.41.07.83.11,1.25.15S374.9,115.91,375.32,115.92Z",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.06,108.93h0c.11-.31.59-1.43.68-1.71-.17.52.06,1.13.78,1.84,1.6,1.57,3.67,1.79,5.66,1.79,1.84,0,3.26-.23,4,.53.48.47.16.79-.63.94a3.78,3.78,0,0,1-2.92-.66l-2,.89h0a6.94,6.94,0,0,1-4.84-1.77C365.12,110.06,364.88,109.45,365.06,108.93Z",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.32 109.62 373.01 107.91 375.42 106.81 374.73 108.53 372.32 109.62",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.32 109.62 373.01 107.91 375.42 106.81 374.73 108.53 372.32 109.62",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.23 104.81 367.44 106 365.92 106.89 365.54 106.52 366.23 104.81",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.23 104.81 367.44 106 365.92 106.89 365.54 106.52 366.23 104.81",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.36,114.67l-.93-.92a2.13,2.13,0,0,0,1.75-1.25l.05-.14c.13-.5-.1-1.09-.77-1.75h0a5.85,5.85,0,0,0-2.46-1.39,2.1,2.1,0,0,1-.24-.06h0l-.25-.06-.22,0-.09,0-.16,0a13.82,13.82,0,0,0-1.4-.14h-2a11.44,11.44,0,0,1-2-.06,2.27,2.27,0,0,1-.76-.24,1.83,1.83,0,0,1-.31-.24c-.37-.36-.3-.73.71-.92a3.39,3.39,0,0,1,2.7.5l2.41-1.1a9,9,0,0,0-5.54-1.28l-1.22-1.19-2.43.47,1.21,1.19c-.93.29-1.51.7-1.69,1.2v0c-.17.51.06,1.12.78,1.83,1.59,1.57,3.67,1.79,5.66,1.79,1.84,0,3.26-.23,4,.53.48.47.16.79-.64.94a3.77,3.77,0,0,1-2.91-.66l-2.56,1.14a7.34,7.34,0,0,0,1,.57,7.79,7.79,0,0,0,1.8.65,10,10,0,0,0,3.14.19l1.21,1.2,2.45-.42Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.36,114.67l-.93-.92a2.13,2.13,0,0,0,1.75-1.25l.05-.14c.13-.5-.1-1.09-.77-1.75h0a5.85,5.85,0,0,0-2.46-1.39,2.1,2.1,0,0,1-.24-.06h0l-.25-.06-.22,0-.09,0-.16,0a13.82,13.82,0,0,0-1.4-.14h-2a11.44,11.44,0,0,1-2-.06,2.27,2.27,0,0,1-.76-.24,1.83,1.83,0,0,1-.31-.24c-.37-.36-.3-.73.71-.92a3.39,3.39,0,0,1,2.7.5l2.41-1.1a9,9,0,0,0-5.54-1.28l-1.22-1.19-2.43.47,1.21,1.19c-.93.29-1.51.7-1.69,1.2v0c-.17.51.06,1.12.78,1.83,1.59,1.57,3.67,1.79,5.66,1.79,1.84,0,3.26-.23,4,.53.48.47.16.79-.64.94a3.77,3.77,0,0,1-2.91-.66l-2.56,1.14a7.34,7.34,0,0,0,1,.57,7.79,7.79,0,0,0,1.8.65,10,10,0,0,0,3.14.19l1.21,1.2,2.45-.42Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.52,109.05a5.86,5.86,0,0,0,2.14,1.27,9.24,9.24,0,0,0,2.52.43c.86.06,1.73,0,2.6,0a8.11,8.11,0,0,1,1.3.08,2,2,0,0,1,1.14.53,2.05,2.05,0,0,0-1.15-.48,7.91,7.91,0,0,0-1.29,0c-.87,0-1.74.06-2.61,0a8.78,8.78,0,0,1-2.55-.47,5.75,5.75,0,0,1-1.14-.56A6.12,6.12,0,0,1,366.52,109.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.22 115.4 376.53 117.11 375.32 115.92 376.01 114.2 377.22 115.4",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.22 115.4 376.53 117.11 375.32 115.92 376.01 114.2 377.22 115.4",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "379.67 114.97 377.3 115.21 376.01 114.2 377.22 115.4 379.67 114.97",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.88 105.53 368.6 104.53 366.23 104.81 368.67 104.34 369.88 105.53",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-104"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.28,123.42l-1.16.85,1.75,2.37h0a3.75,3.75,0,0,0,.74.75l.31.22a5.06,5.06,0,0,0,1.76.69,5.27,5.27,0,0,0,.71.11c.25,0,.51,0,.78.05a9.39,9.39,0,0,0,1-.05,9.5,9.5,0,0,0,1.16-.16c.29-.05.59-.12.89-.19a23,23,0,0,0,12-8.21c.2-.26.38-.52.55-.79a12.76,12.76,0,0,0,.7-1.16c.17-.32.33-.63.46-.94s.23-.53.32-.79.17-.51.23-.76h0a7,7,0,0,0,.24-2.07c0-.14,0-.27,0-.4a4.15,4.15,0,0,0-.5-1.56,3,3,0,0,0-.27-.42h0l-1.66-2.24-1.06.78-.47-.07a8.74,8.74,0,0,0-2,0,11.41,11.41,0,0,0-1.27.18,14.79,14.79,0,0,0-1.68.43,23.31,23.31,0,0,0-10.44,7.16c-.4.48-.76,1-1.1,1.47s-.54.84-.77,1.27a12.29,12.29,0,0,0-.83,1.91A7.57,7.57,0,0,0,112.28,123.42Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.77,119.3a7.82,7.82,0,0,0-.41,2.07,4.7,4.7,0,0,0,.5,2.5,3.94,3.94,0,0,0,1,1.2l.31.22A5.27,5.27,0,0,0,114,126c.23,0,.46.08.71.11s.51,0,.78,0a9.3,9.3,0,0,0,1,0c.38,0,.77-.09,1.16-.16s.59-.12.89-.2a22.93,22.93,0,0,0,12-8.2c.2-.26.38-.53.55-.8a12.62,12.62,0,0,0,.7-1.15c.17-.32.33-.64.46-1s.23-.53.32-.79.16-.51.23-.75h0A7,7,0,0,0,133,111l0-.41a4.21,4.21,0,0,0-.5-1.56,4,4,0,0,0-1.77-1.63,5.91,5.91,0,0,0-1.84-.53,10.08,10.08,0,0,0-2,0,11.64,11.64,0,0,0-1.28.19,13.83,13.83,0,0,0-1.68.43,23.31,23.31,0,0,0-10.43,7.15,18.25,18.25,0,0,0-1.1,1.48c-.28.42-.54.84-.77,1.27A11.49,11.49,0,0,0,110.77,119.3Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.19,117.13a16.5,16.5,0,0,1,10.88-7.75,4.43,4.43,0,0,1,.51-.06c4.13-.36,5.74,2.56,3.59,6.52s-7.25,7.45-11.39,7.8l-.49,0C113.52,123.76,112.13,120.92,114.19,117.13Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.53,117.1l.2-.37a15.85,15.85,0,0,1,10.18-7l.11,0,.38,0a5.83,5.83,0,0,1,2.06.15,2.91,2.91,0,0,1,2.28,2.74,5.92,5.92,0,0,1-.61,2.75c-.09.19-.19.39-.3.58a6,6,0,0,1-.31.55,11.08,11.08,0,0,1-.78,1.1,16.4,16.4,0,0,1-8,5.47,11.57,11.57,0,0,1-1.24.28,5.51,5.51,0,0,1-.57.06l-.47,0h-.13a4.36,4.36,0,0,1-2.48-.63,3.16,3.16,0,0,1-1.16-3.5A7.5,7.5,0,0,1,114.53,117.1Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.53,117.1l.2-.37a15.85,15.85,0,0,1,10.18-7l.11,0,.38,0a5.83,5.83,0,0,1,2.06.15,2.91,2.91,0,0,1,2.28,2.74,5.92,5.92,0,0,1-.61,2.75c-.09.19-.19.39-.3.58a6,6,0,0,1-.31.55,11.08,11.08,0,0,1-.78,1.1,16.4,16.4,0,0,1-8,5.47,11.57,11.57,0,0,1-1.24.28,5.51,5.51,0,0,1-.57.06l-.47,0h-.13a4.36,4.36,0,0,1-2.48-.63,3.16,3.16,0,0,1-1.16-3.5A7.5,7.5,0,0,1,114.53,117.1Z",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.38,117.62c-.07.12-.14.24-.2.36a7.61,7.61,0,0,0-.81,2.12,3.75,3.75,0,0,0,.18,2.36,2.91,2.91,0,0,0,.33.26,4.36,4.36,0,0,0,2.48.63h.13l.47,0a5.51,5.51,0,0,0,.57-.06,11.57,11.57,0,0,0,1.24-.28,16.4,16.4,0,0,0,8-5.47,11.08,11.08,0,0,0,.78-1.1,6,6,0,0,0,.31-.55c.11-.19.21-.39.3-.58a5.92,5.92,0,0,0,.61-2.75,3.19,3.19,0,0,0-.28-1.14,3.24,3.24,0,0,0-1.35-.72,6.07,6.07,0,0,0-2.06-.15l-.38,0h-.1A15.86,15.86,0,0,0,115.38,117.62Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.2,125.29c3.15,1.76,7.28.35,10.35-1.19,4.58-2.47,8.71-6.31,10.17-11h0a5.44,5.44,0,0,0-.24-4,5.41,5.41,0,0,1,.33,4h0c-1.1,3.9-4.18,7.19-7.67,9.63S116.29,127.54,112.2,125.29Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--money-sign--inject-104"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "119 118.01 119.74 119.1 116.67 119.86 115.93 118.77 119 118.01",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.55,117.31c.34.63,1.47.78,2.42.91l.63.07a1.17,1.17,0,0,0,.28-.32c.34-.61-.28-.68-1.65-.85a10.19,10.19,0,0,1-1.38-.24c.14-.33.08-.71-1-.66Z",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.69 110.66 126.44 111.75 125.74 112.98 125 111.88 125.69 110.66",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.23,114.48a2,2,0,0,1,1.64-.81c1.19-.09,1.31.48,1.16.91l.13.2a2.65,2.65,0,0,0-1.93.48C121.44,115.16,120.91,115,121.23,114.48Z",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,113.3a.73.73,0,0,0,.34.28,2.25,2.25,0,0,1-.05.22l.74,1.09a1.31,1.31,0,0,0-.1-1.16h0l-.74-1.09S126.73,112.94,127,113.3Z",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.23,117.12c1.37.17,2,.24,1.65.85a1.17,1.17,0,0,1-.28.32c.92.13,1.31.27,1,.77a2,2,0,0,1-1.67.78c-1,.08-1.37-.22-1.21-.74l-3.07.76a.28.28,0,0,1,0,.09,1.48,1.48,0,0,0-.45,0l.59.88a.41.41,0,0,0,0,.09h0a1.52,1.52,0,0,0,.75.51,4.52,4.52,0,0,0,1.24.2v0l-1.42.11.74,1.09h0l1-.07,1.31-.11h0l.7-1.22a6.25,6.25,0,0,0,4.54-2.73c.37-.66.39-1.12.2-1.44h0v0l-.06-.08-.63-.9a.74.74,0,0,0-.17.42,5.93,5.93,0,0,0-.94-.21c-1.28-.18-2.54-.13-2.1-.91a1.1,1.1,0,0,1,.26-.31c-.79-.1-1.32-.24-1-.78a2,2,0,0,1,1.64-.81c1.19-.09,1.31.48,1.16.91h0l.13.2.61.9,3.21-.79-.74-1.09a1.69,1.69,0,0,0,.08-.52,3.94,3.94,0,0,0-1.58-.3l.28-.5-1.84-.56-.69,1.23a6.62,6.62,0,0,0-4.73,2.8,2.12,2.12,0,0,0-.3.79A6.54,6.54,0,0,0,120.23,117.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.23,117.12c1.37.17,2,.24,1.65.85a1.17,1.17,0,0,1-.28.32c.92.13,1.31.27,1,.77a2,2,0,0,1-1.67.78c-1,.08-1.37-.22-1.21-.74l-3.07.76a.28.28,0,0,1,0,.09,1.48,1.48,0,0,0-.45,0l.59.88a.41.41,0,0,0,0,.09h0a1.52,1.52,0,0,0,.75.51,4.52,4.52,0,0,0,1.24.2v0l-1.42.11.74,1.09h0l1-.07,1.31-.11h0l.7-1.22a6.25,6.25,0,0,0,4.54-2.73c.37-.66.39-1.12.2-1.44h0v0l-.06-.08-.63-.9a.74.74,0,0,0-.17.42,5.93,5.93,0,0,0-.94-.21c-1.28-.18-2.54-.13-2.1-.91a1.1,1.1,0,0,1,.26-.31c-.79-.1-1.32-.24-1-.78a2,2,0,0,1,1.64-.81c1.19-.09,1.31.48,1.16.91h0l.13.2.61.9,3.21-.79-.74-1.09a1.69,1.69,0,0,0,.08-.52,3.94,3.94,0,0,0-1.58-.3l.28-.5-1.84-.56-.69,1.23a6.62,6.62,0,0,0-4.73,2.8,2.12,2.12,0,0,0-.3.79A6.54,6.54,0,0,0,120.23,117.12Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M121.13,121.44a8.47,8.47,0,0,0,3.23-1.38,4.64,4.64,0,0,0,1.18-1.24,2.78,2.78,0,0,0,.36-.76,1,1,0,0,0,0-.79,1,1,0,0,1,.11.81,3,3,0,0,1-.34.79,4.6,4.6,0,0,1-1.19,1.3,6.69,6.69,0,0,1-1.58.85A8.82,8.82,0,0,1,121.13,121.44Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M118.46,116.74a6.54,6.54,0,0,0,1.77.38c1.37.17,2,.24,1.65.85a1.17,1.17,0,0,1-.28.32,2.52,2.52,0,0,1-1.39.46c-1,.08-1.38-.22-1.21-.74l-3.07.76a1.22,1.22,0,0,0,.71,1.45,3.76,3.76,0,0,0,1.47.3l-.69,1.23,1.42-.11.85-.07.69-1.23a6.19,6.19,0,0,0,4.54-2.72,2.32,2.32,0,0,0,.32-.85c.11-.92-.83-1.22-1.92-1.38-.38-.06-.76-.09-1.09-.13-.79-.1-1.32-.24-1-.78a2,2,0,0,1,1.64-.81c1.19-.09,1.31.48,1.16.91l3.21-.78a1.69,1.69,0,0,0,.08-.52c0-.65-.42-1-1.06-1.22a5.31,5.31,0,0,0-1.26-.18l.69-1.22-2.24.16-.7,1.24a6.62,6.62,0,0,0-4.73,2.79C117.41,115.92,117.77,116.45,118.46,116.74Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.46,116.74a6.54,6.54,0,0,0,1.77.38c1.37.17,2,.24,1.65.85a1.17,1.17,0,0,1-.28.32,2.52,2.52,0,0,1-1.39.46c-1,.08-1.38-.22-1.21-.74l-3.07.76a1.22,1.22,0,0,0,.71,1.45,3.76,3.76,0,0,0,1.47.3l-.69,1.23,1.42-.11.85-.07.69-1.23a6.19,6.19,0,0,0,4.54-2.72,2.32,2.32,0,0,0,.32-.85c.11-.92-.83-1.22-1.92-1.38-.38-.06-.76-.09-1.09-.13-.79-.1-1.32-.24-1-.78a2,2,0,0,1,1.64-.81c1.19-.09,1.31.48,1.16.91l3.21-.78a1.69,1.69,0,0,0,.08-.52c0-.65-.42-1-1.06-1.22a5.31,5.31,0,0,0-1.26-.18l.69-1.22-2.24.16-.7,1.24a6.62,6.62,0,0,0-4.73,2.79C117.41,115.92,117.77,116.45,118.46,116.74Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.38 120.34 121.13 121.44 120.43 122.66 119.69 121.57 120.38 120.34",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.38 120.34 121.13 121.44 120.43 122.66 119.69 121.57 120.38 120.34",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.75,112.06l-.24,0-.28.06-.35.1-.41.12-.23.08-.23.08-.23.1-.24.1c-.16.08-.32.15-.47.24s-.31.18-.46.27a4.43,4.43,0,0,0-.42.29c-.13.1-.25.21-.36.31l-.16.15-.07.08-.07.07-.23.27-.16.22-.12.2.12-.2a1.76,1.76,0,0,1,.15-.23c.06-.09.14-.18.22-.28l.07-.07.07-.08.15-.16c.12-.1.23-.21.37-.31a4.33,4.33,0,0,1,.41-.3c.15-.09.3-.19.46-.27s.32-.17.48-.24l.24-.1.24-.1.23-.08.23-.07.41-.12a3.47,3.47,0,0,1,.36-.08l.28-.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "119.69 121.57 117.42 121.75 118.11 120.52 117.65 121.6 119.69 121.57",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125 111.88 125.51 110.78 123.45 110.82 125.69 110.66 125 111.88",
    style: {
      fill: "#fafafa"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-104"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M382.46,66.25l-1.86,1.36,2.81,3.79h0a6.14,6.14,0,0,0,1.18,1.21c.15.12.32.23.49.34a8.2,8.2,0,0,0,2.82,1.11,10.05,10.05,0,0,0,1.14.18c.4,0,.81.06,1.24.07s1.09,0,1.67-.07,1.23-.14,1.85-.26c.47-.08.94-.19,1.42-.31,7-1.76,14.58-7,19.14-13.12.31-.42.6-.84.88-1.27.41-.61.78-1.23,1.12-1.86s.52-1,.74-1.51.35-.84.5-1.26.27-.81.37-1.21h0a11,11,0,0,0,.39-3.31c0-.22,0-.43-.06-.64a6.57,6.57,0,0,0-.8-2.5,4.66,4.66,0,0,0-.43-.66h0l-2.65-3.58L412.73,44c-.25,0-.5-.09-.76-.12a14.56,14.56,0,0,0-3.18,0c-.67.06-1.35.16-2,.29a23,23,0,0,0-2.68.69,37.32,37.32,0,0,0-16.69,11.45,25.79,25.79,0,0,0-1.76,2.36,22.38,22.38,0,0,0-1.23,2,19.32,19.32,0,0,0-1.34,3.05A12.68,12.68,0,0,0,382.46,66.25Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.05,59.66a12.44,12.44,0,0,0-.66,3.31,7.49,7.49,0,0,0,.81,4,6,6,0,0,0,1.64,1.92c.15.12.32.23.49.35a8.31,8.31,0,0,0,2.82,1.1,9.71,9.71,0,0,0,1.14.18c.4,0,.81.06,1.24.07a16.1,16.1,0,0,0,1.67-.07,17.14,17.14,0,0,0,1.85-.26c.47-.08.94-.19,1.42-.31,7-1.75,14.58-7,19.14-13.12.31-.42.6-.84.88-1.27a21.05,21.05,0,0,0,1.11-1.85c.28-.52.53-1,.74-1.51s.36-.85.51-1.27.27-.81.37-1.21h0a11,11,0,0,0,.39-3.31c0-.22,0-.43-.06-.64a6.62,6.62,0,0,0-.8-2.5,6.31,6.31,0,0,0-2.83-2.61,9.44,9.44,0,0,0-2.95-.84,14.55,14.55,0,0,0-3.18,0c-.67.06-1.35.16-2,.29a23,23,0,0,0-2.68.69,37.32,37.32,0,0,0-16.69,11.45,25.79,25.79,0,0,0-1.76,2.36,22.38,22.38,0,0,0-1.23,2A19.32,19.32,0,0,0,380.05,59.66Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.52,56.19c3.3-6.07,10.94-11.46,17.39-12.39.28,0,.55-.08.82-.1,6.61-.57,9.19,4.1,5.74,10.42S397.88,66,391.27,66.61c-.27,0-.54,0-.79,0C384.45,66.8,382.22,62.25,385.52,56.19Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.06,56.14c.1-.2.21-.39.33-.59C389.7,50,396.71,45.16,402.67,44.3l.16,0,.62-.07a9.34,9.34,0,0,1,3.3.24,4.65,4.65,0,0,1,3.64,4.38,9.25,9.25,0,0,1-1,4.4c-.14.31-.3.62-.47.94s-.32.58-.5.86a20.9,20.9,0,0,1-1.24,1.77,26.43,26.43,0,0,1-12.76,8.75,16.43,16.43,0,0,1-2,.44c-.31.05-.61.08-.92.11l-.75,0h-.21a7,7,0,0,1-4-1c-1.68-1.12-2.37-3.11-1.86-5.6A12,12,0,0,1,386.06,56.14Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.06,56.14c.1-.2.21-.39.33-.59C389.7,50,396.71,45.16,402.67,44.3l.16,0,.62-.07a9.34,9.34,0,0,1,3.3.24,4.65,4.65,0,0,1,3.64,4.38,9.25,9.25,0,0,1-1,4.4c-.14.31-.3.62-.47.94s-.32.58-.5.86a20.9,20.9,0,0,1-1.24,1.77,26.43,26.43,0,0,1-12.76,8.75,16.43,16.43,0,0,1-2,.44c-.31.05-.61.08-.92.11l-.75,0h-.21a7,7,0,0,1-4-1c-1.68-1.12-2.37-3.11-1.86-5.6A12,12,0,0,1,386.06,56.14Z",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.43,57c-.12.19-.23.39-.33.58a12.18,12.18,0,0,0-1.3,3.4,6.09,6.09,0,0,0,.29,3.77,4.17,4.17,0,0,0,.53.41,7,7,0,0,0,4,1h.21l.75,0c.31,0,.61-.06.92-.11a16.43,16.43,0,0,0,2-.44A26.43,26.43,0,0,0,407.2,56.8,20.9,20.9,0,0,0,408.44,55c.18-.28.34-.57.5-.86s.33-.63.47-.94a9.25,9.25,0,0,0,1-4.4A5.07,5.07,0,0,0,410,47a5.31,5.31,0,0,0-2.16-1.14,9.56,9.56,0,0,0-3.3-.25l-.62.07-.16,0C397.75,46.58,390.74,51.41,387.43,57Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.33,69.24c5.05,2.82,11.64.56,16.56-1.9,7.32-4,13.94-10.09,16.26-17.65v0a8.68,8.68,0,0,0-.39-6.44,8.66,8.66,0,0,1,.54,6.48h0C413.54,56,408.61,61.25,403,65.14,397.29,68.9,388.87,72.85,382.33,69.24Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--money-sign--inject-104"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "393.2 57.6 394.39 59.35 389.49 60.56 388.31 58.82 393.2 57.6",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.5,56.48c.54,1,2.34,1.25,3.86,1.45l1,.12a1.59,1.59,0,0,0,.46-.52c.55-1-.46-1.09-2.65-1.35a15.66,15.66,0,0,1-2.19-.39c.22-.52.12-1.13-1.67-1.06Z",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "403.92 45.84 405.11 47.59 404 49.55 402.81 47.8 403.92 45.84",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.77,52a3.19,3.19,0,0,1,2.64-1.29c1.89-.15,2.08.76,1.85,1.46l.2.31a3.45,3.45,0,0,0-.87,0,3.78,3.78,0,0,0-2.21.79C397.12,53,396.27,52.82,396.77,52Z",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.93,50.07a1.11,1.11,0,0,0,.55.44c0,.11-.05.23-.09.35l1.19,1.75a2.06,2.06,0,0,0-.17-1.86h0L406.23,49S405.58,49.5,405.93,50.07Z",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.17,56.18c2.19.26,3.2.39,2.65,1.35a1.59,1.59,0,0,1-.46.52c1.49.21,2.1.43,1.65,1.23a3.2,3.2,0,0,1-2.67,1.25c-1.61.12-2.21-.35-1.95-1.18l-4.9,1.21s0,.1,0,.14a3,3,0,0,0-.72-.05l.94,1.42.09.13v0h0A2.46,2.46,0,0,0,391,63a6.7,6.7,0,0,0,2,.33l0,0-2.28.18,1.19,1.74h0l1.54-.13L395.5,65h0l1.11-2c3.27-.57,5.95-2,7.26-4.36.6-1,.64-1.79.34-2.31h0l0,0a.51.51,0,0,0-.09-.13l-1-1.44a1.17,1.17,0,0,0-.27.67,9.07,9.07,0,0,0-1.51-.34c-2.05-.29-4.07-.2-3.36-1.45a1.83,1.83,0,0,1,.42-.5c-1.26-.16-2.11-.38-1.61-1.25a3.19,3.19,0,0,1,2.64-1.29c1.89-.15,2.08.76,1.85,1.46h0l.2.31,1,1.44,5.14-1.26-1.19-1.75a3.35,3.35,0,0,0,.14-.83,6.76,6.76,0,0,0-2.54-.48l.45-.8-2.94-.88-1.1,2c-3.32.59-6.24,2.11-7.58,4.47a3.78,3.78,0,0,0-.47,1.27A11.09,11.09,0,0,0,395.17,56.18Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.17,56.18c2.19.26,3.2.39,2.65,1.35a1.59,1.59,0,0,1-.46.52c1.49.21,2.1.43,1.65,1.23a3.2,3.2,0,0,1-2.67,1.25c-1.61.12-2.21-.35-1.95-1.18l-4.9,1.21s0,.1,0,.14a3,3,0,0,0-.72-.05l.94,1.42.09.13v0h0A2.46,2.46,0,0,0,391,63a6.7,6.7,0,0,0,2,.33l0,0-2.28.18,1.19,1.74h0l1.54-.13L395.5,65h0l1.11-2c3.27-.57,5.95-2,7.26-4.36.6-1,.64-1.79.34-2.31h0l0,0a.51.51,0,0,0-.09-.13l-1-1.44a1.17,1.17,0,0,0-.27.67,9.07,9.07,0,0,0-1.51-.34c-2.05-.29-4.07-.2-3.36-1.45a1.83,1.83,0,0,1,.42-.5c-1.26-.16-2.11-.38-1.61-1.25a3.19,3.19,0,0,1,2.64-1.29c1.89-.15,2.08.76,1.85,1.46h0l.2.31,1,1.44,5.14-1.26-1.19-1.75a3.35,3.35,0,0,0,.14-.83,6.76,6.76,0,0,0-2.54-.48l.45-.8-2.94-.88-1.1,2c-3.32.59-6.24,2.11-7.58,4.47a3.78,3.78,0,0,0-.47,1.27A11.09,11.09,0,0,0,395.17,56.18Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M396.61,63.08a13.64,13.64,0,0,0,5.18-2.19,7.77,7.77,0,0,0,1.88-2,4.68,4.68,0,0,0,.59-1.21,1.69,1.69,0,0,0-.05-1.27,1.65,1.65,0,0,1,.16,1.29,4.91,4.91,0,0,1-.54,1.27,7.55,7.55,0,0,1-1.9,2.09,10.49,10.49,0,0,1-2.54,1.35A12.67,12.67,0,0,1,396.61,63.08Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M392.35,55.57a11.09,11.09,0,0,0,2.82.61c2.19.26,3.2.39,2.65,1.35a1.59,1.59,0,0,1-.46.52,3.92,3.92,0,0,1-2.21.73c-1.61.12-2.2-.35-1.95-1.18l-4.89,1.22a1.92,1.92,0,0,0,1.13,2.31,6.16,6.16,0,0,0,2.35.49l-1.11,2L393,63.4l1.35-.11,1.11-2c3.28-.57,6-2,7.27-4.36a3.9,3.9,0,0,0,.5-1.35c.19-1.48-1.33-2-3.06-2.22-.61-.08-1.22-.14-1.75-.2-1.26-.16-2.11-.38-1.61-1.25a3.19,3.19,0,0,1,2.64-1.29c1.89-.15,2.08.76,1.85,1.46l5.13-1.26a3.35,3.35,0,0,0,.14-.83,2,2,0,0,0-1.71-1.94,7.66,7.66,0,0,0-2-.29l1.11-2-3.6.27-1.11,2c-3.32.59-6.24,2.11-7.57,4.47C390.68,54.25,391.25,55.1,392.35,55.57Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.35,55.57a11.09,11.09,0,0,0,2.82.61c2.19.26,3.2.39,2.65,1.35a1.59,1.59,0,0,1-.46.52,3.92,3.92,0,0,1-2.21.73c-1.61.12-2.2-.35-1.95-1.18l-4.89,1.22a1.92,1.92,0,0,0,1.13,2.31,6.16,6.16,0,0,0,2.35.49l-1.11,2L393,63.4l1.35-.11,1.11-2c3.28-.57,6-2,7.27-4.36a3.9,3.9,0,0,0,.5-1.35c.19-1.48-1.33-2-3.06-2.22-.61-.08-1.22-.14-1.75-.2-1.26-.16-2.11-.38-1.61-1.25a3.19,3.19,0,0,1,2.64-1.29c1.89-.15,2.08.76,1.85,1.46l5.13-1.26a3.35,3.35,0,0,0,.14-.83,2,2,0,0,0-1.71-1.94,7.66,7.66,0,0,0-2-.29l1.11-2-3.6.27-1.11,2c-3.32.59-6.24,2.11-7.57,4.47C390.68,54.25,391.25,55.1,392.35,55.57Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "395.42 61.33 396.61 63.08 395.5 65.04 394.31 63.29 395.42 61.33",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "395.42 61.33 396.61 63.08 395.5 65.04 394.31 63.29 395.42 61.33",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.21,48.08l-.39.08-.43.1-.57.15c-.2.06-.43.12-.66.2l-.36.12-.37.14-.37.15-.39.17c-.25.12-.51.24-.75.38a7.38,7.38,0,0,0-.73.43,8,8,0,0,0-.67.47c-.21.16-.4.33-.58.49l-.25.24-.12.12-.1.12c-.14.16-.27.3-.37.44s-.2.25-.26.35l-.2.32.19-.33c.06-.1.15-.22.25-.36a4,4,0,0,1,.35-.45l.1-.12.12-.12.25-.25a7.48,7.48,0,0,1,.58-.5c.2-.17.43-.32.66-.48s.48-.31.74-.44.51-.26.76-.38L396,49a3,3,0,0,1,.38-.15l.37-.14.36-.11c.24-.08.46-.13.67-.19a5.58,5.58,0,0,1,.57-.13l.44-.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394.31 63.29 390.68 63.58 391.79 61.62 391.05 63.34 394.31 63.29",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "402.81 47.8 403.63 46.03 400.32 46.11 403.92 45.84 402.81 47.8",
    style: {
      fill: "#fafafa"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-104"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M452.72,69.55l-.85.62,1.29,1.73h0a2.6,2.6,0,0,0,.54.56l.22.16a3.74,3.74,0,0,0,1.29.5,4.34,4.34,0,0,0,.52.08,5.17,5.17,0,0,0,.57,0,4.93,4.93,0,0,0,.76,0c.28,0,.56-.06.85-.11l.65-.15a16.75,16.75,0,0,0,8.75-6c.14-.19.28-.38.41-.58s.35-.56.51-.85.23-.46.33-.69a5.23,5.23,0,0,0,.23-.57,4.43,4.43,0,0,0,.17-.56h0a4.86,4.86,0,0,0,.18-1.51c0-.1,0-.2,0-.3a3.25,3.25,0,0,0-.37-1.14,1.57,1.57,0,0,0-.2-.3h0l-1.21-1.64-.77.57-.35-.06a7,7,0,0,0-1.45,0c-.31,0-.62.07-.94.13a11.58,11.58,0,0,0-1.22.32A17.06,17.06,0,0,0,455,65c-.29.36-.56.72-.8,1.08a9.18,9.18,0,0,0-.56.93,8,8,0,0,0-.62,1.4A6.66,6.66,0,0,0,452.72,69.55Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.62,66.53a5.59,5.59,0,0,0-.3,1.52,3.39,3.39,0,0,0,.37,1.83,2.73,2.73,0,0,0,.75.88l.22.15a3.71,3.71,0,0,0,1.29.51,4.34,4.34,0,0,0,.52.08,5.3,5.3,0,0,0,.57,0,5.1,5.1,0,0,0,.77,0,8.41,8.41,0,0,0,.84-.11c.22,0,.43-.09.65-.15a16.75,16.75,0,0,0,8.75-6c.15-.19.28-.38.41-.58s.35-.56.51-.85.24-.46.34-.69.16-.39.23-.58.12-.37.17-.55h0a4.83,4.83,0,0,0,.17-1.51c0-.1,0-.2,0-.3a3.06,3.06,0,0,0-.37-1.14,2.82,2.82,0,0,0-1.29-1.19,4.45,4.45,0,0,0-1.35-.39,7.07,7.07,0,0,0-1.46,0,8,8,0,0,0-.93.13,12.31,12.31,0,0,0-1.23.31,17.19,17.19,0,0,0-7.63,5.24q-.44.52-.81,1.08c-.2.31-.39.62-.56.93A9.07,9.07,0,0,0,451.62,66.53Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.12,65a12.07,12.07,0,0,1,8-5.67l.37,0c3-.26,4.2,1.87,2.63,4.76a11.9,11.9,0,0,1-8.33,5.71l-.36,0C453.63,69.8,452.61,67.72,454.12,65Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.37,64.93l.15-.27A11.6,11.6,0,0,1,462,59.51H462l.28,0a4.25,4.25,0,0,1,1.51.11,2.12,2.12,0,0,1,1.67,2,4.4,4.4,0,0,1-.45,2c-.07.14-.14.28-.22.42a3.18,3.18,0,0,1-.23.4c-.17.27-.36.54-.56.81a12.06,12.06,0,0,1-5.84,4,7.69,7.69,0,0,1-.9.2l-.42,0-.35,0h-.09a3.23,3.23,0,0,1-1.81-.46,2.33,2.33,0,0,1-.86-2.56A5.6,5.6,0,0,1,454.37,64.93Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.37,64.93l.15-.27A11.6,11.6,0,0,1,462,59.51H462l.28,0a4.25,4.25,0,0,1,1.51.11,2.12,2.12,0,0,1,1.67,2,4.4,4.4,0,0,1-.45,2c-.07.14-.14.28-.22.42a3.18,3.18,0,0,1-.23.4c-.17.27-.36.54-.56.81a12.06,12.06,0,0,1-5.84,4,7.69,7.69,0,0,1-.9.2l-.42,0-.35,0h-.09a3.23,3.23,0,0,1-1.81-.46,2.33,2.33,0,0,1-.86-2.56A5.6,5.6,0,0,1,454.37,64.93Z",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455,65.31a2.26,2.26,0,0,0-.16.26,5.67,5.67,0,0,0-.59,1.55,2.74,2.74,0,0,0,.14,1.73,1.55,1.55,0,0,0,.24.19,3.23,3.23,0,0,0,1.81.46h.09l.35,0,.42,0a7.69,7.69,0,0,0,.9-.2,12.06,12.06,0,0,0,5.84-4c.2-.27.39-.54.56-.81a3.18,3.18,0,0,0,.23-.4c.08-.14.15-.28.22-.42a4.4,4.4,0,0,0,.45-2,2.26,2.26,0,0,0-.21-.83,2.36,2.36,0,0,0-1-.52,4.27,4.27,0,0,0-1.51-.11,1.33,1.33,0,0,0-.28,0h-.08A11.53,11.53,0,0,0,455,65.31Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.66,70.91c2.31,1.3,5.33.26,7.58-.86,3.35-1.81,6.37-4.62,7.43-8.07h0a3.93,3.93,0,0,0-.18-2.94,4,4,0,0,1,.25,3h0c-.8,2.86-3.06,5.26-5.61,7S455.66,72.57,452.66,70.91Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--money-sign--inject-104"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "457.64 65.59 458.18 66.39 455.94 66.95 455.4 66.15 457.64 65.59",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.31,65.08c.25.46,1.07.57,1.77.66l.46.06a.79.79,0,0,0,.21-.24c.25-.44-.21-.5-1.21-.62a8.51,8.51,0,0,1-1-.17c.11-.24.06-.52-.76-.49Z",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "462.54 60.21 463.08 61.01 462.57 61.91 462.03 61.11 462.54 60.21",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.27,63a1.44,1.44,0,0,1,1.2-.59c.87-.07,1,.35.85.67l.09.14a1.61,1.61,0,0,0-.39,0,1.73,1.73,0,0,0-1,.36C459.43,63.51,459,63.41,459.27,63Z",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.46,62.15a.51.51,0,0,0,.25.2l0,.16.54.8a1,1,0,0,0-.07-.85h0l-.55-.8S463.3,61.89,463.46,62.15Z",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.54,64.94c1,.12,1.46.18,1.21.62a.79.79,0,0,1-.21.24c.68.09,1,.19.75.56a1.43,1.43,0,0,1-1.22.57c-.74.06-1-.16-.89-.54l-2.24.56a.13.13,0,0,0,0,.06,1.07,1.07,0,0,0-.33,0l.43.65,0,.06h0a1.11,1.11,0,0,0,.54.37,3.59,3.59,0,0,0,.91.15v0l-1,.08.55.8h0l.7-.06,1-.07h0l.51-.9a4.56,4.56,0,0,0,3.32-2c.27-.49.29-.82.15-1.06h0l0-.06-.46-.66a.51.51,0,0,0-.12.31,4.37,4.37,0,0,0-.69-.16c-.94-.13-1.86-.09-1.54-.66a1.06,1.06,0,0,1,.19-.23c-.57-.07-1-.17-.73-.57a1.44,1.44,0,0,1,1.2-.59c.87-.07,1,.35.85.67h0l.09.14.45.66,2.35-.58-.54-.8a1.36,1.36,0,0,0,.06-.38,3.07,3.07,0,0,0-1.16-.22l.21-.36-1.35-.41-.5.9a4.85,4.85,0,0,0-3.47,2,1.76,1.76,0,0,0-.21.59A5.08,5.08,0,0,0,458.54,64.94Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.54,64.94c1,.12,1.46.18,1.21.62a.79.79,0,0,1-.21.24c.68.09,1,.19.75.56a1.43,1.43,0,0,1-1.22.57c-.74.06-1-.16-.89-.54l-2.24.56a.13.13,0,0,0,0,.06,1.07,1.07,0,0,0-.33,0l.43.65,0,.06h0a1.11,1.11,0,0,0,.54.37,3.59,3.59,0,0,0,.91.15v0l-1,.08.55.8h0l.7-.06,1-.07h0l.51-.9a4.56,4.56,0,0,0,3.32-2c.27-.49.29-.82.15-1.06h0l0-.06-.46-.66a.51.51,0,0,0-.12.31,4.37,4.37,0,0,0-.69-.16c-.94-.13-1.86-.09-1.54-.66a1.06,1.06,0,0,1,.19-.23c-.57-.07-1-.17-.73-.57a1.44,1.44,0,0,1,1.2-.59c.87-.07,1,.35.85.67h0l.09.14.45.66,2.35-.58-.54-.8a1.36,1.36,0,0,0,.06-.38,3.07,3.07,0,0,0-1.16-.22l.21-.36-1.35-.41-.5.9a4.85,4.85,0,0,0-3.47,2,1.76,1.76,0,0,0-.21.59A5.08,5.08,0,0,0,458.54,64.94Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M459.2,68.1a6.2,6.2,0,0,0,2.36-1,3.57,3.57,0,0,0,.86-.92,2,2,0,0,0,.27-.55.78.78,0,0,0,0-.58.75.75,0,0,1,.07.59,2.45,2.45,0,0,1-.24.58,3.43,3.43,0,0,1-.87,1,4.8,4.8,0,0,1-1.16.62A5.61,5.61,0,0,1,459.2,68.1Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M457.25,64.67a5.08,5.08,0,0,0,1.29.27c1,.12,1.46.18,1.21.62a.79.79,0,0,1-.21.24,1.77,1.77,0,0,1-1,.33c-.74.06-1-.16-.89-.54l-2.24.56a.88.88,0,0,0,.51,1.06,2.81,2.81,0,0,0,1.08.22l-.51.9,1-.08.62,0,.51-.9a4.54,4.54,0,0,0,3.32-2,1.65,1.65,0,0,0,.23-.62c.09-.68-.6-.9-1.4-1l-.8-.09c-.57-.07-1-.17-.73-.57a1.44,1.44,0,0,1,1.2-.59c.87-.07,1,.35.85.67l2.35-.58a1.36,1.36,0,0,0,.06-.38c0-.47-.31-.74-.78-.89a3.64,3.64,0,0,0-.92-.13l.51-.9-1.65.13-.51.9a4.85,4.85,0,0,0-3.46,2C456.48,64.06,456.74,64.45,457.25,64.67Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.25,64.67a5.08,5.08,0,0,0,1.29.27c1,.12,1.46.18,1.21.62a.79.79,0,0,1-.21.24,1.77,1.77,0,0,1-1,.33c-.74.06-1-.16-.89-.54l-2.24.56a.88.88,0,0,0,.51,1.06,2.81,2.81,0,0,0,1.08.22l-.51.9,1-.08.62,0,.51-.9a4.54,4.54,0,0,0,3.32-2,1.65,1.65,0,0,0,.23-.62c.09-.68-.6-.9-1.4-1l-.8-.09c-.57-.07-1-.17-.73-.57a1.44,1.44,0,0,1,1.2-.59c.87-.07,1,.35.85.67l2.35-.58a1.36,1.36,0,0,0,.06-.38c0-.47-.31-.74-.78-.89a3.64,3.64,0,0,0-.92-.13l.51-.9-1.65.13-.51.9a4.85,4.85,0,0,0-3.46,2C456.48,64.06,456.74,64.45,457.25,64.67Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "458.65 67.3 459.19 68.1 458.69 69 458.14 68.2 458.65 67.3",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "458.65 67.3 459.19 68.1 458.69 69 458.14 68.2 458.65 67.3",
    style: {
      opacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.38,61.24l-.17,0-.2,0-.26.07-.3.09-.17.06-.17.06-.17.07-.17.08-.35.17a2.63,2.63,0,0,0-.33.2l-.31.21a1.94,1.94,0,0,0-.26.23l-.12.11,0,0-.05.06c-.06.07-.12.13-.17.2l-.12.16-.09.14.09-.15.11-.16a2.35,2.35,0,0,1,.16-.21l.05,0,.05-.06.12-.11a1.94,1.94,0,0,1,.26-.23l.31-.22.33-.2a3.7,3.7,0,0,1,.35-.17l.18-.08.17-.07.17-.06.17,0,.3-.09.26-.06.21,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "458.14 68.2 456.48 68.33 456.99 67.43 456.65 68.22 458.14 68.2",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "462.03 61.11 462.4 60.3 460.89 60.34 462.54 60.21 462.03 61.11",
    style: {
      fill: "#fafafa"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-104"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--Shadow--inject-104",
    cx: 251.99,
    cy: 352.24,
    rx: 87.23,
    ry: 50.36,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-104",
    d: "M464.3,371.2c20.61-11.89,20.61-31.18,0-43.08s-54-11.9-74.62,0-20.6,31.18,0,43.08S443.7,383.1,464.3,371.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-104",
    d: "M481.19,439.4c11.08-6.4,11.08-16.78,0-23.18s-29.06-6.4-40.15,0S430,433,441,439.4,470.1,445.8,481.19,439.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-104",
    d: "M433.87,456.61c11.09-6.41,11.09-16.78,0-23.18s-29.06-6.41-40.15,0-11.08,16.78,0,23.18S422.79,463,433.87,456.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-104",
    d: "M111.25,371.2c20.61-11.89,20.61-31.18,0-43.08s-54-11.9-74.62,0-20.6,31.18,0,43.08S90.65,383.1,111.25,371.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-104",
    d: "M63.56,443.27c11.09-6.4,11.09-16.78,0-23.18s-29.07-6.4-40.15,0-11.09,16.78,0,23.18S52.47,449.67,63.56,443.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-104",
    d: "M110.62,461.26c11.09-6.4,11.09-16.78,0-23.18s-29.06-6.4-40.15,0-11.08,16.77,0,23.18S99.54,467.66,110.62,461.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-104",
    d: "M279.51,471.3a4.33,4.33,0,0,1-4.2-3.48l-.71-3.74a46.82,46.82,0,0,1-4.77-1.19l-7.28,3.37a4.88,4.88,0,0,1-2.06.44,5,5,0,0,1-2.49-.64l-7.45-4.3a3.7,3.7,0,0,1-.32-6.3l3.91-2.81c-.19-.27-.36-.54-.53-.81l-9.1-.58a4.14,4.14,0,0,1-3.88-4.13v-5.54a4.15,4.15,0,0,1,3.88-4.14l9.1-.57c.17-.28.34-.55.53-.82l-3.91-2.81a3.73,3.73,0,0,1-1.6-3.23,3.77,3.77,0,0,1,1.92-3.07l7.45-4.3a5.12,5.12,0,0,1,2.49-.64,5,5,0,0,1,2.06.44l7.28,3.37a46.81,46.81,0,0,1,4.77-1.18l.71-3.75a4.34,4.34,0,0,1,4.2-3.48h10.95a4.33,4.33,0,0,1,4.2,3.48l.71,3.75a45.54,45.54,0,0,1,4.77,1.18l7.29-3.37a5,5,0,0,1,2.05-.44,5.09,5.09,0,0,1,2.49.64l7.46,4.3a3.7,3.7,0,0,1,.31,6.3l-3.91,2.81c.19.27.37.54.53.82l9.1.57a4.16,4.16,0,0,1,3.89,4.14v5.54a4.15,4.15,0,0,1-3.88,4.13l-9.11.58c-.16.27-.34.54-.53.81l3.91,2.81a3.69,3.69,0,0,1-.32,6.3l-7.44,4.3a5,5,0,0,1-2.5.64h0a4.8,4.8,0,0,1-2.05-.44l-7.29-3.37a45.54,45.54,0,0,1-4.77,1.19l-.71,3.74a4.33,4.33,0,0,1-4.2,3.48ZM285,437.23a22.72,22.72,0,0,0-11,2.59c-2.31,1.33-3.64,3-3.64,4.54s1.33,3.2,3.64,4.54a24.76,24.76,0,0,0,22,0c2.31-1.33,3.64-3,3.64-4.53s-1.33-3.21-3.64-4.54A22.68,22.68,0,0,0,285,437.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-104",
    d: "M207.89,447.84a4,4,0,0,1-.49,0l-6.9-.72a4.57,4.57,0,0,1-4.06-5.09l.13-1.07c-.58-.21-1.15-.44-1.71-.68,0,0,0,0,0,0h-.08l-5.24,1.64a5.17,5.17,0,0,1-1.58.24,5.86,5.86,0,0,1-3.69-1.28l-3.52-2.93a4.09,4.09,0,0,1,.8-6.92l1.19-.6-3.23-.55a4.4,4.4,0,0,1-3.48-5.7l.95-3.05a5.09,5.09,0,0,1,4.75-3.48l5.86.23-.75-.8a4.12,4.12,0,0,1,1.5-6.77l5.51-2.21a5.55,5.55,0,0,1,2.06-.38,5.91,5.91,0,0,1,3.21.92L202.7,411h0c1-.18,2.09-.31,3.14-.41l1.07-2.08a5.3,5.3,0,0,1,4.62-2.79,4.1,4.1,0,0,1,.5,0l6.89.72a4.49,4.49,0,0,1,3.1,1.7,4.56,4.56,0,0,1,1,3.39l-.13,1.07c.58.21,1.15.44,1.7.68,0,0,0,0,0,0h.08l5.23-1.64a5.23,5.23,0,0,1,1.59-.24,5.83,5.83,0,0,1,3.68,1.28l3.52,2.93a4.08,4.08,0,0,1-.8,6.92l-1.19.6,3.24.55a4.4,4.4,0,0,1,3.48,5.7l-1,3.05a5.08,5.08,0,0,1-4.74,3.48l-5.86-.24.75.81a4.13,4.13,0,0,1-1.5,6.77l-5.52,2.21a5.5,5.5,0,0,1-2,.38,5.86,5.86,0,0,1-3.21-.92l-3.58-2.37h0c-1,.17-2.07.31-3.14.41l-1.06,2.08A5.31,5.31,0,0,1,207.89,447.84Zm1.83-25.3a17,17,0,0,0-6.25,1.11c-2.42,1-3.43,2.21-3.55,3s.66,1.53,1.13,1.92c1.85,1.54,5.18,2.49,8.69,2.49a16.8,16.8,0,0,0,6.25-1.12c2.42-1,3.42-2.2,3.54-3s-.65-1.53-1.12-1.92C216.56,423.49,213.23,422.54,209.72,422.54Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lines--inject-104"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--lines--inject-104"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M406.72,419.22H93.8l.21-.6,45.93-127.46h219.7l.11.29Zm-311.65-.9H405.44L359,292.05H140.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.72,
    y: 207.85,
    width: 0.89,
    height: 294.68,
    transform: "translate(-165.13 448.33) rotate(-64.44)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.96,
    y: 354.74,
    width: 293.84,
    height: 0.89,
    transform: "translate(-131.36 133.16) rotate(-25.64)",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Music--inject-104"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Game--inject-104"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333,180.79a3.25,3.25,0,0,1,3.26.32l.36.21,60.45,34.91a5.66,5.66,0,0,1,.74.5c.12.1.23.21.34.32a8.16,8.16,0,0,1,2.57,5.5v86.92a2.55,2.55,0,0,1-1.07,2.35l-3.5,2a2.57,2.57,0,0,1-2.58-.26l-61.78-35.67a8.09,8.09,0,0,1-3.65-6.33V185.75a3.26,3.26,0,0,1,1.35-3Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.21,313v.3l.35.2a2.55,2.55,0,0,0,2.57.26c.2-.11,3.31-1.86,3.5-2a2.55,2.55,0,0,0,1.06-2.36V222.55a7.6,7.6,0,0,0-1.25-3.9l-3.72,2.1a7.36,7.36,0,0,1,1.22,3.77v86.92a2.83,2.83,0,0,1-.5,1.76,1.54,1.54,0,0,1-1.25.58,3.06,3.06,0,0,1-1.51-.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.74,312.88a1.52,1.52,0,0,0,1.24-.58,2.76,2.76,0,0,0,.49-1.73V224.84A7.84,7.84,0,0,0,394,219.6l-.11-.1a2.09,2.09,0,0,1-.22-.2,5.71,5.71,0,0,0-.7-.47l-59.62-34.42-.36-.21a3.88,3.88,0,0,0-1.89-.58c-1.41,0-2.28,1.14-2.28,3v84.61a7.67,7.67,0,0,0,3.48,6l60.93,35.18A3,3,0,0,0,394.74,312.88Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.51,290.87l-.54-.11a1.68,1.68,0,0,1-.5-.2l-61.79-35.68a2.81,2.81,0,0,1-.77-.67l-.09-.12v-66.7l.14-.13a1.06,1.06,0,0,1,.74-.25,2.43,2.43,0,0,1,1.14.34l60.81,35.12.28.18.23.21a2.18,2.18,0,0,1,.26.29l.09.12Zm-62.38-36.76,61.48,35.5v-66a.17.17,0,0,0-.06-.06l-.19-.18-.16-.1-60.81-35.11a1.52,1.52,0,0,0-.68-.23v65.87a1.68,1.68,0,0,0,.42.34Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--musical-note--inject-104",
    d: "M351.68,217.07l0,22.08a6.59,6.59,0,0,0-1.45-1.19c-2.4-1.39-4.34.08-4.34,3.27s1.95,6.91,4.34,8.29,4.34-.09,4.34-3.28l0-19.78,14.95,3.42h0v19.62a6.59,6.59,0,0,0-1.45-1.19c-2.39-1.39-4.34.08-4.33,3.27s1.94,6.91,4.33,8.29,4.34-.09,4.34-3.28h0V223.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.76,284.76l-24.51-14.15a2.46,2.46,0,0,1-1-1.95h0c0-.75.46-1.09,1-.77L356.76,282a2.45,2.45,0,0,1,1,1.95h0C357.78,284.74,357.32,285.08,356.76,284.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.41,295.66l-54.16-31.27a2.43,2.43,0,0,1-1-1.94h0c0-.75.46-1.1,1-.77L386.41,293a2.43,2.43,0,0,1,1,1.94h0C387.43,295.64,387,296,386.41,295.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.69,183a3.72,3.72,0,0,1,1.79.55l.36.21,60.45,34.91a4.07,4.07,0,0,1,.68.46l.21.18.11.11a7.64,7.64,0,0,1,2.39,5.12v86.92c0,1.3-.55,2.08-1.49,2.08a2.82,2.82,0,0,1-1.37-.43L332,277.42a7.61,7.61,0,0,1-3.39-5.88V185.75c0-1.74.77-2.77,2.05-2.77h0m0-.52c-1.52,0-2.57,1.21-2.57,3.29v85.79a8.09,8.09,0,0,0,3.65,6.33l61.78,35.67a3.34,3.34,0,0,0,1.64.5c1.19,0,2-1,2-2.6V224.52a8.14,8.14,0,0,0-2.56-5.5l-.34-.32a5.15,5.15,0,0,0-.75-.5l-60.44-34.91-.37-.21a4.17,4.17,0,0,0-2.05-.62Z",
    style: {
      fill: "#ebebeb"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--game--inject-104"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--music--inject-104"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.16,180.79a3.24,3.24,0,0,0-3.25.32l-.37.21L103.1,216.23a5.15,5.15,0,0,0-.75.5l-.34.32a8.14,8.14,0,0,0-2.56,5.5v86.92a2.54,2.54,0,0,0,1.06,2.35l3.5,2a2.57,2.57,0,0,0,2.58-.26l61.78-35.67a8.09,8.09,0,0,0,3.65-6.33V185.75a3.26,3.26,0,0,0-1.35-3Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.93,313v.3l-.35.2a2.55,2.55,0,0,1-2.57.26l-3.5-2a2.55,2.55,0,0,1-1.06-2.36V222.55a7.52,7.52,0,0,1,1.26-3.9l3.71,2.1a7.36,7.36,0,0,0-1.22,3.77v86.92a2.83,2.83,0,0,0,.5,1.76,1.56,1.56,0,0,0,1.25.58,3.06,3.06,0,0,0,1.51-.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.4,312.88a1.54,1.54,0,0,1-1.24-.58,2.76,2.76,0,0,1-.49-1.73V224.84a7.84,7.84,0,0,1,2.44-5.24l.11-.1.23-.2a5,5,0,0,1,.69-.47l59.62-34.42.36-.21a3.88,3.88,0,0,1,1.89-.58c1.41,0,2.28,1.14,2.28,3v84.61a7.68,7.68,0,0,1-3.47,6l-60.94,35.18A3,3,0,0,1,105.4,312.88Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.6,291.29l-24.5,14.15c-.56.32-1,0-1-.77h0a2.46,2.46,0,0,1,1-1.95l24.5-14.14c.57-.33,1,0,1,.77h0A2.4,2.4,0,0,1,131.6,291.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.26,268,107.1,299.22c-.56.33-1,0-1-.77h0a2.43,2.43,0,0,1,1-1.94l54.16-31.27c.56-.32,1,0,1,.77h0A2.46,2.46,0,0,1,161.26,268Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.63,290.87v-67.6l.09-.12a3.15,3.15,0,0,1,.25-.28l.2-.19a2.43,2.43,0,0,1,.32-.21l60.81-35.12a2.43,2.43,0,0,1,1.14-.34,1.06,1.06,0,0,1,.74.25l.14.13v66.7l-.09.12a2.66,2.66,0,0,1-.77.67l-61.79,35.68a1.59,1.59,0,0,1-.5.2Zm.9-67.29v66L168,254.11a1.68,1.68,0,0,0,.42-.34V187.9a1.52,1.52,0,0,0-.68.23l-60.81,35.11-.2.13-.16.15Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.2,223.54l-.21-.7c-2-6.68-3.61-12-9.68-10.27-3.58,1-5.8,3.82-7.94,6.53-1.58,2-3.05,3.87-5,5a7.05,7.05,0,0,1-4.93.77c-2.17-.24-4.41-.5-8,2.64-5.93,5.19-7.5,12.22-9.49,21.14l-.22.94c-1.76,7.89-1.78,13.28,0,15.18a2.32,2.32,0,0,0,1.75.76,3.25,3.25,0,0,0,.44,0c2.89-.4,5.66-4.95,8.33-9.35l.76-1.25a47.73,47.73,0,0,1,8.34-10.41,2,2,0,0,0,3.14,1.07,7.78,7.78,0,0,0,3.17-4.77,12.15,12.15,0,0,1,8.41.73l.75.37c2.71,1.33,5.51,2.71,8.42-.24C161.8,238,162.54,231.24,160.2,223.54ZM139.52,240.1a.62.62,0,0,1,0,.13c0,.1,0,.21,0,.32s0,.16,0,.24-.05.22-.09.33-.05.16-.07.24l-.12.31a2.72,2.72,0,0,1-.11.25l-.14.28-.14.25c-.06.09-.1.17-.16.25l-.19.24a1.57,1.57,0,0,1-.15.19,2,2,0,0,1-.25.25,1.59,1.59,0,0,1-.13.13,2.78,2.78,0,0,1-.41.29c-1.13.66-2.06-.05-2.06-1.56a4.55,4.55,0,0,1,0-.53l0-.2c0-.11.05-.22.07-.34s0-.15.07-.23l.09-.28.09-.26s0,0,0-.06a0,0,0,0,0,0,0,4.5,4.5,0,0,1,1.65-2.08c1.14-.66,2.07,0,2.07,1.56C139.54,239.94,139.52,240,139.52,240.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.45,183h0c1.28,0,2.05,1,2.05,2.77v85.79a7.61,7.61,0,0,1-3.39,5.88l-61.78,35.67a2.89,2.89,0,0,1-1.38.43c-.93,0-1.49-.78-1.49-2.08V224.52a7.64,7.64,0,0,1,2.39-5.12l.12-.11.2-.18a4.07,4.07,0,0,1,.68-.46l60.45-34.91.36-.21a3.72,3.72,0,0,1,1.79-.55m0-.52a4.2,4.2,0,0,0-2,.62l-.36.21L106.59,218.2a5.75,5.75,0,0,0-.75.5l-.34.32a8.14,8.14,0,0,0-2.56,5.5v86.92c0,1.65.82,2.6,2,2.6a3.34,3.34,0,0,0,1.64-.5l61.78-35.67a8.09,8.09,0,0,0,3.65-6.33V185.75c0-2.08-1.05-3.29-2.57-3.29Z",
    style: {
      fill: "#ebebeb"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-104"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-104"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-104"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M464.23,331c-.79-10.86.44-19.19-.47-36.16h0c-.08-4.34-.24-9-.53-13.14-1-13.93-3.13-18.69-3.33-21.38,0,0-.36-21.66-1.27-52.13-.43-14.33-4.58-18.68-7.9-26.28H411.28c-4.41,18.77-5.66,59.71-5.53,79.06.06,9.86,4.05,62.63,4.13,63.85.28,4.3-.1,6-1.78,7.81-3.54,3.79-8.66,7.4-13.09,10.71.64,1.7,6,1.63,8.6.34a66.84,66.84,0,0,0,9.83-6.26c3.64-2.7,8.29-4.86,8.35-9a3.26,3.26,0,0,1,.13-.73c.06-2.39,5.64-37.69,6.11-45.88.4-7.05-.46-19-.46-19L432.12,233s2.8,17.63,5.63,29.67c2.31,9.8,6.11,26.52,8.71,38.59h0c2.49,13.89,6.15,23.78,6.79,30.74.19,1.66,2.07,18,2.85,21.69s8.91,3.83,9.43-2.59C465.88,346.85,464.38,333.05,464.23,331Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.12,233l-3.33-21.52s-12.84-1.53-17.51-6c0,0,5.89,8.31,14.6,9.67L429.55,233l-1.94,29.61Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.47,347.67a3.54,3.54,0,0,0,.62,3.55c1.4,1.23,5.52,3.27,11,2.62s8.47-2.31,10.68-4.12,5.31-4.36,7.79-4.88a15.11,15.11,0,0,0,5.56-2.2c.75-.71.68-3.87.68-3.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422,326.57s.41,0,.55.75.31,3.41.66,4.85a25.56,25.56,0,0,1,.45,7.69c-.32,1.61-4.08,2.7-6.49,3.59a30.32,30.32,0,0,0-7.82,4.82,22.65,22.65,0,0,1-11.6,4.18c-5.45,0-9-1.5-10-3.47-1.32-2.44-.25-3.83,6-6.66,1.19-.54,5.38-3,6.81-3.84a32,32,0,0,0,4.3-3.12,26.18,26.18,0,0,0,1.93-1.87,8.84,8.84,0,0,0,1.61-2c.07-.17.12-.36.19-.53a9.35,9.35,0,0,0,.42-1.46c.11-.52.18-1.28.68-1.59a4.25,4.25,0,0,1,2.24-.24,16.31,16.31,0,0,1,2.41.37c.92.22,2,.31,2.52,1.18a4.57,4.57,0,0,1,.49,2.27c0,.37,0,.74,0,1.1,0,.16-.07.44.15.38s.45-.61.53-.79c.18-.41.29-.85.49-1.25a6.71,6.71,0,0,1,.79-1.31,5.91,5.91,0,0,1,1-1,9,9,0,0,0,1.08-.69A2.49,2.49,0,0,0,422,326.57Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.78,342.78c7.88.63,10.31,5.53,10.62,8.55a18.89,18.89,0,0,1-5.62,1.12c-5.45,0-9.19-1.5-10.25-3.47C386.28,346.68,387.16,344.85,392.78,342.78Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.6,343a.38.38,0,0,0,.25-.08.39.39,0,0,0,.06-.54,9.27,9.27,0,0,0-7.1-2.89.38.38,0,0,0-.35.42.38.38,0,0,0,.42.34,8.61,8.61,0,0,1,6.43,2.61A.37.37,0,0,0,404.6,343Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408,341.05a.4.4,0,0,0,.25-.09.39.39,0,0,0,.06-.54,9.29,9.29,0,0,0-7.11-2.89.38.38,0,0,0-.34.42.38.38,0,0,0,.42.35,8.6,8.6,0,0,1,6.43,2.6A.35.35,0,0,0,408,341.05Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.19,338.82a.44.44,0,0,0,.25-.08.38.38,0,0,0,.06-.54,9.25,9.25,0,0,0-7.1-2.89.38.38,0,0,0-.35.42.38.38,0,0,0,.42.34,8.61,8.61,0,0,1,6.43,2.61A.37.37,0,0,0,411.19,338.82Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.3,336.59a.35.35,0,0,0,.24-.08.38.38,0,0,0,.07-.54c-1.49-1.92-4.89-3.22-7.76-2.93a.38.38,0,0,0,.08.76c2.58-.25,5.75.94,7.07,2.64A.38.38,0,0,0,414.3,336.59Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.54,356.62c.22,3.72.8,6.19,2.12,8.37s3.81,2.87,6.33,2.23,5.75-2.35,6.48-5.56a20.41,20.41,0,0,0,.57-8.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.15,329.68c1,.08,1.34,5.07,1.94,10.08.64,5.36,2.24,7.58,2.82,12,.65,5-.18,7.27-1.94,10.31s-8,6-11.06,1.66c-2.5-3.54-2.61-7.47-2.38-12.49a111.15,111.15,0,0,0-.33-12.71c-.2-3.76-1-7.55-.13-8,.07.55.13,1.25.21,1.79a9.08,9.08,0,0,0,.33,2c.11.28.34.57.43.12a2.7,2.7,0,0,0,0-.94c-.15-1.38.55-1.5.93-1.6a45.47,45.47,0,0,1,4.82-.69c.79-.05,3.53-.17,3.89.28A3.2,3.2,0,0,1,464,333c.09.76.26,1.31.28,1.08a22.81,22.81,0,0,0-.07-2.29c0-.33-.06-.77-.07-1.1S464.17,330,464.15,329.68Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.2,354.64a12.54,12.54,0,0,1-1.95,7.64c-1.76,3-8.49,6-11.56,1.67-1.53-2.16-1.94-4.72-2.15-7.33C455.38,353.27,466.29,351.79,469.2,354.64Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.81,351.16l.13,0a17.62,17.62,0,0,1,9.53-.92.39.39,0,0,0,.46-.29.38.38,0,0,0-.29-.46,18,18,0,0,0-10,1,.38.38,0,0,0-.18.51A.4.4,0,0,0,455.81,351.16Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.24,346.45a.37.37,0,0,0,.32-.26.39.39,0,0,0-.24-.49c-4.66-1.57-9.83.79-10,.9a.38.38,0,0,0-.16.52.4.4,0,0,0,.52.16s5.08-2.32,9.41-.84A.49.49,0,0,0,465.24,346.45Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.07,342.92a.38.38,0,0,0,.1-.74c-5.13-1.84-10,.75-10.22.86a.39.39,0,0,0,.4.66s4.78-2.5,9.55-.8A.35.35,0,0,0,465.07,342.92Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.82,339.45a.39.39,0,0,0,.32-.25.38.38,0,0,0-.22-.5c-4.81-1.79-10.09.86-10.29,1a.39.39,0,0,0-.14.53.38.38,0,0,0,.53.14s5.17-2.59,9.62-.91A.55.55,0,0,0,464.82,339.45Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.78,182c4.68,8.53,8.14,15.49,8.62,40.83s.39,32.44.49,35.5,1.88,8.51,3.44,23.56-.28,33-.28,33-1.08,2.42-6.84,2.94c-5.31.47-7.94-1.52-7.94-1.52S442,287,440,278s-7.86-38.88-7.86-38.88l-3.48,24.18s1.62,8.3,0,21.5-4.47,26.72-4.47,26.72a23.93,23.93,0,0,1-8.15,1.33,13.67,13.67,0,0,1-7.16-1.87s-4.51-39.27-4.51-54.23,1.26-52.36,6-74.51Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.12,239.08l-4.74-28.77s-10-.71-15.57-6.53c2.26,6.18,10.47,10.5,14.07,11.37l4.24,23.61-1.48,24.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.17,186.25a35.67,35.67,0,0,1,3.25,6.87,66.06,66.06,0,0,1,2.16,7.28,75.81,75.81,0,0,1,1.37,7.46,47.83,47.83,0,0,1,.5,7.57c-.6-2.46-1.16-4.91-1.72-7.35s-1.11-4.88-1.7-7.31-1.17-4.86-1.79-7.28S442.93,188.67,442.17,186.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.48,187.17A26.53,26.53,0,0,1,448.9,191a34.91,34.91,0,0,1,2.78,4.32,32,32,0,0,1,2.11,4.7,19.7,19.7,0,0,1,1.16,5l-2.3-4.53c-.78-1.48-1.55-3-2.37-4.43s-1.62-2.93-2.42-4.41S446.23,188.72,445.48,187.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440,217.44c1.09,7.84,2.07,15.7,3.06,23.54s2,15.68,3.48,23.43,3,15.55,4.34,23.33,2.7,15.61,3.9,23.43Q452,299.6,449.64,288c-1.63-7.75-3.16-15.48-4.68-23.28s-2.39-15.69-3.15-23.58S440.46,225.34,440,217.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.81,217.44l-1.29,20.64c-.19,3.43-.41,6.87-.57,10.31s-.36,6.88-.3,10.27.28,6.86.45,10.3l.52,10.32q.53,10.32.82,20.67-1.21-10.27-2.06-20.59c-.57-6.88-1.09-13.73-1.33-20.67,0-7,.62-13.83,1.23-20.71S410.75,224.26,411.81,217.44Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-104"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Hair--inject-104",
    d: "M441,131.58c3.32-4.78,5.32-5.88,7.29-10s4-8.29,3.08-12.71c-.36-1.69-.44-2.82-1.92-4.38a6.08,6.08,0,0,0-2-1.67c-.06,0-.39-1.49-.47-1.67a8.16,8.16,0,0,0-1-1.67,13,13,0,0,0-3.47-2.91,21.39,21.39,0,0,0-10.53-2.87,20,20,0,0,0-8.62,1.77c-1.45.66-3.09,1-4.59,1.55a15.79,15.79,0,0,0-4.43,2.51,6.16,6.16,0,0,0-1.76,2.17,3.16,3.16,0,0,0,0,2.72c.64,1.15,2.17,1.81,2.28,3.12a3.83,3.83,0,0,1-.56,1.88,2.27,2.27,0,0,0-.18,1.91,2.5,2.5,0,0,0,1,.88,2,2,0,0,1,.76-2.36A1.62,1.62,0,0,0,418,112c1.22-.45,1.88.89,2.38,2.09a13,13,0,0,1,.6,3.84,25.1,25.1,0,0,0,.75,3.92,7,7,0,0,0,.82,2.11c1.09,1.68,3.31,2.21,5,3q3,1.32,6.12,2.54c1.64.64,3.28,1.27,5,1.78C439.22,131.4,440.34,131.91,441,131.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.76,81.92a3.06,3.06,0,0,1,1.64-.14,13.83,13.83,0,0,0,1.87.47c1.46.08,2.58-1.29,4-1.64A4,4,0,0,1,448,81c1.43.73,3.15,2,3.4,3.71a10.92,10.92,0,0,0,.22,2,2.11,2.11,0,0,0,1.92,1.38c.43,0,.85-.12,1.29-.13a2.28,2.28,0,0,1,2.2,2.12,1.75,1.75,0,0,0-2.79.2,2.91,2.91,0,0,1,3.15,3.37,6.55,6.55,0,0,0-.33,1.41,2.16,2.16,0,0,0,1.14,1.65c.6.37,1.27.59,1.87,1a4.25,4.25,0,0,1,.71,6.66,2,2,0,0,0-1.23-2.58c.64,1.2.71,2.92-.4,3.7-.81.57-2.17.62-2.39,1.59a3.19,3.19,0,0,0,.16,1.25,2.61,2.61,0,0,1-2,2.93c-.66.12-1.34,0-2,.13a9.37,9.37,0,0,0-2.15,1.21,4.37,4.37,0,0,1-5.2-.86c-.93-1-1.36-2.5-2.5-3.29s-2.54-.68-3.79-1.11a4.84,4.84,0,0,1-2.7-2.31c-.31-.59-.5-1.23-.8-1.82a5.28,5.28,0,0,0-5-2.79c-.83.06-1.64.33-2.48.33a4,4,0,0,1-1.71-7.63,2.9,2.9,0,0,0-2.71,1.07,2.62,2.62,0,0,1,1.23-2.76,6.35,6.35,0,0,1,3.1-.79,2.29,2.29,0,0,1-1.28-2.91,3.46,3.46,0,0,1,2.69-2.07c1.21-.23,2.73-.12,3.33-1.19.35-.62.41-1.32.81-2a3.89,3.89,0,0,1,.74-.93c.11-.1.86-.46.88-.54-.13.48,0,1.63.64,1.81s1-.61,1.51-.83A1,1,0,0,1,437.76,81.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-104"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M421.5,138.16c-8.36,1.44-9.6,2.64-14.07,7.66-5.56,6.25-6.86,7.72-15,16l-25.38-8.08v13.62s17.85,8.47,23.82,10.48c4.46,1.51,7-.56,10.51-3.8,5.37-5,16.25-15.19,16.25-15.19Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tablet--inject-104"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.36,136h0l1.43-.7h0a1.37,1.37,0,0,1,1.24.19L395,154a4.86,4.86,0,0,1,2.15,3.41l2.17,28.73a1.24,1.24,0,0,1-.52,1.3h0l-1.48.72v0a1.37,1.37,0,0,1-1.25-.17l-32-18.55a4.81,4.81,0,0,1-2.14-3.41c-.43-5.65-1.75-23.08-2.17-28.73C359.71,136.57,360,136.11,360.36,136Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.73,155.79a4.73,4.73,0,0,1,1,2.32l2.18,28.72a1.31,1.31,0,0,1-.48,1.29l1.39-.68h0a1.22,1.22,0,0,0,.53-1.3l-2.17-28.73a4.68,4.68,0,0,0-.87-2.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.86,186.83l-2.17-28.72a4.86,4.86,0,0,0-2.15-3.42l-32-18.54c-1.09-.63-1.9-.13-1.8,1.13.42,5.65,1.74,23.08,2.17,28.73a4.81,4.81,0,0,0,2.14,3.41l32,18.55C397.15,188.6,398,188.09,397.86,186.83Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.22,163.62l-.41-5.38a.94.94,0,0,0-.4-.64l-2.2-1.27c-.21-.11-.36,0-.34.22.08,1,.32,4.32.4,5.37a.9.9,0,0,0,.41.64l2.2,1.27C394.08,164,394.23,163.86,394.22,163.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.38,159.39a2.3,2.3,0,0,0-1-1.59c-.53-.3-.92-.08-.88.49a2.31,2.31,0,0,0,1,1.59C393,160.18,393.42,160,393.38,159.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.56,162.1a2.27,2.27,0,0,0-1-1.59c-.53-.31-.92-.09-.87.48a2.25,2.25,0,0,0,1,1.59C393.21,162.88,393.6,162.67,393.56,162.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.67,153.9c-.86-1.87-.71-2.06.09-2.78a5.28,5.28,0,0,1,4.61-1.35,10.77,10.77,0,0,1,3.57,1.1c.67.53-.26,2-2.22,2-3.09.1-3.23.91-3.23.91a37.55,37.55,0,0,1,4,.06,28.1,28.1,0,0,1,4.21,1.49c1.22.43,1.15,2.09-1.07,2.24l2.22.81c1.55.56,1.93,1.52.49,2.27a2.38,2.38,0,0,1-1.56.26s1.71.33,1.64.9c-.22,1.65-1.35,1.88-5,2.22-3.47.32-4.49,2-4.07,3.31,0,0-1.18-1-2.2-2.07-.75-.76-1.36-1.57-.71-2.84,0,0-1.88-.33-1.78-1.51a6.14,6.14,0,0,1,.93-2.41,2.08,2.08,0,0,1-.66-2.12,3.39,3.39,0,0,1,1.07-1.91Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.59,157.6a11.13,11.13,0,0,0-2-.62,6.76,6.76,0,0,0-2.14.25,25.73,25.73,0,0,0-4,1.25,25.74,25.74,0,0,0,4.13-.64,10.6,10.6,0,0,1,2-.38C367.17,157.48,367.89,157.6,368.59,157.6Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.74,160.94a4.74,4.74,0,0,0-2.24-.49,12.34,12.34,0,0,0-2.27.26,21.33,21.33,0,0,0-4.31,1.35c1.51-.15,3-.45,4.44-.74A12,12,0,0,1,369.74,160.94Z",
    style: {
      fill: "#9a4a4d"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    id: "freepik--Chest--inject-104",
    d: "M456,187.39c-.71-2.93-1.9-7.95-2.13-9.66-1.33-9.92.43-15,1.08-19.3,1.41-9.45-1.3-17.38-3.5-19.24,0,0-2.5-.62-4.6-1-1.66-.29-2.94-.49-5.14-1-5.46-1.33-11.43,0-13.51.19a22,22,0,0,0-4.26.3c-1.47.35-4.89.93-4.9.94a31,31,0,0,0-6.5,8.36c-2.4,4.28-3.46,8-3.88,16.44-.59,11.68-.87,17-1.28,23.77C417.08,193.12,443.52,194.68,456,187.39Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-104"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M441.7,134.8c0-1.55.3-9.32.3-9.32.06.58,2.86,2.18,5.41-.79s2.75-6.15,1.25-8.19c-1.65-2.26-5.36-2.17-6.88,1.48-1.12,0-2.9-.21-2.33-6,0-7-6.77-12.75-12.48-7.93-2.2-3.91-6.92-2.37-8.66,1.42-1,2.38-1.28,3.19-.82,7.7.08.75-.85,2.37-.77,5.74.19,8.36,2.13,11.3,4.84,12.54,1.62.74,3,1,6.13.81l0,2.5h0c-.07,1.3,0,1.85-1.23,2.26-.84.28-2.54.63-2.54.63s-3.68,3.43,4.35,4.58c12,1.71,18.56-4.05,18.56-4.05s-.81-.13-2.86-.52S441.7,136.35,441.7,134.8Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431,122.05l-4.35,1.35a2.24,2.24,0,0,0,2.81,1.58A2.38,2.38,0,0,0,431,122.05Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.74,123.05a2.51,2.51,0,0,0-2.52,1.93,2.2,2.2,0,0,0,1.27,0,2.35,2.35,0,0,0,1.59-1.88Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.92,110.52l3.1-1.61a1.67,1.67,0,0,0-2.3-.79A1.83,1.83,0,0,0,418.92,110.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.55,111.1l-3-1.87a1.7,1.7,0,0,1,2.39-.62A1.87,1.87,0,0,1,434.55,111.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.38,114.13a1.5,1.5,0,0,1-1.36,1.58,1.41,1.41,0,0,1-1.55-1.3,1.51,1.51,0,0,1,1.36-1.58A1.41,1.41,0,0,1,422.38,114.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.94,114.48a1.5,1.5,0,0,1-1.36,1.58,1.41,1.41,0,0,1-1.55-1.3,1.52,1.52,0,0,1,1.36-1.58A1.41,1.41,0,0,1,432.94,114.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "421.37 118.91 425.96 121.14 426.97 112.27 421.37 118.91",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.69,132.27c5.54-.51,11.07-2.37,12.34-4.88a5,5,0,0,1-2.27,4.06c-3.16,1.82-10,2.72-10,2.72Z",
    style: {
      fill: "#9a4a4d"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-104"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M424.53,159.38c-2.73-2-4.1-2.81-5.37-3.17s-5.72-2.21-7.43-2.64c-1.08-.27-1.52,1.46-.14,2.64a37.78,37.78,0,0,0,5,2.77,21.49,21.49,0,0,1,3.59,3.55Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.78,146.14c-2.7-5.75-5-6.3-11.53-7.06-6.14,6-1.16,19.4-1.16,19.4l3.29,16.15s-16.27-4.38-18.12-5.56-6.78-6.49-8.44-8.08c-2.25-2.17-3.37-1.88-4.52-1.7-3.75.56-4.57.88-5.37,1.38a1.72,1.72,0,0,0-.73,1.46c-1,.13-2.49.1-2.68,1.73a4.48,4.48,0,0,0-.06,1.32,1,1,0,0,0-.65.37c-.83,1,.6,4.28,1.5,5.1a3.25,3.25,0,0,0,2.73.48c1-.14.54-1.17.54-1.17L419,170c3.05,2.17,3.21,6.47,7.24,7.42a27.19,27.19,0,0,1,4.93.95c8.69,2.92,22.94,11.77,30.68,12.44,7.56.65,7.34-3.38,7.46-8C469.41,178.71,465.47,151.88,462.78,146.14Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.06,173l.32,1.59c3.44.88,7.16,3.36,8,5.24C460.72,176.89,459.12,174.66,453.06,173Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.2,162.13l4.46-.9-4.37.29A1.84,1.84,0,0,0,416.2,162.13Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.46,165.18l5.13-.67-5.14.07A3,3,0,0,0,413.46,165.18Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.14,167.44a1.62,1.62,0,0,0,.69.6,3.25,3.25,0,0,0,.88.29l-.07,0c.13.26.28.53.43.79l.1-.14a1.06,1.06,0,0,0-.81.2,1.32,1.32,0,0,0-.45.67,1.75,1.75,0,0,1,.52-.56,1,1,0,0,1,.7-.12l.2,0-.09-.18-.43-.8,0,0h0a5.24,5.24,0,0,1-.86-.24A1.87,1.87,0,0,1,414.14,167.44Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.5,168.1a17.29,17.29,0,0,0,1.86.13,2,2,0,0,0,.64,1,9.4,9.4,0,0,0,1,.83l-1.41-.08a2.28,2.28,0,0,0-1.62-.87Z",
    style: {
      fill: "#9a4a4d"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-104"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-104"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-104"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.12,302.75c0,10-.76,18.72.17,25.09.08.53-5.27,2.62-8.92,2s-4.63-1.91-4.63-2.29c0-1.33-1.33-3.11-1.47-4.43-.86-8.39-2.12-14.39-2.76-20.35Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.57,345.45c.25,0,.57,2.67-.8,3.78-1.59,1.28-6.21,3.34-12.24,2.48s-7.7-2.06-10.08-4.07-4.56-4.1-7.28-4.74c-2.53-.58-6.38-1.64-7.18-2.41s-.61-4.17-.61-4.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78,321.67a1.08,1.08,0,0,0-1,.79c-.21.93-.47,3.65-.9,5.17a37.31,37.31,0,0,0-.6,9.86c.3,1.74,5.53,2.91,8.15,3.93a25.13,25.13,0,0,1,7.32,4.68A18.82,18.82,0,0,0,102,350.25c4.66.05,10-1.33,11.19-3.41,1.55-2.57,1.82-5.06-5-8.28-1.3-.61-5.29-3-6.83-4A30.12,30.12,0,0,1,96.62,331a19.59,19.59,0,0,1-1.73-1.8,5.37,5.37,0,0,1-.92-1.91,23.59,23.59,0,0,1-.37-3.86.7.7,0,0,0-.12-.34.65.65,0,0,0-.3-.18,8.42,8.42,0,0,0-3.39-.23,14.5,14.5,0,0,0-3.43.69,2.83,2.83,0,0,0-1.58.95,2.34,2.34,0,0,0-.34,1.24,8,8,0,0,1-.06,1.3.81.81,0,0,1-.19.43c-.24.22-.61,0-.81-.15a18.33,18.33,0,0,1-1.82-2.2c-.32-.4-1.78-.67-2.18-1a10.75,10.75,0,0,1-1.17-.77C77.8,322.73,78,322.21,78,321.67Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.94,346.1a36.62,36.62,0,0,0-3.16-2.45h0s7.31,3,10.64.82c2.15-1.36,1.17-3.09,1.13-3.63s5.24-2.79,7.3-3h0c.56.32,1,.58,1.34.72,6.85,3.22,6.58,5.71,5,8.28-1.24,2.08-5.08,3.66-11.11,3.55A19.39,19.39,0,0,1,90.94,346.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99,339.24c4.27,1.74,2.41,2.49,1.21,2.64s-7.21-3.35-11.55-6.81c-4.53-3.62-8.47-7.42-10.15-8.75-.63-.49-1.3-1.1-1.9-1.67.13-.91.24-1.75.34-2.19.17-.78,1.13-1,1.13-1l.17,1.64a3.38,3.38,0,0,0,1.18.68,5.46,5.46,0,0,1,2.11,1.11,18.33,18.33,0,0,0,1.82,2.2C87,331.79,94.75,337.5,99,339.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.93,341.26a.42.42,0,0,1-.26-.1.4.4,0,0,1,0-.58,10.43,10.43,0,0,1,7.94-2.89.43.43,0,0,1,.37.47.41.41,0,0,1-.48.35,9.66,9.66,0,0,0-7.18,2.6A.45.45,0,0,1,99.93,341.26Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.22,339.14a.44.44,0,0,1-.27-.09.4.4,0,0,1-.06-.58,10.41,10.41,0,0,1,7.87-3.06.42.42,0,0,1,.38.45.43.43,0,0,1-.47.37A9.65,9.65,0,0,0,96.55,339,.44.44,0,0,1,96.22,339.14Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8,336.74a.44.44,0,0,1-.27-.09.41.41,0,0,1,0-.59,10.45,10.45,0,0,1,7.94-2.88.41.41,0,1,1-.11.82,9.62,9.62,0,0,0-7.18,2.6A.4.4,0,0,1,92.8,336.74Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.77,334.58a.46.46,0,0,1-.27-.09.41.41,0,0,1-.07-.58,10.44,10.44,0,0,1,7.81-3.2.41.41,0,0,1,.39.44.42.42,0,0,1-.46.38,9.67,9.67,0,0,0-7.07,2.89A.42.42,0,0,1,89.77,334.58Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.53,332a.43.43,0,0,1-.27-.08.41.41,0,0,1-.08-.58c1.63-2.08,5.38-3.5,8.55-3.23a.41.41,0,1,1-.08.82c-2.85-.24-6.34,1.07-7.79,2.91A.44.44,0,0,1,86.53,332Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.23,306.09l18.33-.84L52.14,328l-1.25,5.57c-.6,4-10.16,5.12-12.47-1.14l.07-5.46C38.42,322,38.36,313.6,38.23,306.09Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.13,355.32c-.05,4.14-.55,6.91-1.9,9.4s-4.08,3.39-6.91,2.81-6.51-2.29-7.48-5.81a22.77,22.77,0,0,1-.48-9.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.49,327c-1,.36-.93,6-1.32,11.6-.43,6-1.39,7.83-1.79,12.73-.46,5.61,0,7.46,2.14,10.73s9.18,6.25,12.35,1.26c2.59-4.07,2.43-7.81,1.91-13.36a115,115,0,0,1-.6-13.26c0-4.18,2-8.25,1-8.67a16.5,16.5,0,0,1-.53,3.17,5.49,5.49,0,0,1-.53,1.57c-.51.8-.83-.45-.85-.93,0-.83.2-1.5-.48-2.15a4.74,4.74,0,0,0-1.77-.91,10.29,10.29,0,0,0-2.13-.49,22.15,22.15,0,0,0-4.46,0,2.17,2.17,0,0,0-1.68.8,1.39,1.39,0,0,0-.14.45c-.08.55,0,1.11-.08,1.66,0,.15-.07.56-.21.65s-.38.07-.39,0S38.43,328,38.49,327Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.52,349.4c-.07.81-.38,5.86,1.11,6.75s2.28-3.26,2.28-3.26,3.62-1.31,9.09.78c-.23.87.73,3.68,2.17,3s1.65-6.17,1.65-6.25c.48,5.32.57,8.93-2,12.88-3.17,5-10.24,2-12.35-1.26s-2.6-5.12-2.14-10.73C35.42,350.76,35.45,349.91,35.52,349.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.35,353.22c.07,2-1.76,1.41-2.18-1.41-.61-4.22.25-8.33,0-13.22.39-5.58.18-11.46,1.32-11.6,0,1,.4,4.78.4,4.78-.16,4.16-1,9.07-.65,13.34C38.57,348.87,39.27,351.21,39.35,353.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.38,353.64c.28-2,.89-2.59,1.11-6.36s2-10.59,2.55-14.68c.16-1.27,1.1-4.53,1.1-4.58.74.32.17,2.68-.28,5.22s-.75,4.09-1,6.52c-.76,4.84-.66,9.94-1.18,12.74S47.09,355.64,47.38,353.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.84,353.72l-.16,0a13.59,13.59,0,0,0-8.92-.49.43.43,0,0,1-.54-.28.43.43,0,0,1,.28-.54,14.24,14.24,0,0,1,9.54.53.43.43,0,0,1-.2.82Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.81,349.66l-.15,0A18,18,0,0,0,38.24,349a.43.43,0,0,1-.52-.29.42.42,0,0,1,.29-.53,18.66,18.66,0,0,1,11,.71.43.43,0,0,1,.23.56A.44.44,0,0,1,48.81,349.66Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5,345.71a.42.42,0,0,1-.38-.27.43.43,0,0,1,.24-.56c5.08-2,12,.09,12.22.2a.43.43,0,1,1-.36.77s-6.81-2-11.54-.17Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.16,342.06a.43.43,0,0,1-.37-.26.42.42,0,0,1,.23-.56c5.58-2.31,11.57.52,11.78.63a.43.43,0,0,1-.41.75s-5.85-2.74-11-.59A.57.57,0,0,1,38.16,342.06Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3,337.64a.4.4,0,0,1-.37-.25.43.43,0,0,1,.22-.57c5.23-2.25,11.64.64,11.87.75a.43.43,0,0,1,.18.58.42.42,0,0,1-.58.18s-6.27-2.81-11.13-.72A.32.32,0,0,1,38.3,337.64Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.16,246.79,72,268.73s-.25,7.51.11,14.76,3.48,24.49,5.06,32.18a16,16,0,0,0,15.87.14s1.58-38.33,2.22-48.5-.88-51.41-1.37-67.54l-49.46.15s-1,8.67-1.85,21.63-2.9,47.69-2.9,47.69c-4.67,15.68-3,23.13-1.73,49.81,7.53,5.27,16.53.82,16.53.82S59,297.3,61.6,285.73s4.66-26.31,7.56-38.94",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.47,224.93l1.42,19.78c.09,3.16.79,10.07.85,13.23s.3,7.51.27,13-.08,21.19.17,27.53c.94-7,1-22.81,1-31.05s-.58-13.63-1.42-22.81S88.27,231.21,87.47,224.93Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.46,224.57c-1.84,12.54-4.53,34.88-5.46,42.06s-4.62,30.37-5.32,37.6c1.27-7.16,5.78-30.2,6.77-37.42S59.81,238.29,60.46,224.57Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1,224l-3.94,22.82L72,268.73l-.7-21,4.6-21.48s8.64-2.56,10.89-11.35C82.39,222,73.1,224,73.1,224Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-104"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.05,166.55c-2,1.47-4.09,3.79-7.49,6.41s-8.58,7.22-13.49,9.92-7.33,3.79-13.14-2.62a166.77,166.77,0,0,1-14.5-19.45l.82-23c5,1.69,7.84,4.48,10.81,9.37,5.61,9.2,9.42,15.14,12.67,20.45,0,0,14.45-7.9,16.33-9.16a7.6,7.6,0,0,0,3-4,35.1,35.1,0,0,1,1.56-4c.61-1.38.85-1.9,1.56-3.64s1.3-4.66,1.53-5.31c.43-.72,1.53-.63,2.41,1.2a7.16,7.16,0,0,1,.32,3.56c-.06.78-.85,2.41.49,2.45a14.23,14.23,0,0,0,5-.93c2-.71,3.78-1.47,5.78-2.18,1-.35,2.09-.85,3.1-1.16.71-.21,1.87-.79,2.59-.35s.33,1.45,0,2a5,5,0,0,1-1.48,1.37,23.83,23.83,0,0,1-3.76,2.09c-1.18.53-2.72,1.38-3.45,1.71a2.17,2.17,0,0,1,1.62.54,2.35,2.35,0,0,1,0,3,1.35,1.35,0,0,1,1.28,1.21c.15,1,0,2-1,2.38,0,0,.83.21.87.7a2.4,2.4,0,0,1-.84,2.2,7.88,7.88,0,0,1-2.9.61s-.16.36-1.13.83a25.18,25.18,0,0,1-3.26,1.65C138.09,164.89,135.64,165.38,134.05,166.55Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.73,167.64a11.23,11.23,0,0,0-5.06,7.26,8.59,8.59,0,0,1,4.44-8.28Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.26,137.71a16,16,0,0,1,7.38,4.61c2.06,2.2,5.68,8.4,7.84,11.84s4.49,7.08,4.49,7.08-.16,8.72-11.32,13L85,161.05Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.52,159.58a4.66,4.66,0,0,0,1.29-.38c.4-.12.83-.19,1.25-.28.85-.16,1.71-.3,2.56-.48a25.06,25.06,0,0,0-2.6.2,6.47,6.47,0,0,0-1.3.24,4.85,4.85,0,0,1-1.21.32,2.55,2.55,0,0,1-1.15-.33,2.89,2.89,0,0,1-1-.65,2,2,0,0,1-.22-.56.62.62,0,0,1,.13-.52,1.36,1.36,0,0,1,.76-.46,4.52,4.52,0,0,0,.9.2,4.32,4.32,0,0,0,1.46-.32c.46-.17.9-.35,1.34-.54.89-.37,1.77-.75,2.63-1.17-.92.27-1.83.58-2.73.9a9.91,9.91,0,0,1-2.69.76,3.7,3.7,0,0,1-1.31-.35,6.16,6.16,0,0,1-1.2-.72,1.15,1.15,0,0,1-.55-1.11c.13-1,1.7-.77,2.37-.84a5.39,5.39,0,0,0,1.64-.45,13.5,13.5,0,0,0,2.89-1.71,11.47,11.47,0,0,1-1.47.78c-.5.24-1,.49-1.52.68a6.6,6.6,0,0,1-1.58.37c-.8.08-1.7-.08-2.35.49a1.13,1.13,0,0,0-.3,1.16,6.68,6.68,0,0,1,.05,1.34,5.21,5.21,0,0,1-.84,2.71,6.31,6.31,0,0,1-2.57,2.35,7.15,7.15,0,0,0,2.92-1.81,6,6,0,0,0,1.49-2.38l.3.46a.81.81,0,0,0,0,.22,2.09,2.09,0,0,0,.21.67,2.68,2.68,0,0,0,1.11.81,4.77,4.77,0,0,0,.8.32.71.71,0,0,0-.13.35,1.08,1.08,0,0,0,.14.56,4.56,4.56,0,0,0,.69.86,3.68,3.68,0,0,0,.44.34,1.38,1.38,0,0,0,.53.23,4.28,4.28,0,0,0,1.07.11l-1-.39a1.52,1.52,0,0,1-.42-.23A3.07,3.07,0,0,1,142,161a7,7,0,0,1-.71-.73.88.88,0,0,1-.18-.74A1.61,1.61,0,0,0,141.52,159.58Zm-3.45-5.87h0s0,0,0,0Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chest--inject-104"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--chest--inject-104",
    d: "M60,135.06c-7.68,1.69-10,2.43-13.61,3.26,0,0-7.53,7-3.11,31.91a106,106,0,0,1,1.19,18.4c-.12,5.54-1,14-1.12,17.8,0,0,9.19,5.93,30.63,3.89,16.84-1.59,20.53-7.92,20.53-7.92V166.62c0-20.49-3.66-25.25-8.24-28.89-.59-.37-12-2.27-12-2.27Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-104"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.11,91.64c-9.12-1.41-15.88,2.11-17.3,7.8-3.46,0-5.46,2.72-6,6.13C51,117,60.1,123.16,61.45,128.82l26.47-19.77C90.84,104.09,87.08,93.34,76.11,91.64Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.38,97.49l4.52,1.86a2.59,2.59,0,0,1-3.29,1.3A2.33,2.33,0,0,1,55.38,97.49Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.28,94.67l.63,4.76a2.58,2.58,0,0,1-2.81-2.15A2.35,2.35,0,0,1,59.28,94.67Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.67,103.43a5.15,5.15,0,0,1-.61,3.13c-1,1.74-3.15,2.7-3.89,4.57-.47,1.2-.29,2.55-.56,3.81a2.66,2.66,0,0,1-.59,1.27,1.34,1.34,0,0,1-1.28.44,6,6,0,0,0-2.06-4.78,3.84,3.84,0,0,0-5.91,1.21,7.34,7.34,0,0,0,1.85,8.69,3.75,3.75,0,0,0,4.88-.11l-1.2,14.55c2.17,4.2,7.93,7.38,13.75,7.14s4.59-3.24,2.61-5.57l.45-5.05a16.46,16.46,0,0,0,4.81-.29c3.6-.87,5.47-3.63,6.54-7.36,1.31-4.54.57-9.27.44-13.29-.07-2.2.17-4.4-.37-6.56a8.43,8.43,0,0,0-4.06-5.32,4.12,4.12,0,0,1-3.65,2.49,11.9,11.9,0,0,1-4.58-.8l-4.33-1.35a4.11,4.11,0,0,0-1.55-.26,1.36,1.36,0,0,0-1.2.89,2.58,2.58,0,0,0,.27,1.42A5.55,5.55,0,0,1,68.67,103.43Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.29 110.3 79.29 119.79 84.06 118.05 78.29 110.3",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.25,121.06l4.9,1.89a2.6,2.6,0,0,1-3.37,1.54A2.68,2.68,0,0,1,74.25,121.06Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.78,124.49a2,2,0,0,0,.31.08,2.34,2.34,0,0,0-2-2.61A2.65,2.65,0,0,0,75.78,124.49Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.58,108.19l-3.43,1.58a1.92,1.92,0,0,1,.94-2.53A1.87,1.87,0,0,1,73.58,108.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.36,109.57l-3.58-1.21a1.92,1.92,0,0,1,2.42-1.19A1.87,1.87,0,0,1,86.36,109.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.27,113a1.54,1.54,0,1,0,1.54-1.54A1.53,1.53,0,0,0,71.27,113Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.78,112.34a1.54,1.54,0,1,0,1.53-1.54A1.53,1.53,0,0,0,82.78,112.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.11,132.73A31.64,31.64,0,0,1,68.53,131c-2.88-1.25-4.12-2.19-5.45-5.61a8.07,8.07,0,0,0,2,5c3.3,3.33,10.89,4,10.89,4Z",
    style: {
      fill: "#f0997a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--tablet--inject-104"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.41,170.34h0l-1.2-1.12h0A1.45,1.45,0,0,0,113,169l-37.07,8.58a5,5,0,0,0-3.14,2.71L61.92,207.94a1.29,1.29,0,0,0,.12,1.44h0l1.24,1.16v0a1.38,1.38,0,0,0,1.28.21l37.07-8.58a5,5,0,0,0,3.15-2.71c2.12-5.43,8.69-22.19,10.82-27.62C115.86,171.14,115.76,170.62,115.41,170.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.59,179.46a5,5,0,0,0-1.65,2l-10.82,27.6a1.31,1.31,0,0,0,.08,1.41L62,209.39h0a1.27,1.27,0,0,1-.12-1.44l10.82-27.62a4.72,4.72,0,0,1,1.52-1.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.12,209.07,74,181.46a5,5,0,0,1,3.14-2.72l37.07-8.58c1.26-.29,1.9.46,1.43,1.66-2.13,5.43-8.7,22.19-10.82,27.62a5,5,0,0,1-3.15,2.71l-37.07,8.58C63.29,211,62.65,210.27,63.12,209.07Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.73,187.33l2-5.17a1,1,0,0,1,.59-.51l2.55-.58c.24-.06.36.08.27.31-.4,1-1.63,4.15-2,5.17a1,1,0,0,1-.59.5l-2.55.59C73.76,187.69,73.64,187.55,73.73,187.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.83,183.42a2.31,2.31,0,0,1,1.49-1.25c.62-.14.94.19.72.74a2.36,2.36,0,0,1-1.5,1.25C75.93,184.3,75.61,184,75.83,183.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.84,186a2.31,2.31,0,0,1,1.5-1.25c.61-.14.93.19.71.74a2.36,2.36,0,0,1-1.5,1.25C74.94,186.91,74.62,186.58,74.84,186Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.86,192.77l-.58,1.48a36.69,36.69,0,0,0,6.42,1c.73,0,3.48-1.29,5.72-1.87s3.68.76,2.52,1.66a13.88,13.88,0,0,1-2,1.35c.94.94,1.59,1.82-.3,3.42a2.49,2.49,0,0,1-.81,2.78,23.43,23.43,0,0,1-6.31,4c-1.23.47-7.65.06-8.18-.23A39.14,39.14,0,0,1,59.52,203,36.68,36.68,0,0,0,53,199.4c-2-.65-19.35-7.85-22.41-9.41s-8-4.93-3.87-8.2,10.57-5.23,15.58-2c3.63,2.36,12.82,7.46,16.93,9.88a5.13,5.13,0,0,0,3.71.77,27.07,27.07,0,0,1,5.77.09Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2,138.71c-8,2.27-10.36,3.7-12,8-2.65,7-8.71,31-9,37.24-.16,3.09,14.69,3.59,14.69,3.59l2.48-7.74s5.12-17.49,6.29-21.19C49.94,154.43,51.46,142.75,46.2,138.71Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.33,179.8c-2.66-1.73-7.65-2-10.37-.81,2-2.52,7.94-2.1,10.72-.28Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80,196.43c-.91.52-1.79,1.08-2.66,1.65-.45.28-.88.58-1.31.86a1.12,1.12,0,0,1-.6.27l-.76.08c-2,.14-4.14.15-6.22.32,1,.1,2.08.16,3.12.19s2.09,0,3.14-.05c.26,0,.53-.05.79-.09a2.06,2.06,0,0,0,.45-.14,2.36,2.36,0,0,0,.35-.23c.42-.31.84-.61,1.25-.93C78.37,197.74,79.19,197.11,80,196.43Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.69,199.85c-.86.59-1.72,1.17-2.6,1.71l-1.34.8c-.22.12-.45.26-.67.37a2.53,2.53,0,0,1-.68.15c-1,.14-2.05.16-3.09.22s-2.08.07-3.12.19a34.54,34.54,0,0,0,6.27.05,3.07,3.07,0,0,0,.83-.21c.25-.12.46-.26.69-.39.44-.29.88-.57,1.3-.88A21.22,21.22,0,0,0,79.69,199.85Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2,204c-.71.29-1.4.6-2.1.85a10.87,10.87,0,0,1-2.15.52,15,15,0,0,1-2.23,0,12.47,12.47,0,0,0-2.28.14l2.26.25a8.92,8.92,0,0,0,2.31,0A9.63,9.63,0,0,0,77.2,204Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.41,138.32c-6.68,1.68-7.88,2.62-10.08,4.45s-3.09,4.92-4.66,10.65-4.48,17.34-4.48,17.34a13.81,13.81,0,0,0,7.69,4,19.59,19.59,0,0,0,9.32-.44s4.67-14.69,5.49-17.33S52.4,141.78,46.41,138.32Z",
    style: {
      fill: "#8E4DFE"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Video--inject-104"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--video--inject-104"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M439.09,283.84a4.06,4.06,0,0,0-4.08.4l-.46.26-75.74,43.74a7.62,7.62,0,0,0-.93.63l-.43.39a10.21,10.21,0,0,0-3.21,6.9V445.07a3.22,3.22,0,0,0,1.33,2.95L360,450.5a3.23,3.23,0,0,0,3.23-.33l77.41-44.69a10.13,10.13,0,0,0,4.57-7.93V290.05c0-1.84-.65-3.13-1.69-3.73Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.62,449.54v.38l-.44.25a3.21,3.21,0,0,1-3.22.33L355.57,448a3.22,3.22,0,0,1-1.33-2.95V336.16a9.52,9.52,0,0,1,1.58-4.89l4.65,2.63a9.27,9.27,0,0,0-1.53,4.73V447.54a3.53,3.53,0,0,0,.63,2.2,1.94,1.94,0,0,0,1.57.74,3.9,3.9,0,0,0,1.88-.59Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.7,449.35a1.9,1.9,0,0,1-1.55-.73,3.44,3.44,0,0,1-.62-2.17V339a9.82,9.82,0,0,1,3.06-6.57l.14-.13.28-.25a7.85,7.85,0,0,1,.87-.59l74.7-43.13.45-.26a4.87,4.87,0,0,1,2.38-.73c1.76,0,2.85,1.43,2.85,3.75v106a9.63,9.63,0,0,1-4.35,7.55l-76.35,44.08A3.84,3.84,0,0,1,361.7,449.35Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.44,376.19a2.79,2.79,0,0,0,.79-.7V292.35a.78.78,0,0,0-.54-.17,2.42,2.42,0,0,0-1.14.36l-76.2,44-.3.2-.25.22a3,3,0,0,0-.25.29v83.83a1.39,1.39,0,0,0,.46-.19Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.44,376.19a2.79,2.79,0,0,0,.79-.7V292.35a.78.78,0,0,0-.54-.17,2.42,2.42,0,0,0-1.14.36l-76.2,44-.3.2-.25.22a3,3,0,0,0-.25.29v83.83a1.39,1.39,0,0,0,.46-.19Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.26,380V351.33c0-2.32,1.77-4.92,3.37-5l25.92-.65c2-.05,2,3.74,0,6L391.63,381C390,382.83,388.26,382.28,388.26,380Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442,286.57h0c1.6,0,2.56,1.3,2.56,3.48v107.5a9.52,9.52,0,0,1-4.25,7.36l-77.41,44.7a3.6,3.6,0,0,1-1.72.54c-1.18,0-1.88-1-1.88-2.61V338.63a9.64,9.64,0,0,1,3-6.42l.15-.13.25-.23a7.13,7.13,0,0,1,.85-.58l75.75-43.74.45-.26a4.6,4.6,0,0,1,2.25-.7m0-.65a5.19,5.19,0,0,0-2.58.79l-.45.26L363.19,330.7a8.1,8.1,0,0,0-.93.64l-.44.39a10.21,10.21,0,0,0-3.21,6.9V447.54c0,2.07,1,3.26,2.53,3.26a4.15,4.15,0,0,0,2.05-.63l77.41-44.69a10.13,10.13,0,0,0,4.57-7.93V290.05c0-2.61-1.31-4.13-3.21-4.13Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.89,421.65l-30.7,17.73c-.71.4-1.28,0-1.28-1h0a3.05,3.05,0,0,1,1.28-2.44l30.7-17.73c.71-.4,1.28,0,1.28,1h0A3.05,3.05,0,0,1,394.89,421.65Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.05,392.41l-67.86,39.18c-.71.41-1.28,0-1.28-1h0a3,3,0,0,1,1.28-2.43L432.05,389c.7-.41,1.27,0,1.27,1h0A3.07,3.07,0,0,1,432.05,392.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Picture--inject-104"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Image--inject-104"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.05,283.84a4.06,4.06,0,0,1,4.08.4l.46.26,75.74,43.74a6.92,6.92,0,0,1,.93.63l.43.39a10.21,10.21,0,0,1,3.21,6.9V445.07a3.22,3.22,0,0,1-1.33,2.95l-4.39,2.48a3.21,3.21,0,0,1-3.22-.33L59.54,405.48A10.13,10.13,0,0,1,55,397.55V290.05c0-1.84.65-3.13,1.69-3.73Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.52,449.54v.38l.44.25a3.21,3.21,0,0,0,3.22.33l4.39-2.48a3.2,3.2,0,0,0,1.33-2.95V336.16a9.52,9.52,0,0,0-1.58-4.89l-4.65,2.63a9.27,9.27,0,0,1,1.53,4.73V447.54a3.53,3.53,0,0,1-.62,2.2,2,2,0,0,1-1.58.74,3.9,3.9,0,0,1-1.88-.59Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.44,449.35a1.9,1.9,0,0,0,1.55-.73,3.44,3.44,0,0,0,.62-2.17V339a9.82,9.82,0,0,0-3.06-6.57l-.14-.13-.28-.25a7.85,7.85,0,0,0-.87-.59l-74.7-43.13-.45-.26a4.87,4.87,0,0,0-2.38-.73c-1.75,0-2.85,1.43-2.85,3.75v106a9.66,9.66,0,0,0,4.35,7.55l76.35,44.08A3.84,3.84,0,0,0,138.44,449.35Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.71,376.19a2.72,2.72,0,0,1-.8-.7V292.35a.8.8,0,0,1,.54-.17,2.42,2.42,0,0,1,1.14.36l76.21,44,.29.2.25.22a3,3,0,0,1,.25.29v83.83a1.28,1.28,0,0,1-.45-.19Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.71,376.19a2.72,2.72,0,0,1-.8-.7V292.35a.8.8,0,0,1,.54-.17,2.42,2.42,0,0,1,1.14.36l76.21,44,.29.2.25.22a3,3,0,0,1,.25.29v83.83a1.28,1.28,0,0,1-.45-.19Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.21 373.08 135.46 415.95 135.46 378.32 115.16 341.28 95.76 354.36 102.48 371.69 81.63 341.71 61.21 349.49 61.21 373.08",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.05,324.21c0,4.6-2.42,6.94-5.42,5.21s-5.41-6.86-5.41-11.47,2.42-6.94,5.41-5.21S84.05,319.6,84.05,324.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.18,286.57a4.6,4.6,0,0,1,2.25.7l.45.26,75.75,43.74a7.13,7.13,0,0,1,.85.58l.25.23.15.13a9.64,9.64,0,0,1,3,6.42V447.54c0,1.63-.7,2.61-1.88,2.61a3.6,3.6,0,0,1-1.72-.54l-77.41-44.7a9.52,9.52,0,0,1-4.25-7.36V290.05c0-2.18,1-3.48,2.56-3.48h0m0-.65c-1.9,0-3.21,1.52-3.21,4.13v107.5a10.13,10.13,0,0,0,4.57,7.93L137,450.17a4.09,4.09,0,0,0,2,.63c1.5,0,2.53-1.19,2.53-3.26V338.63a10.21,10.21,0,0,0-3.21-6.9l-.43-.39a9.07,9.07,0,0,0-.93-.64L61.21,287l-.45-.26a5.19,5.19,0,0,0-2.58-.79Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.21,413.46,60.5,395.73a3.07,3.07,0,0,1-1.27-2.44h0c0-.94.57-1.37,1.27-1l30.71,17.73a3,3,0,0,1,1.28,2.43h0C92.49,413.43,91.91,413.87,91.21,413.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.37,427.12,60.5,387.94a3,3,0,0,1-1.27-2.43h0c0-.94.57-1.38,1.27-1l67.87,39.18a3.07,3.07,0,0,1,1.27,2.44h0C129.64,427.1,129.07,427.53,128.37,427.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Platform--inject-104"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--platform--inject-104"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M307.73,341.86a48.34,48.34,0,0,0-10.62-8.14c-25.17-14.53-66-14.53-91.14,0a48.34,48.34,0,0,0-10.62,8.14H187.1v9.44h0c0,9.52,6.29,19,18.87,26.31,25.17,14.53,66,14.53,91.14,0C309.69,370.34,316,360.82,316,351.3v-9.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 251.54,
    cy: 341.86,
    rx: 64.44,
    ry: 37.2,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.54,306.36c16.92,0,32.8,3.79,44.72,10.67,11.62,6.71,18,15.53,18,24.83s-6.4,18.13-18,24.84c-11.92,6.88-27.8,10.67-44.72,10.67s-32.8-3.79-44.72-10.67c-11.62-6.71-18-15.53-18-24.84s6.4-18.12,18-24.83c11.92-6.88,27.8-10.67,44.72-10.67m0-1.7c-16.49,0-33,3.63-45.57,10.9-25.16,14.53-25.16,38.08,0,52.61,12.59,7.27,29.08,10.9,45.57,10.9s33-3.63,45.57-10.9c25.16-14.53,25.16-38.08,0-52.61-12.59-7.27-29.08-10.9-45.57-10.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.09,332a40.28,40.28,0,0,0-8.8-6.75c-20.85-12-54.65-12-75.5,0A40.59,40.59,0,0,0,205,332h-6.83v7.5h0c0,7.88,5.21,15.77,15.64,21.79,20.85,12,54.65,12,75.5,0,10.43-6,15.64-13.91,15.64-21.79V332Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.29,310.19c-10.42-6-24.09-9-37.75-9s-27.33,3-37.75,9c-20.85,12.05-20.85,31.56,0,43.6,10.42,6,24.09,9,37.75,9s27.33-3,37.75-9C310.15,341.75,310.15,322.24,289.29,310.19Zm-.85,42.13c-9.82,5.68-22.93,8.8-36.9,8.8s-27.07-3.12-36.91-8.8c-9.53-5.51-14.78-12.73-14.78-20.33s5.25-14.82,14.78-20.32c9.84-5.68,22.94-8.81,36.91-8.81s27.08,3.13,36.9,8.81c9.54,5.5,14.79,12.72,14.79,20.32S298,346.81,288.44,352.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.23,332c0,7.6-5.25,14.82-14.79,20.33-9.82,5.68-22.93,8.8-36.9,8.8s-27.07-3.12-36.91-8.8c-9.53-5.51-14.78-12.73-14.78-20.33s5.25-14.82,14.78-20.32c9.84-5.68,22.94-8.81,36.91-8.81s27.08,3.13,36.9,8.81C298,317.17,303.23,324.39,303.23,332Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252,360.63c-32,.44-49.64-15.69-52-26.58h0c.83,6.93,5.82,13.74,15,19.05,20.18,11.65,52.91,11.65,73.1,0a37.14,37.14,0,0,0,9.76-7.85C297.1,346,283.15,360.2,252,360.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.62,27.6H142.36L200,334.05h0c.83,6.93,5.82,13.74,15,19.05,20.18,11.65,52.91,11.65,73.1,0,9.19-5.31,14.18-12.12,15-19.05h0Z",
    style: {
      fill: "#8E4DFE",
      opacity: 0.1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--NFT--inject-104"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--nft-coin--inject-104"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.08,171l2.78-5.81-12.17-7h0a18.9,18.9,0,0,0-4.59-1.92c-.56-.15-1.13-.27-1.71-.37a22.6,22.6,0,0,0-8.56.23,28.37,28.37,0,0,0-3.09.83,32.53,32.53,0,0,0-3.19,1.23,38.85,38.85,0,0,0-4.1,2.1,46.68,46.68,0,0,0-4.27,2.8c-1.06.77-2.1,1.59-3.13,2.47-15.11,12.75-27,35.48-30,57.33-.21,1.5-.37,3-.49,4.45-.18,2.11-.27,4.21-.26,6.28,0,1.7.07,3.34.2,4.93.11,1.37.27,2.7.47,4s.43,2.51.71,3.7h0a35.76,35.76,0,0,0,3.54,9.38c.32.58.66,1.14,1,1.68a22.62,22.62,0,0,0,5.4,5.83,18.23,18.23,0,0,0,2,1.3h0l11.5,6.64,2.55-5.31c.68-.15,1.36-.33,2-.53a37.36,37.36,0,0,0,8-3.55,49.29,49.29,0,0,0,4.71-3.13,59.49,59.49,0,0,0,5.77-4.92c12.61-12.13,22.54-31.12,26.18-50a84.24,84.24,0,0,0,1.19-8.39c.21-2.31.32-4.61.31-6.88a58.33,58.33,0,0,0-.81-9.77A42.21,42.21,0,0,0,286.08,171Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.82,210l24.69,14.26,3.25-9.4L220,200.58C218.82,203.67,217.73,206.81,216.82,210Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.69,158.21h0a18.9,18.9,0,0,0-4.59-1.92c-.56-.15-1.13-.27-1.71-.37a22.6,22.6,0,0,0-8.56.23c-.38.08-.76.18-1.13.27l25.4,14.67a.14.14,0,0,1,0-.06l2.78-5.81Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274,194.26l3.26-3.91-37-21.31c-1.17,1.16-2.33,2.39-3.45,3.67Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229,183.18,261,201.7l3.53-9.23-29.87-17.25A92.81,92.81,0,0,0,229,183.18Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.69,158.21h0a18.9,18.9,0,0,0-4.59-1.92c-.56-.15-1.13-.27-1.71-.37a22.6,22.6,0,0,0-8.56.23,28.37,28.37,0,0,0-3.09.83,32.53,32.53,0,0,0-3.19,1.23,38.85,38.85,0,0,0-4.1,2.1,46.68,46.68,0,0,0-4.27,2.8c-1.06.77-2.1,1.59-3.13,2.47C230,177.45,218.71,198,214.79,218.41l51.51,29.74a100.45,100.45,0,0,0,21.06-44.53,84.24,84.24,0,0,0,1.19-8.39c.21-2.31.32-4.61.31-6.88a58.33,58.33,0,0,0-.81-9.77,42.21,42.21,0,0,0-2-7.55l2.78-5.81Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.1,271.08l2.55-5.31c.68-.15,1.36-.33,2-.53a37.36,37.36,0,0,0,8-3.55,49.29,49.29,0,0,0,4.71-3.13,59.49,59.49,0,0,0,5.77-4.92,72.78,72.78,0,0,0,5.12-5.49l-51.51-29.74c-.29,1.5-.54,3-.75,4.5s-.37,3-.49,4.45c-.18,2.11-.27,4.21-.26,6.28,0,1.7.07,3.34.2,4.93.11,1.37.27,2.7.47,4s.43,2.51.71,3.7h0a35.76,35.76,0,0,0,3.54,9.38c.32.58.66,1.14,1,1.68a22.62,22.62,0,0,0,5.4,5.83,18.23,18.23,0,0,0,2,1.3h0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.21,255.63c.32.58.66,1.14,1,1.68a22.62,22.62,0,0,0,5.4,5.83,18.23,18.23,0,0,0,2,1.3h0l11.5,6.64,2.55-5.31.1,0,.19-2.18-25.59-14.78A34,34,0,0,0,218.21,255.63Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.07,186.09a41.17,41.17,0,0,0-2.85-9.71,25,25,0,0,0-7.47-9.87,19.08,19.08,0,0,0-6.71-3.32c-.56-.15-1.13-.27-1.7-.38a22.66,22.66,0,0,0-8.57.24,29.64,29.64,0,0,0-3.09.83,32.53,32.53,0,0,0-3.19,1.23,39.71,39.71,0,0,0-4.1,2.09,50.56,50.56,0,0,0-4.27,2.81c-1.06.77-2.1,1.59-3.13,2.46-15.11,12.75-27,35.48-30,57.34-.21,1.49-.37,3-.49,4.45-.18,2.11-.26,4.21-.25,6.28,0,1.7.07,3.34.2,4.92.11,1.38.26,2.7.46,4s.44,2.51.72,3.7h0a35.89,35.89,0,0,0,3.53,9.38c.33.58.66,1.14,1,1.68a22.58,22.58,0,0,0,5.39,5.83,19.12,19.12,0,0,0,10.64,3.81,24.87,24.87,0,0,0,8.51-1.1,37.43,37.43,0,0,0,8-3.55,48.54,48.54,0,0,0,4.7-3.13,59.58,59.58,0,0,0,5.78-4.92c12.61-12.13,22.54-31.12,26.17-50a81.61,81.61,0,0,0,1.19-8.38c.21-2.32.32-4.62.31-6.89A59.44,59.44,0,0,0,301.07,186.09Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.74,225.28c-.29,1.51-.55,3-.76,4.53s-.37,3-.49,4.45c-.18,2.11-.26,4.21-.25,6.28,0,1.7.07,3.34.2,4.92.11,1.38.26,2.7.46,4s.44,2.51.72,3.7h0a35.89,35.89,0,0,0,3.53,9.38c.33.58.66,1.14,1,1.68a22.58,22.58,0,0,0,5.39,5.83,19.12,19.12,0,0,0,10.64,3.81,24.87,24.87,0,0,0,8.51-1.1,37.43,37.43,0,0,0,8-3.55c1.41-.83,2.81-1.76,4.18-2.76Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.33,255.79a34.11,34.11,0,0,0,2.82,6.74c.33.58.66,1.14,1,1.68a22.58,22.58,0,0,0,5.39,5.83,19.09,19.09,0,0,0,8.61,3.6Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,207.49c-1.22,3.09-2.3,6.23-3.21,9.4l44.83,44.83.61-.57a76.42,76.42,0,0,0,5.49-5.94Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.63,182.12a89.21,89.21,0,0,0-5.73,8l49.34,49.35c1.61-3,3.07-6.13,4.39-9.31Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.23,175.92q-1.78,1.77-3.48,3.7l47.18,47.18c.66-1.77,1.28-3.55,1.84-5.34Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.76,192.45h0c-.05-.91-.12-1.8-.21-2.68l-.09-.88c0-.3-.07-.59-.11-.89-.09-.64-.18-1.29-.28-1.91a41.17,41.17,0,0,0-2.85-9.71,25,25,0,0,0-7.47-9.87,19.08,19.08,0,0,0-6.71-3.32c-.56-.15-1.13-.27-1.7-.38a22.66,22.66,0,0,0-8.57.24l-1.14.27Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.27,201.78c0-.66,0-1.31,0-2a38.08,38.08,0,0,0-1.38-10.64,20.16,20.16,0,0,0-5.87-9.86,14.59,14.59,0,0,0-1.89-.51,18.45,18.45,0,0,0-11.28,1.8l-.51.24c-.6.3-1.21.62-1.83,1s-1.44.86-2.14,1.35a40.36,40.36,0,0,0-4.35,3.43c-9.85,8.9-17.61,23.71-20,38.23a57.67,57.67,0,0,0-.7,6.2c0,1-.08,2-.08,2.92s0,2.07.1,3a29.77,29.77,0,0,0,3.54,13,16.86,16.86,0,0,0,3.59,4.42,14.82,14.82,0,0,0,6.95.63A23.66,23.66,0,0,0,259,252c.49-.29,1-.59,1.46-.9l.37-.24C274.59,241.66,285.55,220.58,286.27,201.78Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.27,201.78c0-.66,0-1.31,0-2a38.08,38.08,0,0,0-1.38-10.64,20.16,20.16,0,0,0-5.87-9.86,14.59,14.59,0,0,0-1.89-.51,18.45,18.45,0,0,0-11.28,1.8l-.51.24c-.6.3-1.21.62-1.83,1s-1.44.86-2.14,1.35a40.36,40.36,0,0,0-4.35,3.43c-9.85,8.9-17.61,23.71-20,38.23a57.67,57.67,0,0,0-.7,6.2c0,1-.08,2-.08,2.92s0,2.07.1,3a29.77,29.77,0,0,0,3.54,13,16.86,16.86,0,0,0,3.59,4.42,14.82,14.82,0,0,0,6.95.63A23.66,23.66,0,0,0,259,252c.49-.29,1-.59,1.46-.9l.37-.24C274.59,241.66,285.55,220.58,286.27,201.78Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.47,179.11c-.64.31-1.27.65-1.92,1C247.78,189.24,235,213.66,235,234.68s12.77,30.7,28.54,21.59c.65-.37,1.28-.77,1.92-1.19,14.88-9.91,26.64-33.19,26.64-53.36S280.35,171.83,265.47,179.11Zm-4.62,71.7-.37.24c-.48.31-1,.61-1.46.9a23.69,23.69,0,0,1-8.57,3.11,14.75,14.75,0,0,1-7-.62,17.2,17.2,0,0,1-3.58-4.42,29.63,29.63,0,0,1-3.53-13c-.08-1-.11-2-.11-3.07s0-1.93.08-2.9a60,60,0,0,1,.69-6.2c2.42-14.52,10.17-29.34,20-38.24a44,44,0,0,1,4.35-3.44c.71-.48,1.43-.93,2.15-1.34s1.23-.68,1.83-1l.51-.24a18.54,18.54,0,0,1,11.29-1.8,13,13,0,0,1,1.88.52,20.13,20.13,0,0,1,5.88,9.85,38.42,38.42,0,0,1,1.37,10.64c0,.65,0,1.31-.05,2C285.54,220.58,274.6,241.66,260.85,250.81Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.47,179.11c-.64.31-1.27.65-1.92,1C247.78,189.24,235,213.66,235,234.68s12.77,30.7,28.54,21.59c.65-.37,1.28-.77,1.92-1.19,14.88-9.91,26.64-33.19,26.64-53.36S280.35,171.83,265.47,179.11Zm-4.62,71.7-.37.24c-.48.31-1,.61-1.46.9a23.69,23.69,0,0,1-8.57,3.11,14.75,14.75,0,0,1-7-.62,17.2,17.2,0,0,1-3.58-4.42,29.63,29.63,0,0,1-3.53-13c-.08-1-.11-2-.11-3.07s0-1.93.08-2.9a60,60,0,0,1,.69-6.2c2.42-14.52,10.17-29.34,20-38.24a44,44,0,0,1,4.35-3.44c.71-.48,1.43-.93,2.15-1.34s1.23-.68,1.83-1l.51-.24a18.54,18.54,0,0,1,11.29-1.8,13,13,0,0,1,1.88.52,20.13,20.13,0,0,1,5.88,9.85,38.42,38.42,0,0,1,1.37,10.64c0,.65,0,1.31-.05,2C285.54,220.58,274.6,241.66,260.85,250.81Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.83,202.45c0,.65,0,1.31,0,2-.72,18.8-11.67,39.87-25.41,49l-.37.24c-.48.31-1,.62-1.46.9A23.89,23.89,0,0,1,255,257.7a14,14,0,0,1-11.45-3.25,14.74,14.74,0,0,0,6.93.61A23.69,23.69,0,0,0,259,252c.49-.29,1-.59,1.46-.9l.37-.24c13.75-9.15,24.69-30.23,25.41-49,0-.65.05-1.31.05-2a38.42,38.42,0,0,0-1.37-10.64,20.13,20.13,0,0,0-5.88-9.85c4.82,1.65,8.52,6,10.4,12.48A38.48,38.48,0,0,1,290.83,202.45Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.52,254.45h0a1.52,1.52,0,0,1-.22-.22A1.07,1.07,0,0,0,243.52,254.45Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.83,202.45c0,.65,0,1.31,0,2-.72,18.8-11.67,39.87-25.41,49l-.37.24c-.48.31-1,.62-1.46.9A23.89,23.89,0,0,1,255,257.7a14,14,0,0,1-11.45-3.25,14.74,14.74,0,0,0,6.93.61A23.69,23.69,0,0,0,259,252c.49-.29,1-.59,1.46-.9l.37-.24c13.75-9.15,24.69-30.23,25.41-49,0-.65.05-1.31.05-2a38.42,38.42,0,0,0-1.37-10.64,20.13,20.13,0,0,0-5.88-9.85c4.82,1.65,8.52,6,10.4,12.48A38.48,38.48,0,0,1,290.83,202.45Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "287.83 190.36 283.69 187.97 270.78 195.43 270.78 202.08 274.66 204.32 274.66 227.18 278.8 229.57 283.97 226.58 283.97 199.24 287.83 197.01 287.83 190.36",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.78 195.43 274.92 197.81 274.92 204.47 270.78 202.08 270.78 195.43",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "274.92 197.81 274.92 204.47 278.8 202.23 278.8 229.57 283.97 226.58 283.97 199.24 287.83 197.01 287.83 190.36 274.92 197.81",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "274.92 197.81 287.36 191.26 287.83 197.01 287.83 190.36 274.92 197.81",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "287.83 190.36 274.92 197.81 270.78 195.43 283.69 187.97 287.83 190.36",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "278.8 229.57 278.8 202.23 274.92 204.47 274.66 204.32 274.66 227.18 278.8 229.57",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.25 198.75 269.12 196.36 257.21 203.24 257.21 237.26 261.35 239.65 266.52 236.66 266.52 222.97 271.44 220.13 271.44 213.48 267.3 211.09 266.52 211.54 266.52 209.29 273.25 205.4 273.25 198.75",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "261.35 239.65 261.35 205.63 257.21 203.24 257.21 237.26 261.35 239.65",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.25 205.4 273.25 198.75 261.35 205.63 261.35 239.65 266.52 236.66 266.52 222.97 271.44 220.13 271.44 213.48 266.52 216.32 266.52 209.29 273.25 205.4",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "261.35 205.63 272.85 199.65 273.25 205.4 273.25 198.75 261.35 205.63",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.52,216.32l4.55-2.09s.42,6,.37,5.9,0-6.65,0-6.65Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.12 196.36 273.25 198.75 261.35 205.63 257.21 203.24 269.12 196.36",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.44 213.48 266.52 216.32 266.52 211.54 267.3 211.09 271.44 213.48",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "254.76 204.65 249.58 207.64 249.58 211.78 246 209.71 240.65 212.8 240.65 246.82 244.79 249.21 249.97 246.22 249.97 241.85 253.75 244.03 258.9 241.06 258.9 207.04 254.76 204.65",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "253.72 210.03 253.72 226.09 250.14 212.1 244.79 215.19 244.79 249.21 249.97 246.22 249.97 230.64 253.75 244.03 258.9 241.06 258.9 207.04 253.72 210.03",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "253.72 210.03 258.38 208 258.9 241.06 258.9 207.04 253.72 210.03",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "244.79 215.19 249.87 212.9 253.72 226.09 250.14 212.1 244.79 215.19",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "258.9 207.04 254.76 204.65 249.58 207.64 253.72 210.03 258.9 207.04",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.65 212.8 246 209.71 250.14 212.1 244.79 215.19 240.65 212.8",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "244.79 215.19 244.79 249.21 240.65 246.82 240.65 212.8 244.79 215.19",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "253.75 244.03 249.97 230.64 249.97 241.85 253.75 244.03",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "249.58 207.64 249.58 211.78 250.14 212.1 253.72 226.09 253.72 210.03 249.58 207.64",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.34,162.81A25.9,25.9,0,0,0,270.82,164c-11.26,3.56-20.57,13.63-27.34,22.91-12.93,19.05-21.12,43.19-16.65,66.26v-.05c1.45,6.42,4.39,12.86,9.73,16.94-5.46-4-8.62-10.43-10.16-16.89v0c-4.12-18.89,1.06-38.73,9.7-55.63,7.47-13.5,19.14-29.34,34.56-33.74A24.94,24.94,0,0,1,282.34,162.81Z",
    style: {
      fill: "#f5f5f5"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sparkles--inject-104"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M313.63,169.83a3.08,3.08,0,0,0,2.83-2.83l.53-7,.53,7a3.08,3.08,0,0,0,2.83,2.83l7,.53-7,.53a3.08,3.08,0,0,0-2.83,2.83l-.53,7-.53-7a3.08,3.08,0,0,0-2.83-2.83l-7-.53Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.6,264.49a2.75,2.75,0,0,0,2.53-2.53l.56-7.27.55,7.27a2.75,2.75,0,0,0,2.53,2.53L216,265l-7.26.55a2.75,2.75,0,0,0-2.53,2.53l-.55,7.26-.56-7.26a2.75,2.75,0,0,0-2.53-2.53l-7.26-.55Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.15 163 302.51 158.34 302.86 163 307.52 163.35 302.86 163.71 302.51 168.37 302.15 163.71 297.49 163.35 302.15 163",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.42 185.5 311.68 182.03 311.95 185.5 315.41 185.76 311.95 186.03 311.68 189.49 311.42 186.03 307.95 185.76 311.42 185.5",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "218.88 271.48 219.09 268.63 219.31 271.48 222.15 271.69 219.31 271.91 219.09 274.75 218.88 271.91 216.03 271.69 218.88 271.48",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.72 249.23 202.07 244.57 202.43 249.23 207.09 249.58 202.43 249.94 202.07 254.6 201.72 249.94 197.06 249.58 201.72 249.23",
    style: {
      fill: "#8E4DFE"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tab--inject-104"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-104"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M274.39,42.42V96a4.41,4.41,0,0,0,2,3.46L321,125.3a1.36,1.36,0,0,0,.66.19,1.17,1.17,0,0,0,.26,0,.49.49,0,0,0,.17-.06.56.56,0,0,0,.17-.09,1.66,1.66,0,0,0,.53-.66,2.52,2.52,0,0,0,.21-1V70.49A4.4,4.4,0,0,0,321,67L276.38,41.27A1.43,1.43,0,0,0,275,41.1a.59.59,0,0,0-.17.1h0a.53.53,0,0,0-.13.13s0,0-.06.07l-.07.11a1.15,1.15,0,0,0-.12.25.48.48,0,0,0,0,.18.06.06,0,0,0,0,0,1.13,1.13,0,0,0,0,.18A2,2,0,0,0,274.39,42.42Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.5,41.71a1.12,1.12,0,0,1,.53.17l44.65,25.77a3.74,3.74,0,0,1,1.64,2.84v53.14a1.87,1.87,0,0,1-.13.69,1.46,1.46,0,0,1-.27.38l-.08,0h0l0,0-.11,0h0a.6.6,0,0,1-.31-.1l-44.65-25.8A3.7,3.7,0,0,1,275.09,96V42.42c0-.07,0-.13,0-.19s0,0,0,0h0l0,0v0l.07-.21h0l0-.07h0l.05-.06h0l0,0a.41.41,0,0,1,.16,0m0-.71a1,1,0,0,0-.46.1.59.59,0,0,0-.17.1h0a.53.53,0,0,0-.13.13s0,0-.06.07l-.07.11a1.15,1.15,0,0,0-.12.25.8.8,0,0,0,0,.18.06.06,0,0,0,0,0,1.13,1.13,0,0,0,0,.18,2,2,0,0,0,0,.25V96a4.41,4.41,0,0,0,2,3.46L321,125.3a1.37,1.37,0,0,0,.63.19h0a1.17,1.17,0,0,0,.26,0,.49.49,0,0,0,.17-.06.56.56,0,0,0,.17-.09,1.66,1.66,0,0,0,.53-.66,2.52,2.52,0,0,0,.21-1V70.49A4.4,4.4,0,0,0,321,67L276.38,41.27a1.84,1.84,0,0,0-.88-.27Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275,41.1a1.43,1.43,0,0,1,1.34.17L321,67a4.4,4.4,0,0,1,2,3.45V77l5.11-3V67.59a4.39,4.39,0,0,0-2-3.45L281.5,38.37a1.38,1.38,0,0,0-1.45-.11C279.69,38.47,275.47,40.88,275,41.1Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.39,42.41c0-1.26.9-1.77,2-1.14L321,67a4.4,4.4,0,0,1,2,3.45V77L274.39,48.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.15,74.06V67.58a4.13,4.13,0,0,0-.6-2l-5.11,2.92a4,4,0,0,1,.59,2V77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.69,49.4a3,3,0,0,1,1.13,2.39c0,1-.5,1.44-1.13,1.08a3,3,0,0,1-1.12-2.38C284.57,49.53,285.07,49,285.69,49.4Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.64,47.06a3,3,0,0,1,1.13,2.38c0,1-.51,1.44-1.13,1.08a3,3,0,0,1-1.12-2.38C280.52,47.18,281,46.7,281.64,47.06Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.59,44.71a3,3,0,0,1,1.13,2.39c0,.95-.51,1.44-1.13,1.08a3,3,0,0,1-1.13-2.38C276.46,44.84,277,44.36,277.59,44.71Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.29,125.3l.25-.14,4.77-2.74a1.64,1.64,0,0,0,.6-.68,2.38,2.38,0,0,0,.23-1V74.05L323,77v46.63a2.74,2.74,0,0,1-.21,1A1.69,1.69,0,0,1,322.29,125.3Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.69,96.74a1.32,1.32,0,0,1-.42-.38V53.74a.41.41,0,0,1,.29-.09,1.22,1.22,0,0,1,.61.2l41.05,23.69.16.11.13.12a.87.87,0,0,1,.13.15v43a.81.81,0,0,1-.24-.1Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.69,96.74a1.32,1.32,0,0,1-.42-.38V53.74a.41.41,0,0,1,.29-.09,1.22,1.22,0,0,1,.61.2l41.05,23.69.16.11.13.12a.87.87,0,0,1,.13.15v43a.81.81,0,0,1-.24-.1Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "278.5 95.07 318.5 118.16 318.5 97.89 307.56 77.94 297.12 84.99 300.73 94.32 289.5 78.17 278.5 82.36 278.5 95.07",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.81,68.74c0,2.49-1.31,3.74-2.92,2.81S285,67.86,285,65.37s1.31-3.73,2.92-2.8S290.81,66.26,290.81,68.74Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Line--inject-104"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 294.72,
    cy: 113.89,
    r: 1.12,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.57,155.51a1.13,1.13,0,1,1-1.13-1.12A1.13,1.13,0,0,1,279.57,155.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.23,
    y: 134.43,
    width: 44.69,
    height: 0.54,
    transform: "translate(56.6 352.38) rotate(-68.6)",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shield--inject-104"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--shield--inject-104"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.67,68.82a15.51,15.51,0,0,1-1.86-1.25c.2-.51.38-1,.53-1.43a14,14,0,0,0,4.66,4.6Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.67,68.82a15.51,15.51,0,0,1-1.86-1.25c.2-.51.38-1,.53-1.43a14,14,0,0,0,4.66,4.6Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.94,73.5c.09,19.94.25,46.83-22.38,68.54l-.49.47-.66.13a21.62,21.62,0,0,1-4.14.42,15.05,15.05,0,0,1-9.61-3.23,15.87,15.87,0,0,0,5.87,1.07,21.6,21.6,0,0,0,4.13-.42l.67-.13.48-.47c22.64-21.72,22.48-48.6,22.38-68.54,0-1.07,0-2.09,0-3.07h0l3.73-2.94v4.75C232.92,71.16,232.93,72.31,232.94,73.5Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.94,73.5c.09,19.94.25,46.83-22.38,68.54l-.49.47-.66.13a21.62,21.62,0,0,1-4.14.42,15.05,15.05,0,0,1-9.61-3.23,15.87,15.87,0,0,0,5.87,1.07,21.6,21.6,0,0,0,4.13-.42l.67-.13.48-.47c22.64-21.72,22.48-48.6,22.38-68.54,0-1.07,0-2.09,0-3.07h0l3.73-2.94v4.75C232.92,71.16,232.93,72.31,232.94,73.5Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.07,142.51h0l.49-.47c22.63-21.71,22.47-48.6,22.38-68.54,0-1.19,0-2.34,0-3.43V65.32L231,66.86l-1.78,1.4h0v0c0,1,0,2,0,3,.1,19.94.26,46.82-22.38,68.54l-.48.47,3.74,2.16Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.42,70.2a8.25,8.25,0,0,1-5.28-2.39,5.65,5.65,0,0,0,1.54.22c3,0,6.23-1.29,9.34-3.75l7.47-5.88,3.74,2.16-7.46,5.89C224.65,68.9,221.43,70.2,218.42,70.2Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.42,70.2a8.25,8.25,0,0,1-5.28-2.39,5.65,5.65,0,0,0,1.54.22c3,0,6.23-1.29,9.34-3.75l7.47-5.88,3.74,2.16-7.46,5.89C224.65,68.9,221.43,70.2,218.42,70.2Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.62,70.07l-3.74-2.16c-6.29,5-12.39,5.52-16.76,4A9.49,9.49,0,0,1,209,70.66l-3.74-2.16c-3.52,8.53-12.38,21-21.66,24.41,0,15.36-1.08,36.82,11.29,44l3.75,2.16c2.74,1.59,6.14,2.16,10.36,1.33h0C232.24,118.05,230.62,88.83,230.62,70.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.84,95.35,209,70.66h0l-3.74-2.16c-3.52,8.53-12.37,21-21.66,24.41l3.75,2.16Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.27,139.84a11.79,11.79,0,0,1-8.78-3.58c-8.44-8.48-8.34-23.49-8.27-37.72,0-1,0-1.93,0-2.83,9.41-3.82,17.53-15.75,21-23.38a13.38,13.38,0,0,0,9.19,3.4h0a20,20,0,0,0,11.27-3.84c0,.53,0,1.07,0,1.63.09,19.36.25,45.24-21.19,66a18.76,18.76,0,0,1-3.25.31Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "207.52 120.13 195.67 112.41 199.21 106.97 205.17 110.85 217.64 87.86 223.35 90.95 207.52 120.13",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.79,73.57c.09,19.16.22,44.61-20.71,65.1a17.39,17.39,0,0,1-2.81.24,10.92,10.92,0,0,1-8.13-3.3c-8.16-8.2-8.06-23-8-37.08,0-.76,0-1.5,0-2.21,9-4,16.7-14.89,20.41-22.51a14.64,14.64,0,0,0,8.87,2.84,20.21,20.21,0,0,0,10.36-3.08m1.83-3.5c-4.32,3.4-8.55,4.74-12.19,4.74A12,12,0,0,1,209,70.66c-3.51,8.54-12.37,21-21.65,24.41,0,17.71-1.44,45.69,18,45.69a18.8,18.8,0,0,0,3.69-.38h0c23.27-22.33,21.65-51.55,21.65-70.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204,58.5c-2.28,10.36-13.92,27.12-22,30.08l-3,1.11,3.75,2.17,3-1.12c8.08-3,19.72-19.72,22-30.08Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204,58.5c-2.28,10.36-13.92,27.12-22,30.08l-3,1.11,3.75,2.17,3-1.12c8.08-3,19.72-19.72,22-30.08Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.56,140.16c-10.05-10.1-9.95-26.5-9.87-41.65,0-1.2,0-2.35,0-3.44V91.86L179,89.69v3.22c0,1.09,0,2.24,0,3.44-.07,15.15-.18,31.54,9.88,41.65a17.72,17.72,0,0,0,3.71,2.88l3.47,2A18.34,18.34,0,0,1,192.56,140.16Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.56,140.16c-10.05-10.1-9.95-26.5-9.87-41.65,0-1.2,0-2.35,0-3.44V91.86L179,89.69v3.22c0,1.09,0,2.24,0,3.44-.07,15.15-.18,31.54,9.88,41.65a17.72,17.72,0,0,0,3.71,2.88l3.47,2A18.34,18.34,0,0,1,192.56,140.16Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.24,73.49c0-1.19,0-2.34,0-3.42V60.56l-7.46,5.89c-3.12,2.45-6.34,3.75-9.34,3.75-2.37,0-6.35-1.7-10.72-9.54-2.27,10.36-13.91,27.13-22,30.09l-3,1.1v3.22c0,1.09,0,2.24,0,3.44-.07,15.15-.18,31.55,9.87,41.65a17.31,17.31,0,0,0,12.71,5.21,24.52,24.52,0,0,0,4.58-.46l1.33-.26,1-.94C235.5,121.3,235.34,93.8,235.24,73.49ZM210.56,142l-.49.47-.66.13a21.62,21.62,0,0,1-4.14.42,15.08,15.08,0,0,1-11.07-4.52c-9.38-9.43-9.28-25.25-9.21-40,0-1.2,0-2.36,0-3.45V93.46l1.52-.55c8.76-3.21,19.26-19,21.82-26.77,2.39,3.93,6.9,6.36,10.09,6.36h0c3.52,0,7.24-1.47,10.76-4.24l3.74-2.94v4.75c0,1.09,0,2.24,0,3.43C233,93.44,233.19,120.33,210.56,142Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.24,73.49c0-1.19,0-2.34,0-3.42V60.56l-7.46,5.89c-3.12,2.45-6.34,3.75-9.34,3.75-2.37,0-6.35-1.7-10.72-9.54-2.27,10.36-13.91,27.13-22,30.09l-3,1.1v3.22c0,1.09,0,2.24,0,3.44-.07,15.15-.18,31.55,9.87,41.65a17.31,17.31,0,0,0,12.71,5.21,24.52,24.52,0,0,0,4.58-.46l1.33-.26,1-.94C235.5,121.3,235.34,93.8,235.24,73.49ZM210.56,142l-.49.47-.66.13a21.62,21.62,0,0,1-4.14.42,15.08,15.08,0,0,1-11.07-4.52c-9.38-9.43-9.28-25.25-9.21-40,0-1.2,0-2.36,0-3.45V93.46l1.52-.55c8.76-3.21,19.26-19,21.82-26.77,2.39,3.93,6.9,6.36,10.09,6.36h0c3.52,0,7.24-1.47,10.76-4.24l3.74-2.94v4.75c0,1.09,0,2.24,0,3.43C233,93.44,233.19,120.33,210.56,142Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--line--inject-104"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 212.84,
    cy: 148.74,
    r: 1.12,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.76,
    cy: 176.7,
    r: 1.12,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.52,
    y: 146.63,
    width: 0.54,
    height: 32.18,
    transform: "translate(-51.59 130.54) rotate(-29.65)",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-104"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gear--inject-104"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220.39,409.57a1.5,1.5,0,0,1-1-1.55l.32-2.62a1.2,1.2,0,0,0-1.07-1.35l-6.9-.72a1.92,1.92,0,0,0-1.78,1L208.56,407a2.45,2.45,0,0,1-1.79,1.17,35.51,35.51,0,0,0-3.57.44,3.48,3.48,0,0,1-2.23-.45l-3.71-2.46a2.56,2.56,0,0,0-2.16-.22l-5.52,2.21a.79.79,0,0,0-.56.7h0v.06h0v5.64h0a.93.93,0,0,0,.27.62l.32.34a3,3,0,0,1-1.51.48l-6.31-.26a1.68,1.68,0,0,0-1.59,1.12l-1,3.05a1,1,0,0,0,0,.38h0v5.7h0a1,1,0,0,0,.9,1l4.88.83-1.9,1a.78.78,0,0,0-.5.69h0v5.7h0a.82.82,0,0,0,.34.63l3.52,2.93a2.51,2.51,0,0,0,2.12.42l5.36-1.68a3.82,3.82,0,0,1,2.29.15,27.84,27.84,0,0,0,2.87,1.06,1.49,1.49,0,0,1,.71.5v3.84h0a1.2,1.2,0,0,0,1.08,1.18l6.9.72a1.94,1.94,0,0,0,1.78-1l1.37-2.68a2.41,2.41,0,0,1,1.78-1.16,35.36,35.36,0,0,0,3.58-.45,3.51,3.51,0,0,1,2.22.45l3.71,2.46a2.61,2.61,0,0,0,2.16.23l5.52-2.21a.81.81,0,0,0,.57-.74h0v-5.68h0a.86.86,0,0,0-.27-.61l-.32-.34a2.87,2.87,0,0,1,1.52-.47l6.3.25a1.69,1.69,0,0,0,1.6-1.12l.95-3.05a1.06,1.06,0,0,0,.05-.35h0V422.3h0a1,1,0,0,0-.88-1.06l-4.88-.83,1.9-1a.77.77,0,0,0,.49-.7h0V413.1h0a.86.86,0,0,0-.35-.65L233,409.52a2.49,2.49,0,0,0-2.11-.42l-5.37,1.68a3.78,3.78,0,0,1-2.28-.15A30.58,30.58,0,0,0,220.39,409.57Zm-22.88,14.29a10.2,10.2,0,0,1,4.71-3.41c6-2.4,14.19-1.54,18.34,1.91a8.32,8.32,0,0,1,1.4,1.49,10.25,10.25,0,0,1-4.72,3.42c-6,2.4-14.19,1.54-18.34-1.91A7.71,7.71,0,0,1,197.51,423.86Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.39,409.57a1.5,1.5,0,0,1-1-1.55l.32-2.62a1.2,1.2,0,0,0-1.07-1.35l-6.9-.72a1.92,1.92,0,0,0-1.78,1L208.56,407a2.45,2.45,0,0,1-1.79,1.17,35.51,35.51,0,0,0-3.57.44,3.48,3.48,0,0,1-2.23-.45l-3.71-2.46a2.56,2.56,0,0,0-2.16-.22l-5.52,2.21a.79.79,0,0,0-.56.7h0v.06h0v5.64h0a.93.93,0,0,0,.27.62l.32.34a3,3,0,0,1-1.51.48l-6.31-.26a1.68,1.68,0,0,0-1.59,1.12l-1,3.05a1,1,0,0,0,0,.38h0v5.7h0a1,1,0,0,0,.9,1l4.88.83-1.9,1a.78.78,0,0,0-.5.69h0v5.7h0a.82.82,0,0,0,.34.63l3.52,2.93a2.51,2.51,0,0,0,2.12.42l5.36-1.68a3.82,3.82,0,0,1,2.29.15,27.84,27.84,0,0,0,2.87,1.06,1.49,1.49,0,0,1,.71.5v3.84h0a1.2,1.2,0,0,0,1.08,1.18l6.9.72a1.94,1.94,0,0,0,1.78-1l1.37-2.68a2.41,2.41,0,0,1,1.78-1.16,35.36,35.36,0,0,0,3.58-.45,3.51,3.51,0,0,1,2.22.45l3.71,2.46a2.61,2.61,0,0,0,2.16.23l5.52-2.21a.81.81,0,0,0,.57-.74h0v-5.68h0a.86.86,0,0,0-.27-.61l-.32-.34a2.87,2.87,0,0,1,1.52-.47l6.3.25a1.69,1.69,0,0,0,1.6-1.12l.95-3.05a1.06,1.06,0,0,0,.05-.35h0V422.3h0a1,1,0,0,0-.88-1.06l-4.88-.83,1.9-1a.77.77,0,0,0,.49-.7h0V413.1h0a.86.86,0,0,0-.35-.65L233,409.52a2.49,2.49,0,0,0-2.11-.42l-5.37,1.68a3.78,3.78,0,0,1-2.28-.15A30.58,30.58,0,0,0,220.39,409.57Zm-22.88,14.29a10.2,10.2,0,0,1,4.71-3.41c6-2.4,14.19-1.54,18.34,1.91a8.32,8.32,0,0,1,1.4,1.49,10.25,10.25,0,0,1-4.72,3.42c-6,2.4-14.19,1.54-18.34-1.91A7.71,7.71,0,0,1,197.51,423.86Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.54,423.22a2,2,0,0,0-1.46-1.4l-6-1a1,1,0,0,1-.88-.94v5.63a1,1,0,0,0,.89,1l4.89.84,2.52-1.27a1.2,1.2,0,0,0,.51-1.63A7.22,7.22,0,0,1,187.54,423.22Zm1.47-9.16h0a1,1,0,0,0,.27.62l.32.34a2.53,2.53,0,0,0,.53-.4,12.47,12.47,0,0,1,1.51-1.35,1.06,1.06,0,0,0,.15-1.61L189.28,409a1,1,0,0,1-.27-.62Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.22,414.77c-5.16,2.07-7,5.88-4.71,9.09a10.17,10.17,0,0,1,4.7-3.41c6-2.39,14.19-1.54,18.35,1.91a7.89,7.89,0,0,1,1.39,1.49c1.6-2.29,1.23-5-1.39-7.17C216.41,413.23,208.2,412.38,202.22,414.77Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.48,434.41a1.85,1.85,0,0,0-.57.66l-1.38,2.68a1.92,1.92,0,0,1-1,.85v5.68a1.9,1.9,0,0,0,1-.85l1.38-2.68a2,2,0,0,1,.59-.65Zm19-.76h0a.8.8,0,0,1-.57.74l-5.51,2.21a2.53,2.53,0,0,1-1.45,0v5.68a2.58,2.58,0,0,0,1.44-.05l5.53-2.22a.78.78,0,0,0,.56-.73Zm-36.61-2.38-5.3,1.67a2.41,2.41,0,0,1-1.33,0v5.66a2.36,2.36,0,0,0,1.34,0l5.3-1.66Zm46.44-9a1.91,1.91,0,0,1-.06.33l-.95,3.05a1.69,1.69,0,0,1-1.59,1.12l-6.3-.25a2.57,2.57,0,0,0-1,.2v5.68a2.56,2.56,0,0,1,1-.2l6.31.25a1.71,1.71,0,0,0,1.59-1.12l.95-3.05a1.06,1.06,0,0,0,.05-.35Zm-3.37-9.2a.49.49,0,0,1,0,.2.56.56,0,0,1-.19.29.86.86,0,0,1-.28.19L232,416a.93.93,0,0,0-.27.19,1.08,1.08,0,0,0-.3.46,1.27,1.27,0,0,0-.06.44,2,2,0,0,0,0,.23,1.82,1.82,0,0,0,.11.3,9.62,9.62,0,0,1,.45,1.19,2.05,2.05,0,0,0,1.46,1.41l1.11.19,1.91-.95a.84.84,0,0,0,.5-.71h0Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.48,434.41a1.85,1.85,0,0,0-.57.66l-1.38,2.68a1.92,1.92,0,0,1-1,.85v5.68a1.9,1.9,0,0,0,1-.85l1.38-2.68a2,2,0,0,1,.59-.65Zm19-.76h0a.8.8,0,0,1-.57.74l-5.51,2.21a2.53,2.53,0,0,1-1.45,0v5.68a2.58,2.58,0,0,0,1.44-.05l5.53-2.22a.78.78,0,0,0,.56-.73Zm-36.61-2.38-5.3,1.67a2.41,2.41,0,0,1-1.33,0v5.66a2.36,2.36,0,0,0,1.34,0l5.3-1.66Zm46.44-9a1.91,1.91,0,0,1-.06.33l-.95,3.05a1.69,1.69,0,0,1-1.59,1.12l-6.3-.25a2.57,2.57,0,0,0-1,.2v5.68a2.56,2.56,0,0,1,1-.2l6.31.25a1.71,1.71,0,0,0,1.59-1.12l.95-3.05a1.06,1.06,0,0,0,.05-.35Zm-3.37-9.2a.49.49,0,0,1,0,.2.56.56,0,0,1-.19.29.86.86,0,0,1-.28.19L232,416a.93.93,0,0,0-.27.19,1.08,1.08,0,0,0-.3.46,1.27,1.27,0,0,0-.06.44,2,2,0,0,0,0,.23,1.82,1.82,0,0,0,.11.3,9.62,9.62,0,0,1,.45,1.19,2.05,2.05,0,0,0,1.46,1.41l1.11.19,1.91-.95a.84.84,0,0,0,.5-.71h0Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.92,409.1l-5.37,1.68a3.78,3.78,0,0,1-2.28-.15,28,28,0,0,0-2.88-1.06,1.5,1.5,0,0,1-1-1.55l.32-2.62a1.2,1.2,0,0,0-1.07-1.35l-6.9-.72a1.92,1.92,0,0,0-1.78,1L208.56,407a2.45,2.45,0,0,1-1.79,1.17,35.51,35.51,0,0,0-3.57.44,3.48,3.48,0,0,1-2.23-.45l-3.71-2.46a2.56,2.56,0,0,0-2.16-.22l-5.52,2.21a.77.77,0,0,0-.29,1.35l2.5,2.66a1.06,1.06,0,0,1-.16,1.61,15.24,15.24,0,0,0-1.51,1.35,3.12,3.12,0,0,1-2,.87l-6.31-.26a1.68,1.68,0,0,0-1.59,1.12l-1,3.05a1.05,1.05,0,0,0,.85,1.38l6,1a2.07,2.07,0,0,1,1.47,1.41,6.9,6.9,0,0,0,.45,1.19,1.2,1.2,0,0,1-.51,1.63l-4.42,2.22a.74.74,0,0,0-.16,1.33l3.53,2.93a2.45,2.45,0,0,0,2.11.42l5.37-1.68a3.79,3.79,0,0,1,2.28.15,27.84,27.84,0,0,0,2.87,1.06,1.5,1.5,0,0,1,1,1.56l-.32,2.62a1.2,1.2,0,0,0,1.07,1.34l6.9.72a1.94,1.94,0,0,0,1.78-1l1.37-2.68a2.41,2.41,0,0,1,1.79-1.16,35.53,35.53,0,0,0,3.57-.45,3.57,3.57,0,0,1,2.22.45l3.71,2.46a2.63,2.63,0,0,0,2.17.23l5.51-2.21a.78.78,0,0,0,.3-1.35l-2.5-2.67a1.06,1.06,0,0,1,.15-1.61,13.27,13.27,0,0,0,1.51-1.35,3.07,3.07,0,0,1,2-.86l6.31.25a1.68,1.68,0,0,0,1.59-1.12l.95-3.05a1,1,0,0,0-.84-1.38l-6-1a2.07,2.07,0,0,1-1.46-1.41,9.62,9.62,0,0,0-.45-1.19A1.19,1.19,0,0,1,232,416l4.43-2.23a.74.74,0,0,0,.15-1.33L233,409.52A2.49,2.49,0,0,0,230.92,409.1Zm-10.36,7.58c4.14,3.46,2.66,8.2-3.32,10.59s-14.19,1.54-18.34-1.91-2.66-8.2,3.32-10.59S216.41,413.23,220.56,416.68Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.55
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.92,409.1l-5.37,1.68a3.78,3.78,0,0,1-2.28-.15,28,28,0,0,0-2.88-1.06,1.5,1.5,0,0,1-1-1.55l.32-2.62a1.2,1.2,0,0,0-1.07-1.35l-6.9-.72a1.92,1.92,0,0,0-1.78,1L208.56,407a2.45,2.45,0,0,1-1.79,1.17,35.51,35.51,0,0,0-3.57.44,3.48,3.48,0,0,1-2.23-.45l-3.71-2.46a2.56,2.56,0,0,0-2.16-.22l-5.52,2.21a.77.77,0,0,0-.29,1.35l2.5,2.66a1.06,1.06,0,0,1-.16,1.61,15.24,15.24,0,0,0-1.51,1.35,3.12,3.12,0,0,1-2,.87l-6.31-.26a1.68,1.68,0,0,0-1.59,1.12l-1,3.05a1.05,1.05,0,0,0,.85,1.38l6,1a2.07,2.07,0,0,1,1.47,1.41,6.9,6.9,0,0,0,.45,1.19,1.2,1.2,0,0,1-.51,1.63l-4.42,2.22a.74.74,0,0,0-.16,1.33l3.53,2.93a2.45,2.45,0,0,0,2.11.42l5.37-1.68a3.79,3.79,0,0,1,2.28.15,27.84,27.84,0,0,0,2.87,1.06,1.5,1.5,0,0,1,1,1.56l-.32,2.62a1.2,1.2,0,0,0,1.07,1.34l6.9.72a1.94,1.94,0,0,0,1.78-1l1.37-2.68a2.41,2.41,0,0,1,1.79-1.16,35.53,35.53,0,0,0,3.57-.45,3.57,3.57,0,0,1,2.22.45l3.71,2.46a2.63,2.63,0,0,0,2.17.23l5.51-2.21a.78.78,0,0,0,.3-1.35l-2.5-2.67a1.06,1.06,0,0,1,.15-1.61,13.27,13.27,0,0,0,1.51-1.35,3.07,3.07,0,0,1,2-.86l6.31.25a1.68,1.68,0,0,0,1.59-1.12l.95-3.05a1,1,0,0,0-.84-1.38l-6-1a2.07,2.07,0,0,1-1.46-1.41,9.62,9.62,0,0,0-.45-1.19A1.19,1.19,0,0,1,232,416l4.43-2.23a.74.74,0,0,0,.15-1.33L233,409.52A2.49,2.49,0,0,0,230.92,409.1Zm-10.36,7.58c4.14,3.46,2.66,8.2-3.32,10.59s-14.19,1.54-18.34-1.91-2.66-8.2,3.32-10.59S216.41,413.23,220.56,416.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.89,439.06h-.18l-6.89-.72a1.53,1.53,0,0,1-1.38-1.73l.32-2.61a1.15,1.15,0,0,0-.8-1.19,28.36,28.36,0,0,1-2.91-1.08,3.49,3.49,0,0,0-2-.13l-5.37,1.68a2.82,2.82,0,0,1-2.43-.48l-3.53-2.93a1.19,1.19,0,0,1-.46-1,1.17,1.17,0,0,1,.68-.89l4.43-2.22a.85.85,0,0,0,.35-1.17,9,9,0,0,1-.47-1.24,1.72,1.72,0,0,0-1.2-1.17l-6-1a1.45,1.45,0,0,1-1-.65,1.41,1.41,0,0,1-.13-1.17l1-3.05a2,2,0,0,1,1.94-1.36l6.3.25a2.67,2.67,0,0,0,1.78-.76,14.78,14.78,0,0,1,1.54-1.38.79.79,0,0,0,.33-.56.74.74,0,0,0-.21-.55l-2.5-2.66a1.2,1.2,0,0,1-.35-1.07,1.18,1.18,0,0,1,.77-.83l5.51-2.21a3,3,0,0,1,2.48.25l3.71,2.47a3.27,3.27,0,0,0,2,.39c1.17-.2,2.38-.35,3.61-.45a2.06,2.06,0,0,0,1.5-1l1.37-2.67a2.27,2.27,0,0,1,2.13-1.15l6.89.72a1.54,1.54,0,0,1,1.05.57,1.56,1.56,0,0,1,.33,1.16l-.32,2.62a1.17,1.17,0,0,0,.79,1.19,27.13,27.13,0,0,1,2.92,1.07,3.57,3.57,0,0,0,2,.14l5.37-1.69a2.89,2.89,0,0,1,2.43.48l3.52,2.94a1.08,1.08,0,0,1-.22,1.9l-4.42,2.22a.86.86,0,0,0-.35,1.18,9.29,9.29,0,0,1,.47,1.24,1.73,1.73,0,0,0,1.19,1.16l6,1a1.38,1.38,0,0,1,1.11,1.81l-1,3a2,2,0,0,1-1.93,1.36l-6.3-.25a2.61,2.61,0,0,0-1.78.76A16,16,0,0,1,228,429a.81.81,0,0,0-.32.56.74.74,0,0,0,.21.55l2.5,2.66a1.12,1.12,0,0,1-.42,1.91l-5.52,2.21a2.94,2.94,0,0,1-2.47-.26l-3.72-2.46a3.17,3.17,0,0,0-2-.4,35.24,35.24,0,0,1-3.61.45,2.06,2.06,0,0,0-1.5,1l-1.38,2.67A2.27,2.27,0,0,1,207.89,439.06Zm-13.13-8.25a4.05,4.05,0,0,1,1.56.29,29.66,29.66,0,0,0,2.85,1,1.85,1.85,0,0,1,1.27,1.93l-.32,2.62a.82.82,0,0,0,.18.64.83.83,0,0,0,.59.32l6.89.72a1.58,1.58,0,0,0,1.44-.78l1.38-2.67a2.73,2.73,0,0,1,2.06-1.35c1.2-.1,2.39-.24,3.54-.44a3.84,3.84,0,0,1,2.47.49l3.71,2.47a2.3,2.3,0,0,0,1.85.19l5.52-2.21a.54.54,0,0,0,.35-.34.53.53,0,0,0-.18-.46l-2.5-2.66a1.4,1.4,0,0,1-.39-1.07,1.48,1.48,0,0,1,.58-1.05,15.87,15.87,0,0,0,1.48-1.31,3.3,3.3,0,0,1,2.29-1l6.31.26a1.32,1.32,0,0,0,1.25-.88l1-3.05a.8.8,0,0,0-.06-.61.76.76,0,0,0-.52-.33l-6-1a2.38,2.38,0,0,1-1.74-1.65,8.3,8.3,0,0,0-.43-1.14,1.54,1.54,0,0,1,.66-2.08l4.43-2.22a.54.54,0,0,0,.31-.35.53.53,0,0,0-.23-.42l-3.52-2.93a2.15,2.15,0,0,0-1.79-.35l-5.37,1.68a4.13,4.13,0,0,1-2.52-.16,27.87,27.87,0,0,0-2.84-1.05A1.85,1.85,0,0,1,219,408l.32-2.62a.86.86,0,0,0-.18-.64.92.92,0,0,0-.59-.32l-6.9-.72a1.58,1.58,0,0,0-1.44.78l-1.37,2.68a2.78,2.78,0,0,1-2.06,1.35c-1.2.09-2.39.24-3.54.44a3.93,3.93,0,0,1-2.48-.5L197.07,406a2.28,2.28,0,0,0-1.84-.19L189.71,408a.54.54,0,0,0-.35.34.52.52,0,0,0,.18.46l2.5,2.66a1.4,1.4,0,0,1,.39,1.07,1.48,1.48,0,0,1-.58,1.05,13.61,13.61,0,0,0-1.48,1.32,3.36,3.36,0,0,1-2.3,1l-6.3-.26a1.32,1.32,0,0,0-1.25.89l-1,3a.71.71,0,0,0,.06.61.76.76,0,0,0,.51.33l6,1a2.39,2.39,0,0,1,1.74,1.64,7.29,7.29,0,0,0,.43,1.15,1.53,1.53,0,0,1-.66,2.07l-4.43,2.22c-.19.1-.3.22-.31.36a.48.48,0,0,0,.22.41l3.52,2.93a2.18,2.18,0,0,0,1.8.36l5.36-1.69A3.55,3.55,0,0,1,194.76,430.81Zm15-1.84c-4.26,0-8.47-1.17-11.08-3.35a5.79,5.79,0,0,1-2.42-5.34c.38-2.37,2.5-4.5,5.83-5.83,6.07-2.43,14.46-1.55,18.69,2h0c1.85,1.55,2.71,3.44,2.41,5.34-.37,2.37-2.5,4.5-5.82,5.83A20.73,20.73,0,0,1,209.76,429Zm0-15.22a20.18,20.18,0,0,0-7.38,1.34c-3.09,1.24-5.06,3.17-5.4,5.3a5.12,5.12,0,0,0,2.18,4.7c4,3.38,12.13,4.21,18,1.86,3.1-1.24,5.07-3.17,5.4-5.3a5.13,5.13,0,0,0-2.17-4.7C217.84,414.87,213.81,413.75,209.72,413.75Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--gear--inject-104"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317.85,423.22l-7.45-4.3a2,2,0,0,0-1.65-.07l-7.55,3.5a2.84,2.84,0,0,1-1.73.1,44.07,44.07,0,0,0-5.87-1.39,1.45,1.45,0,0,1-1.09-1.07l-.94-5a1.17,1.17,0,0,0-1.11-.92H279.51a1.15,1.15,0,0,0-1.1.92l-1,5a1.45,1.45,0,0,1-1.09,1.07,43.92,43.92,0,0,0-5.86,1.39,2.83,2.83,0,0,1-1.73-.1l-7.56-3.5a2,2,0,0,0-1.65.07l-7.45,4.3a.61.61,0,0,0-.34.51h0v6.46h0a.61.61,0,0,0,.29.5l3.43,2.47a1.71,1.71,0,0,1-.84.35l-9.93.63a1,1,0,0,0-.93,1v4.22h0l0,7.76a1,1,0,0,0,.93,1l9.93.63a1.68,1.68,0,0,1,.86.37l-3.41,2.45a.61.61,0,0,0-.29.49h0v6.46h0a.61.61,0,0,0,.34.51l7.46,4.3a2,2,0,0,0,1.64.07l7.56-3.5a2.84,2.84,0,0,1,1.73-.1,43.92,43.92,0,0,0,5.86,1.39,1.42,1.42,0,0,1,1.09,1.07l.95,5a1.16,1.16,0,0,0,1.1.92h11a1.17,1.17,0,0,0,1.1-.92l.94-5a1.45,1.45,0,0,1,1.1-1.07,44.29,44.29,0,0,0,5.86-1.39,2.84,2.84,0,0,1,1.73.1l7.55,3.5a2,2,0,0,0,1.65-.07l7.45-4.3a.61.61,0,0,0,.35-.5h0l0-6.48h0a.62.62,0,0,0-.3-.49l-3.43-2.47a1.7,1.7,0,0,1,.85-.35l9.93-.63a1,1,0,0,0,.93-1v-12a1,1,0,0,0-.92-1l-9.93-.63a1.71,1.71,0,0,1-.87-.37l3.41-2.45a.62.62,0,0,0,.3-.49h0l0-6.47h0A.64.64,0,0,0,317.85,423.22ZM267.55,440c.53-1.79,2.13-3.53,4.85-5.1,7-4,18.22-4,25.17,0,2.55,1.47,4.22,3.09,5,4.75-.6,2-2.25,4-5,5.55-6.95,4-18.22,4-25.17,0A10.27,10.27,0,0,1,267.55,440Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.85,423.22l-7.45-4.3a2,2,0,0,0-1.65-.07l-7.55,3.5a2.84,2.84,0,0,1-1.73.1,44.07,44.07,0,0,0-5.87-1.39,1.45,1.45,0,0,1-1.09-1.07l-.94-5a1.17,1.17,0,0,0-1.11-.92H279.51a1.15,1.15,0,0,0-1.1.92l-1,5a1.45,1.45,0,0,1-1.09,1.07,43.92,43.92,0,0,0-5.86,1.39,2.83,2.83,0,0,1-1.73-.1l-7.56-3.5a2,2,0,0,0-1.65.07l-7.45,4.3a.61.61,0,0,0-.34.51h0v6.46h0a.61.61,0,0,0,.29.5l3.43,2.47a1.71,1.71,0,0,1-.84.35l-9.93.63a1,1,0,0,0-.93,1v4.22h0l0,7.76a1,1,0,0,0,.93,1l9.93.63a1.68,1.68,0,0,1,.86.37l-3.41,2.45a.61.61,0,0,0-.29.49h0v6.46h0a.61.61,0,0,0,.34.51l7.46,4.3a2,2,0,0,0,1.64.07l7.56-3.5a2.84,2.84,0,0,1,1.73-.1,43.92,43.92,0,0,0,5.86,1.39,1.42,1.42,0,0,1,1.09,1.07l.95,5a1.16,1.16,0,0,0,1.1.92h11a1.17,1.17,0,0,0,1.1-.92l.94-5a1.45,1.45,0,0,1,1.1-1.07,44.29,44.29,0,0,0,5.86-1.39,2.84,2.84,0,0,1,1.73.1l7.55,3.5a2,2,0,0,0,1.65-.07l7.45-4.3a.61.61,0,0,0,.35-.5h0l0-6.48h0a.62.62,0,0,0-.3-.49l-3.43-2.47a1.7,1.7,0,0,1,.85-.35l9.93-.63a1,1,0,0,0,.93-1v-12a1,1,0,0,0-.92-1l-9.93-.63a1.71,1.71,0,0,1-.87-.37l3.41-2.45a.62.62,0,0,0,.3-.49h0l0-6.47h0A.64.64,0,0,0,317.85,423.22ZM267.55,440c.53-1.79,2.13-3.53,4.85-5.1,7-4,18.22-4,25.17,0,2.55,1.47,4.22,3.09,5,4.75-.6,2-2.25,4-5,5.55-6.95,4-18.22,4-25.17,0A10.27,10.27,0,0,1,267.55,440Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,443.17a1.84,1.84,0,0,0-1.35-.89l-9.93-.63a1,1,0,0,1-.92-1v-1.32l0,7.77a1,1,0,0,0,.93,1l9.93.63a1.69,1.69,0,0,1,.87.36l2.49-1.79a.79.79,0,0,0,.11-1.21A14.67,14.67,0,0,1,256,443.17Zm-4.23-13h0a.6.6,0,0,0,.29.5l3.43,2.47a1.56,1.56,0,0,0,.49-.54,15.58,15.58,0,0,1,2.12-2.93.79.79,0,0,0-.11-1.21l-5.91-4.25a.74.74,0,0,1-.3-.43Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.57,430.63c-6.95-4-18.22-4-25.17,0-4.4,2.53-6,6.07-4.85,9.34.52-1.79,2.12-3.54,4.85-5.12,7-4,18.22-4,25.17,0,2.55,1.47,4.22,3.08,5,4.74C303.47,436.44,301.8,433.07,297.57,430.63Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.19,440.79a1,1,0,0,1-.92.86l-9.93.63a1.54,1.54,0,0,0-.5.13v6.47a1.51,1.51,0,0,1,.49-.14l9.93-.63a1,1,0,0,0,.93-1Zm-8-17.06h0a.35.35,0,0,1,0,.2.47.47,0,0,1-.12.19.81.81,0,0,1-.14.12L312,428.48a.57.57,0,0,0-.14.13.69.69,0,0,0-.18.36.71.71,0,0,0,0,.25l0,.13a.85.85,0,0,0,.2.34l.11.13a15.06,15.06,0,0,1,2,2.8,1.93,1.93,0,0,0,.47.53l3.41-2.45a.65.65,0,0,0,.3-.5h0Zm0,28.38a.62.62,0,0,1-.35.46l-7.45,4.3a2,2,0,0,1-1.16.2v6.46a2,2,0,0,0,1.15-.2l7.45-4.3a.59.59,0,0,0,.35-.49Zm-48.68,1.15a2.66,2.66,0,0,0-.75.18l-7.55,3.5a1.57,1.57,0,0,1-.67.15l0,6.44a1.83,1.83,0,0,0,.68-.13l7.55-3.5a2.36,2.36,0,0,1,.74-.17Zm21.86,7.93a1.16,1.16,0,0,1-.91.5h-11a1.14,1.14,0,0,1-.67-.24v6.46a1.21,1.21,0,0,0,.66.24h10.95a1.19,1.19,0,0,0,1-.55Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.19,440.79a1,1,0,0,1-.92.86l-9.93.63a1.54,1.54,0,0,0-.5.13v6.47a1.51,1.51,0,0,1,.49-.14l9.93-.63a1,1,0,0,0,.93-1Zm-8-17.06h0a.35.35,0,0,1,0,.2.47.47,0,0,1-.12.19.81.81,0,0,1-.14.12L312,428.48a.57.57,0,0,0-.14.13.69.69,0,0,0-.18.36.71.71,0,0,0,0,.25l0,.13a.85.85,0,0,0,.2.34l.11.13a15.06,15.06,0,0,1,2,2.8,1.93,1.93,0,0,0,.47.53l3.41-2.45a.65.65,0,0,0,.3-.5h0Zm0,28.38a.62.62,0,0,1-.35.46l-7.45,4.3a2,2,0,0,1-1.16.2v6.46a2,2,0,0,0,1.15-.2l7.45-4.3a.59.59,0,0,0,.35-.49Zm-48.68,1.15a2.66,2.66,0,0,0-.75.18l-7.55,3.5a1.57,1.57,0,0,1-.67.15l0,6.44a1.83,1.83,0,0,0,.68-.13l7.55-3.5a2.36,2.36,0,0,1,.74-.17Zm21.86,7.93a1.16,1.16,0,0,1-.91.5h-11a1.14,1.14,0,0,1-.67-.24v6.46a1.21,1.21,0,0,0,.66.24h10.95a1.19,1.19,0,0,0,1-.55Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.75,418.85l-7.55,3.5a2.84,2.84,0,0,1-1.73.1,44.07,44.07,0,0,0-5.87-1.39,1.45,1.45,0,0,1-1.09-1.07l-.94-5a1.17,1.17,0,0,0-1.11-.92H279.51a1.15,1.15,0,0,0-1.1.92l-1,5a1.45,1.45,0,0,1-1.09,1.06,43.92,43.92,0,0,0-5.86,1.39,2.83,2.83,0,0,1-1.73-.1l-7.56-3.5a2,2,0,0,0-1.65.07l-7.45,4.3a.56.56,0,0,0-.05,1l5.91,4.25a.79.79,0,0,1,.11,1.21,14.39,14.39,0,0,0-2.11,2.93,1.84,1.84,0,0,1-1.34.89l-9.93.63a1,1,0,0,0-.93,1v5.54a1,1,0,0,0,.93,1l9.93.63a1.84,1.84,0,0,1,1.34.89,14.67,14.67,0,0,0,2.11,2.93.79.79,0,0,1-.11,1.21l-5.91,4.25a.56.56,0,0,0,.05,1l7.45,4.3a2,2,0,0,0,1.65.07l7.56-3.5a2.81,2.81,0,0,1,1.72-.1,44.44,44.44,0,0,0,5.87,1.39,1.45,1.45,0,0,1,1.09,1.07l.94,5a1.17,1.17,0,0,0,1.11.92h10.95a1.17,1.17,0,0,0,1.11-.92l.94-5a1.45,1.45,0,0,1,1.09-1.07,44.07,44.07,0,0,0,5.87-1.39,2.84,2.84,0,0,1,1.73.1l7.55,3.5a2,2,0,0,0,1.65-.07l7.45-4.3a.55.55,0,0,0,0-1l-5.9-4.25a.78.78,0,0,1-.11-1.21,14.72,14.72,0,0,0,2.1-2.93,1.84,1.84,0,0,1,1.35-.89l9.93-.63a1,1,0,0,0,.92-1v-5.53a1,1,0,0,0-.92-1l-9.93-.63a1.84,1.84,0,0,1-1.35-.89,15,15,0,0,0-2.1-2.93.78.78,0,0,1,.11-1.21l5.9-4.25a.55.55,0,0,0,0-1l-7.45-4.3A2,2,0,0,0,308.75,418.85Zm-11.18,11.78c7,4,7,10.52,0,14.53s-18.22,4-25.17,0-6.95-10.52,0-14.53S290.62,426.61,297.57,430.63Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.55
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M308.75,418.85l-7.55,3.5a2.84,2.84,0,0,1-1.73.1,44.07,44.07,0,0,0-5.87-1.39,1.45,1.45,0,0,1-1.09-1.07l-.94-5a1.17,1.17,0,0,0-1.11-.92H279.51a1.15,1.15,0,0,0-1.1.92l-1,5a1.45,1.45,0,0,1-1.09,1.06,43.92,43.92,0,0,0-5.86,1.39,2.83,2.83,0,0,1-1.73-.1l-7.56-3.5a2,2,0,0,0-1.65.07l-7.45,4.3a.56.56,0,0,0-.05,1l5.91,4.25a.79.79,0,0,1,.11,1.21,14.39,14.39,0,0,0-2.11,2.93,1.84,1.84,0,0,1-1.34.89l-9.93.63a1,1,0,0,0-.93,1v5.54a1,1,0,0,0,.93,1l9.93.63a1.84,1.84,0,0,1,1.34.89,14.67,14.67,0,0,0,2.11,2.93.79.79,0,0,1-.11,1.21l-5.91,4.25a.56.56,0,0,0,.05,1l7.45,4.3a2,2,0,0,0,1.65.07l7.56-3.5a2.81,2.81,0,0,1,1.72-.1,44.44,44.44,0,0,0,5.87,1.39,1.45,1.45,0,0,1,1.09,1.07l.94,5a1.17,1.17,0,0,0,1.11.92h10.95a1.17,1.17,0,0,0,1.11-.92l.94-5a1.45,1.45,0,0,1,1.09-1.07,44.07,44.07,0,0,0,5.87-1.39,2.84,2.84,0,0,1,1.73.1l7.55,3.5a2,2,0,0,0,1.65-.07l7.45-4.3a.55.55,0,0,0,0-1l-5.9-4.25a.78.78,0,0,1-.11-1.21,14.72,14.72,0,0,0,2.1-2.93,1.84,1.84,0,0,1,1.35-.89l9.93-.63a1,1,0,0,0,.92-1v-5.53a1,1,0,0,0-.92-1l-9.93-.63a1.84,1.84,0,0,1-1.35-.89,15,15,0,0,0-2.1-2.93.78.78,0,0,1,.11-1.21l5.9-4.25a.55.55,0,0,0,0-1l-7.45-4.3A2,2,0,0,0,308.75,418.85Zm-11.18,11.78c7,4,7,10.52,0,14.53s-18.22,4-25.17,0-6.95-10.52,0-14.53S290.62,426.61,297.57,430.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.46,462H279.51a1.42,1.42,0,0,1-1.37-1.13l-.94-5a1.16,1.16,0,0,0-.88-.84,44.6,44.6,0,0,1-5.9-1.41,2.57,2.57,0,0,0-1.53.09l-7.56,3.5a2.23,2.23,0,0,1-1.89-.08L252,452.8a.82.82,0,0,1-.07-1.46l5.9-4.25a.47.47,0,0,0,.23-.37.55.55,0,0,0-.16-.44,16,16,0,0,1-2.15-3,1.52,1.52,0,0,0-1.12-.75l-9.93-.63a1.28,1.28,0,0,1-1.18-1.25v-5.54a1.28,1.28,0,0,1,1.18-1.26l9.93-.63a1.59,1.59,0,0,0,1.13-.75,15.08,15.08,0,0,1,2.14-3,.55.55,0,0,0,.16-.44.47.47,0,0,0-.23-.37l-5.9-4.25A.82.82,0,0,1,252,423l7.45-4.3a2.23,2.23,0,0,1,1.89-.08l7.56,3.5a2.6,2.6,0,0,0,1.54.09,44.08,44.08,0,0,1,5.89-1.41,1.16,1.16,0,0,0,.88-.84l.94-5a1.42,1.42,0,0,1,1.37-1.13h10.95a1.42,1.42,0,0,1,1.37,1.13l.94,5a1.16,1.16,0,0,0,.88.84,45.83,45.83,0,0,1,5.9,1.41,2.57,2.57,0,0,0,1.53-.09l7.56-3.5.11.24-.11-.24a2.23,2.23,0,0,1,1.89.08L318,423a.89.89,0,0,1,.48.71.87.87,0,0,1-.4.75l-5.91,4.25a.53.53,0,0,0-.23.37.55.55,0,0,0,.16.44,15.14,15.14,0,0,1,2.15,3,1.52,1.52,0,0,0,1.12.75l9.93.63a1.28,1.28,0,0,1,1.18,1.25v5.55a1.28,1.28,0,0,1-1.18,1.25l-9.93.63a1.57,1.57,0,0,0-1.12.75,15.14,15.14,0,0,1-2.15,3,.55.55,0,0,0-.16.44.47.47,0,0,0,.23.37l5.91,4.25a.87.87,0,0,1,.4.75.89.89,0,0,1-.48.71l-7.45,4.3a2.23,2.23,0,0,1-1.89.08l-7.56-3.5a2.57,2.57,0,0,0-1.53-.09,44.6,44.6,0,0,1-5.9,1.41,1.16,1.16,0,0,0-.88.84l-.94,5A1.42,1.42,0,0,1,290.46,462Zm-20.64-9a2.58,2.58,0,0,1,.76.11,44.75,44.75,0,0,0,5.83,1.38,1.71,1.71,0,0,1,1.31,1.28l.95,5a.9.9,0,0,0,.84.7h10.95a.91.91,0,0,0,.85-.7l.94-5a1.71,1.71,0,0,1,1.31-1.28,45.14,45.14,0,0,0,5.83-1.38,3,3,0,0,1,1.92.11l7.55,3.5a1.78,1.78,0,0,0,1.41-.06l7.45-4.3a.37.37,0,0,0,.21-.27.37.37,0,0,0-.18-.3l-5.91-4.25a1,1,0,0,1-.45-.75,1.11,1.11,0,0,1,.3-.85,14.43,14.43,0,0,0,2.07-2.87,2.07,2.07,0,0,1,1.56-1l9.93-.63a.74.74,0,0,0,.68-.72v-5.55a.74.74,0,0,0-.68-.72l-9.93-.63a2.07,2.07,0,0,1-1.56-1,14.85,14.85,0,0,0-2.07-2.87,1.11,1.11,0,0,1-.3-.85,1,1,0,0,1,.45-.75l5.91-4.25a.37.37,0,0,0,.18-.3.37.37,0,0,0-.21-.27l-7.45-4.3a1.78,1.78,0,0,0-1.41-.06l-7.55,3.5a3,3,0,0,1-1.92.11,44.75,44.75,0,0,0-5.83-1.38,1.71,1.71,0,0,1-1.31-1.28l-.94-5a.91.91,0,0,0-.85-.7H279.51a.9.9,0,0,0-.84.7l-.95,5a1.7,1.7,0,0,1-1.31,1.28,45.54,45.54,0,0,0-5.83,1.38,3,3,0,0,1-1.91-.11l-7.56-3.5a1.75,1.75,0,0,0-1.4.06l-7.46,4.3a.37.37,0,0,0-.21.27.36.36,0,0,0,.19.3l5.9,4.25a1,1,0,0,1,.45.75,1.07,1.07,0,0,1-.3.85,15.16,15.16,0,0,0-2.07,2.87,2.07,2.07,0,0,1-1.56,1l-9.93.63a.75.75,0,0,0-.68.73v5.54a.74.74,0,0,0,.68.72l9.93.63a2.07,2.07,0,0,1,1.56,1,14.85,14.85,0,0,0,2.07,2.87,1.05,1.05,0,0,1-.15,1.61l-5.9,4.24a.36.36,0,0,0-.19.3.37.37,0,0,0,.21.27l7.46,4.3a1.75,1.75,0,0,0,1.4.06l7.56-3.5A2.91,2.91,0,0,1,269.82,453ZM285,448.43a26,26,0,0,1-12.73-3c-3.44-2-5.34-4.65-5.34-7.49s1.9-5.51,5.35-7.5c7-4,18.42-4,25.44,0,3.45,2,5.34,4.65,5.34,7.5s-1.89,5.5-5.34,7.49A26,26,0,0,1,285,448.43Zm0-20.55a25.4,25.4,0,0,0-12.46,3c-3.28,1.89-5.08,4.39-5.08,7s1.8,5.14,5.08,7c6.87,4,18,4,24.91,0,3.28-1.89,5.08-4.39,5.08-7s-1.8-5.15-5.08-7A25.36,25.36,0,0,0,285,427.88Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coins-2--inject-104"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Coins--inject-104"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-104"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M484.74,421a15.65,15.65,0,0,0-5.82-5.39c-9.52-5.49-25-5.49-34.48,0a15.65,15.65,0,0,0-5.82,5.39H437.3v5h0c.17,3.46,2.54,6.9,7.12,9.54,9.52,5.49,25,5.49,34.48,0,4.58-2.64,7-6.08,7.14-9.54h0v-5Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.74,421a15.65,15.65,0,0,0-5.82-5.39c-9.52-5.49-25-5.49-34.48,0a15.65,15.65,0,0,0-5.82,5.39H437.3v5h0c.17,3.46,2.54,6.9,7.12,9.54,9.52,5.49,25,5.49,34.48,0,4.58-2.64,7-6.08,7.14-9.54h0v-5Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.68,411.46c-6.24,0-12.48,1.37-17.24,4.12a15.65,15.65,0,0,0-5.82,5.39H437.3v5h0c.17,3.46,2.54,6.9,7.12,9.54,4.76,2.75,11,4.12,17.24,4.12Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.37,413.75a26.7,26.7,0,0,0-3.93,1.83,15.65,15.65,0,0,0-5.82,5.39H437.3v5h0c.17,3.46,2.54,6.9,7.12,9.54a27.8,27.8,0,0,0,3.93,1.84Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475,413.75a27.07,27.07,0,0,1,3.92,1.83,15.65,15.65,0,0,1,5.82,5.39h1.32v5h0c-.18,3.46-2.56,6.9-7.14,9.54a28.21,28.21,0,0,1-3.92,1.84Z",
    style: {
      fill: "#8E4DFE",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.44,411c-9.52,5.49-9.52,14.41,0,19.9,8.33,4.81,21.19,5.41,30.65,1.81h0l.38-.15a25.54,25.54,0,0,0,3.45-1.66c7.94-4.58,9.26-11.54,3.95-16.91h0a18.32,18.32,0,0,0-3.95-3C469.4,405.52,454,405.52,444.44,411Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.44,411c-9.52,5.49-9.52,14.41,0,19.9,8.33,4.81,21.19,5.41,30.65,1.81h0l.38-.15a25.54,25.54,0,0,0,3.45-1.66c7.94-4.58,9.26-11.54,3.95-16.91h0a18.32,18.32,0,0,0-3.95-3C469.4,405.52,454,405.52,444.44,411Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.87,414a10.59,10.59,0,0,1,2.55,8.68c-.84,4.84-7.61,8.91-9.95,9.89a25.54,25.54,0,0,0,3.45-1.66C486.86,426.34,488.18,419.38,482.87,414Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.49,427.93a10.59,10.59,0,0,1-2.55-8.68c.84-4.84,7.61-8.91,9.95-9.89a26.8,26.8,0,0,0-3.45,1.66C436.5,415.6,435.18,422.56,440.49,427.93Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.71,430.2c8.85-5.11,8.85-13.39,0-18.5s-23.2-5.11-32,0-8.85,13.39,0,18.5S468.86,435.31,477.71,430.2Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.71,430.2c8.85-5.11,8.85-13.39,0-18.5s-23.2-5.11-32,0-8.85,13.39,0,18.5S468.86,435.31,477.71,430.2Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.32,424.86c1.82-3.37,1.23-7.08-1.78-10.23a14.61,14.61,0,0,0-1.92-1.68,20,20,0,0,0-1.83-1.21c-.36-.21-.73-.41-1.12-.6.94,1.55.6,3.21-4.74,3.52-10.44.61,2.79,10.59,2.79,10.59S481.46,422,483.32,424.86Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.24,422.1c1.57-.18,2.35-1.79,1.74-3.6a4.14,4.14,0,0,0-3.94-3c-1.57.18-2.35,1.79-1.74,3.6A4.15,4.15,0,0,0,482.24,422.1Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.72,430.42c-.51-3.88-17.47-14.62-17.47-14.62s-3.76-1.51-2.51-4.14a19.52,19.52,0,0,0-1.81,1.18c-.39.28-.76.57-1.1.87-5.05,4.37-5.06,10.11,0,14.49.34.29.71.58,1.1.87a19.46,19.46,0,0,0,1.68,1.09c.58.34,1.18.65,1.8.94s1,.46,1.52.66,1.05.4,1.59.57a32.79,32.79,0,0,0,5.06,1.22l1.14.17a38.73,38.73,0,0,0,5.06.31,37.47,37.47,0,0,0,6.19-.51S465.24,433,465.72,430.42Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.72,430.42c-.51-3.88-17.47-14.62-17.47-14.62s-3.76-1.51-2.51-4.14a19.52,19.52,0,0,0-1.81,1.18c-.39.28-.76.57-1.1.87-5.05,4.37-5.06,10.11,0,14.49.34.29.71.58,1.1.87a19.46,19.46,0,0,0,1.68,1.09c.58.34,1.18.65,1.8.94s1,.46,1.52.66,1.05.4,1.59.57a32.79,32.79,0,0,0,5.06,1.22l1.14.17a38.73,38.73,0,0,0,5.06.31,37.47,37.47,0,0,0,6.19-.51S465.24,433,465.72,430.42Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.74,414.06c-6.32,3.65-6.58,9.48-.77,13.3q.38.25.78.48c6.59,3.81,17.28,3.81,23.87,0s6.6-10,0-13.78c-.27-.16-.55-.31-.83-.45C466.16,410.26,456.07,410.41,449.74,414.06Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.74,414.06c-6.32,3.65-6.58,9.48-.77,13.3q.38.25.78.48c6.59,3.81,17.28,3.81,23.87,0s6.6-10,0-13.78c-.27-.16-.55-.31-.83-.45C466.16,410.26,456.07,410.41,449.74,414.06Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.28,414.36c-6.3,3.64-6.3,9.54,0,13.18s16.52,3.64,22.82,0,6.3-9.54,0-13.18S456.58,410.72,450.28,414.36Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.28,414.36c-6.3,3.64-6.3,9.54,0,13.18s16.52,3.64,22.82,0,6.3-9.54,0-13.18S456.58,410.72,450.28,414.36Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.28,417c6.3-3.64,16.52-3.64,22.82,0,2.58,1.49,4.1,3.36,4.57,5.29-.47,1.93-2,3.8-4.57,5.29-6.3,3.64-16.52,3.64-22.82,0-2.58-1.49-4.1-3.36-4.57-5.29C446.18,420.32,447.7,418.45,450.28,417Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.28,417c6.3-3.64,16.52-3.64,22.82,0,2.58,1.49,4.1,3.36,4.57,5.29-.47,1.93-2,3.8-4.57,5.29-6.3,3.64-16.52,3.64-22.82,0-2.58-1.49-4.1-3.36-4.57-5.29C446.18,420.32,447.7,418.45,450.28,417Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.85,423.76c0-.32,0-1.6,0-1.93,0-.79-.54-1.55-1.72-2.24l0,0a8.24,8.24,0,0,0-6.4-.58h0c-.85.21-1.65.49-2.39.74a23.11,23.11,0,0,1-2.56.79h0a4.89,4.89,0,0,1-1.22.11,2.53,2.53,0,0,1-1-.27l.08-.05.25-.16a5.3,5.3,0,0,1,.68-.33,4.67,4.67,0,0,1,3.59-.09l2.06-2.08v-1.92a9.79,9.79,0,0,0-5.65-.2,11.63,11.63,0,0,0-1.8.62l-2.07-1.2-2.47,1.43v1.92l.85.48a2,2,0,0,0-.37,1.12c0,.32,0,1.59,0,1.91,0,.79.56,1.56,1.75,2.24a7.29,7.29,0,0,0,3.41,1h0c.22,0,.45,0,.68,0a13.55,13.55,0,0,0,3.66-.79l.71-.24-2.08,2.08V428a10.12,10.12,0,0,0,8-.35l2,1.18,2.47-1.42v-1.92l-.85-.49A2.2,2.2,0,0,0,471.85,423.76Zm-5.21-.17a5.1,5.1,0,0,1-.57.29,5.33,5.33,0,0,1-4,.06c1.94-.68,3.55-1.28,4.93-.55A2.49,2.49,0,0,1,466.64,423.59Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.69,419h0c-.85.21-1.65.49-2.39.74a23.11,23.11,0,0,1-2.56.79h0a4.89,4.89,0,0,1-1.22.11,2.52,2.52,0,0,1-1.18-.35c-.79-.46-.91-1.13.25-1.89l.25-.15a5.39,5.39,0,0,1,.68-.34,4.67,4.67,0,0,1,3.59-.08l2.06-2.09a9.79,9.79,0,0,0-5.65-.2,11.63,11.63,0,0,0-1.8.62l-2.07-1.2-2.47,1.43,2,1.18,0,0c-2.08,1.57-2.12,3.21.21,4.56a7.27,7.27,0,0,0,3.41,1h.69a13.93,13.93,0,0,0,3.66-.79c2.37-.8,4.29-1.73,5.89-.81,1.06.62.77,1.39-.41,2.07a5.1,5.1,0,0,1-.57.29,5.31,5.31,0,0,1-4.11,0l-2.17,2.17a10.17,10.17,0,0,0,8-.34l2,1.18,2.47-1.43-2-1.18c2.05-1.59,2.29-3.32-.11-4.72l0,0A8.24,8.24,0,0,0,463.69,419Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M463.69,419h0c-.85.21-1.65.49-2.39.74a23.11,23.11,0,0,1-2.56.79h0a4.89,4.89,0,0,1-1.22.11,2.52,2.52,0,0,1-1.18-.35c-.79-.46-.91-1.13.25-1.89l.25-.15a5.39,5.39,0,0,1,.68-.34,4.67,4.67,0,0,1,3.59-.08l2.06-2.09a9.79,9.79,0,0,0-5.65-.2,11.63,11.63,0,0,0-1.8.62l-2.07-1.2-2.47,1.43,2,1.18,0,0c-2.08,1.57-2.12,3.21.21,4.56a7.27,7.27,0,0,0,3.41,1h.69a13.93,13.93,0,0,0,3.66-.79c2.37-.8,4.29-1.73,5.89-.81,1.06.62.77,1.39-.41,2.07a5.1,5.1,0,0,1-.57.29,5.31,5.31,0,0,1-4.11,0l-2.17,2.17a10.17,10.17,0,0,0,8-.34l2,1.18,2.47-1.43-2-1.18c2.05-1.59,2.29-3.32-.11-4.72l0,0A8.24,8.24,0,0,0,463.69,419Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "451.16 416.38 453.65 415.25 455.7 416.15 453.63 414.95 451.16 416.38",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.21,415.6a11.67,11.67,0,0,1,5.31.18l-1.43,2,2.06-2.09A9.92,9.92,0,0,0,457.21,415.6Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.09,419.56l0,0c2.4,1.4,2.16,3.13.11,4.72,1.82-2,1.49-3.36-.49-4.51a9.36,9.36,0,0,0-6.06-.82A8.24,8.24,0,0,1,470.09,419.56Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "470.24 424.31 471.81 425.52 469.81 426.92 472.28 425.49 470.24 424.31",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.07,423.88a5.27,5.27,0,0,1-3.93.34l-2.35,1.86,2.17-2.17A5.31,5.31,0,0,0,466.07,423.88Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.72,420.52a3.24,3.24,0,0,1-3-.28c-.72-.62-.26-1.28.81-1.85-1.16.76-1,1.43-.25,1.89a2.52,2.52,0,0,0,1.18.35A4.89,4.89,0,0,0,458.72,420.52Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.19,417.58c-.18.15-1.66,1.54-1,2.92s2.88,2.43,4.64,2.62h0a7.27,7.27,0,0,1-3.41-1C451.07,420.79,451.11,419.15,453.19,417.58Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-104"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M481.93,413.52a15.83,15.83,0,0,0-5.83-5.38c-9.52-5.5-25-5.5-34.47,0a15.83,15.83,0,0,0-5.83,5.38h-1.31v5h0c.18,3.47,2.55,6.9,7.13,9.54,9.52,5.5,24.95,5.5,34.47,0,4.58-2.64,7-6.07,7.14-9.54h0v-5Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.93,413.52a15.83,15.83,0,0,0-5.83-5.38c-9.52-5.5-25-5.5-34.47,0a15.83,15.83,0,0,0-5.83,5.38h-1.31v5h0c.18,3.47,2.55,6.9,7.13,9.54,9.52,5.5,24.95,5.5,34.47,0,4.58-2.64,7-6.07,7.14-9.54h0v-5Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.87,404c-6.24,0-12.48,1.37-17.24,4.12a15.83,15.83,0,0,0-5.83,5.38h-1.31v5h0c.18,3.47,2.55,6.9,7.13,9.54,4.76,2.75,11,4.13,17.24,4.13Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.55,406.3a25.64,25.64,0,0,0-3.92,1.84,15.83,15.83,0,0,0-5.83,5.38h-1.31v5h0c.18,3.47,2.55,6.9,7.13,9.54a25.64,25.64,0,0,0,3.92,1.84Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.18,406.3a25.64,25.64,0,0,1,3.92,1.84,15.83,15.83,0,0,1,5.83,5.38h1.31v5h0c-.17,3.47-2.56,6.9-7.14,9.54a25.64,25.64,0,0,1-3.92,1.84Z",
    style: {
      fill: "#8E4DFE",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.63,403.57c-9.52,5.5-9.52,14.41,0,19.91,8.33,4.81,21.19,5.41,30.65,1.8h0l.38-.15a26.62,26.62,0,0,0,3.44-1.65c7.94-4.59,9.26-11.54,4-16.92h0a18.65,18.65,0,0,0-4-3C466.58,398.08,451.15,398.08,441.63,403.57Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.63,403.57c-9.52,5.5-9.52,14.41,0,19.91,8.33,4.81,21.19,5.41,30.65,1.8h0l.38-.15a26.62,26.62,0,0,0,3.44-1.65c7.94-4.59,9.26-11.54,4-16.92h0a18.65,18.65,0,0,0-4-3C466.58,398.08,451.15,398.08,441.63,403.57Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.06,406.56a10.69,10.69,0,0,1,2.55,8.69c-.84,4.83-7.62,8.91-9.95,9.88a26.62,26.62,0,0,0,3.44-1.65C484,418.89,485.36,411.94,480.06,406.56Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.67,420.49a10.69,10.69,0,0,1-2.55-8.69c.85-4.83,7.62-8.91,9.95-9.88a26.62,26.62,0,0,0-3.44,1.65C433.69,408.16,432.37,415.12,437.67,420.49Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.9,422.76c8.85-5.11,8.85-13.4,0-18.51s-23.2-5.11-32,0-8.85,13.4,0,18.51S466.05,427.87,474.9,422.76Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.9,422.76c8.85-5.11,8.85-13.4,0-18.51s-23.2-5.11-32,0-8.85,13.4,0,18.51S466.05,427.87,474.9,422.76Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.51,417.41c1.82-3.36,1.22-7.07-1.78-10.22a15.19,15.19,0,0,0-1.92-1.68A18.3,18.3,0,0,0,475,404.3c-.36-.22-.73-.42-1.11-.61.94,1.55.59,3.21-4.74,3.52-10.45.61,2.79,10.6,2.79,10.6S478.64,414.55,480.51,417.41Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.43,414.65c1.57-.17,2.34-1.79,1.73-3.6s-2.37-3.14-3.94-3-2.34,1.78-1.73,3.6S477.86,414.83,479.43,414.65Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.91,423c-.52-3.88-17.47-14.62-17.47-14.62s-3.76-1.5-2.51-4.13a17.8,17.8,0,0,0-1.82,1.17c-.39.28-.76.57-1.1.87-5.05,4.37-5.05,10.11,0,14.49.34.3.71.59,1.1.87a19.51,19.51,0,0,0,1.68,1.1c.58.33,1.18.65,1.8.94s1,.45,1.53.66,1.05.39,1.59.57a34,34,0,0,0,5.06,1.22l1.13.16a40.56,40.56,0,0,0,5.06.32,39.67,39.67,0,0,0,6.19-.51S462.42,425.52,462.91,423Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.91,423c-.52-3.88-17.47-14.62-17.47-14.62s-3.76-1.5-2.51-4.13a17.8,17.8,0,0,0-1.82,1.17c-.39.28-.76.57-1.1.87-5.05,4.37-5.05,10.11,0,14.49.34.3.71.59,1.1.87a19.51,19.51,0,0,0,1.68,1.1c.58.33,1.18.65,1.8.94s1,.45,1.53.66,1.05.39,1.59.57a34,34,0,0,0,5.06,1.22l1.13.16a40.56,40.56,0,0,0,5.06.32,39.67,39.67,0,0,0,6.19-.51S462.42,425.52,462.91,423Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.93,406.61c-6.33,3.65-6.58,9.48-.77,13.31.24.16.5.32.77.48,6.59,3.8,17.28,3.8,23.87,0s6.6-10,0-13.79l-.83-.44C463.34,402.81,453.25,403,446.93,406.61Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.93,406.61c-6.33,3.65-6.58,9.48-.77,13.31.24.16.5.32.77.48,6.59,3.8,17.28,3.8,23.87,0s6.6-10,0-13.79l-.83-.44C463.34,402.81,453.25,403,446.93,406.61Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.46,406.92c-6.3,3.64-6.3,9.53,0,13.17s16.52,3.64,22.83,0,6.3-9.53,0-13.17S453.77,403.28,447.46,406.92Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.46,406.92c-6.3,3.64-6.3,9.53,0,13.17s16.52,3.64,22.83,0,6.3-9.53,0-13.17S453.77,403.28,447.46,406.92Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.46,409.52c6.31-3.64,16.52-3.64,22.83,0,2.57,1.48,4.1,3.35,4.56,5.28-.46,1.94-2,3.81-4.56,5.29-6.31,3.64-16.52,3.64-22.83,0-2.57-1.48-4.1-3.35-4.57-5.29C443.36,412.87,444.89,411,447.46,409.52Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.46,409.52c6.31-3.64,16.52-3.64,22.83,0,2.57,1.48,4.1,3.35,4.56,5.28-.46,1.94-2,3.81-4.56,5.29-6.31,3.64-16.52,3.64-22.83,0-2.57-1.48-4.1-3.35-4.57-5.29C443.36,412.87,444.89,411,447.46,409.52Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469,416.31c0-.31,0-1.59,0-1.92,0-.79-.55-1.56-1.72-2.25l-.05,0a8.24,8.24,0,0,0-6.4-.59h0c-.85.22-1.66.49-2.39.74a23.52,23.52,0,0,1-2.57.8h0a4.46,4.46,0,0,1-1.22.12,2.57,2.57,0,0,1-1-.27l.08-.06.26-.15a5.28,5.28,0,0,1,.67-.34,4.67,4.67,0,0,1,3.59-.08l2.07-2.09v-1.91a9.83,9.83,0,0,0-5.66-.21,11.63,11.63,0,0,0-1.8.62l-2.07-1.19-2.47,1.42v1.92l.85.49a2.06,2.06,0,0,0-.36,1.12v1.91c0,.79.57,1.55,1.76,2.24a7.24,7.24,0,0,0,3.41,1h0c.23,0,.46,0,.68,0a13.55,13.55,0,0,0,3.66-.79l.72-.25L457,418.64v1.91a10.16,10.16,0,0,0,8-.34l2.05,1.18,2.47-1.43v-1.91l-.85-.49A2.25,2.25,0,0,0,469,416.31Zm-5.21-.16a5,5,0,0,1-.57.28,5.28,5.28,0,0,1-4,.06c1.93-.68,3.55-1.27,4.92-.54Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.87,411.53h0c-.85.22-1.66.49-2.39.74a23.52,23.52,0,0,1-2.57.8h0a4.46,4.46,0,0,1-1.22.12,2.7,2.7,0,0,1-1.17-.35c-.8-.46-.91-1.13.24-1.89a2.26,2.26,0,0,1,.26-.16,7,7,0,0,1,.67-.34,4.71,4.71,0,0,1,3.59-.08l2.07-2.08a9.83,9.83,0,0,0-5.66-.21,11.63,11.63,0,0,0-1.8.62l-2.07-1.19-2.47,1.42,2.05,1.19h0c-2.07,1.58-2.12,3.21.22,4.56a7.13,7.13,0,0,0,3.41,1h.68a13.55,13.55,0,0,0,3.66-.79c2.37-.79,4.29-1.73,5.89-.8,1.07.61.77,1.39-.4,2.07a5,5,0,0,1-.57.28,5.29,5.29,0,0,1-4.12,0L457,418.64a10.12,10.12,0,0,0,8-.35l2.05,1.18,2.47-1.42-2.05-1.18c2.06-1.59,2.29-3.32-.1-4.73l-.05,0A8.24,8.24,0,0,0,460.87,411.53Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M460.87,411.53h0c-.85.22-1.66.49-2.39.74a23.52,23.52,0,0,1-2.57.8h0a4.46,4.46,0,0,1-1.22.12,2.7,2.7,0,0,1-1.17-.35c-.8-.46-.91-1.13.24-1.89a2.26,2.26,0,0,1,.26-.16,7,7,0,0,1,.67-.34,4.71,4.71,0,0,1,3.59-.08l2.07-2.08a9.83,9.83,0,0,0-5.66-.21,11.63,11.63,0,0,0-1.8.62l-2.07-1.19-2.47,1.42,2.05,1.19h0c-2.07,1.58-2.12,3.21.22,4.56a7.13,7.13,0,0,0,3.41,1h.68a13.55,13.55,0,0,0,3.66-.79c2.37-.79,4.29-1.73,5.89-.8,1.07.61.77,1.39-.4,2.07a5,5,0,0,1-.57.28,5.29,5.29,0,0,1-4.12,0L457,418.64a10.12,10.12,0,0,0,8-.35l2.05,1.18,2.47-1.42-2.05-1.18c2.06-1.59,2.29-3.32-.1-4.73l-.05,0A8.24,8.24,0,0,0,460.87,411.53Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "448.35 408.94 450.84 407.81 452.88 408.7 450.81 407.51 448.35 408.94",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.4,408.16a11.49,11.49,0,0,1,5.3.18l-1.43,2,2.07-2.08A9.76,9.76,0,0,0,454.4,408.16Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.27,412.12l.05,0c2.39,1.41,2.16,3.14.1,4.73,1.82-2,1.5-3.37-.48-4.51a9.33,9.33,0,0,0-6.07-.83A8.24,8.24,0,0,1,467.27,412.12Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "467.42 416.87 468.99 418.07 467 419.47 469.47 418.05 467.42 416.87",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.26,416.43a5.34,5.34,0,0,1-3.94.35L457,418.64l2.17-2.18A5.29,5.29,0,0,0,463.26,416.43Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.9,413.07a3.22,3.22,0,0,1-3-.28c-.71-.61-.25-1.27.81-1.84-1.15.76-1,1.43-.24,1.89a2.7,2.7,0,0,0,1.17.35A4.46,4.46,0,0,0,455.9,413.07Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.37,410.13c-.17.16-1.66,1.54-1,2.93s2.87,2.42,4.63,2.61h0a7.13,7.13,0,0,1-3.41-1C448.25,413.34,448.3,411.71,450.37,410.13Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-104"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M437.69,405.75a15.76,15.76,0,0,1,5.83-5.39c9.52-5.49,25-5.49,34.47,0a15.76,15.76,0,0,1,5.83,5.39h1.31v5h0c-.18,3.46-2.55,6.9-7.13,9.54-9.52,5.5-24.95,5.5-34.47,0-4.58-2.64-7-6.08-7.14-9.54h0v-5Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.69,405.75a15.76,15.76,0,0,1,5.83-5.39c9.52-5.49,25-5.49,34.47,0a15.76,15.76,0,0,1,5.83,5.39h1.31v5h0c-.18,3.46-2.55,6.9-7.13,9.54-9.52,5.5-24.95,5.5-34.47,0-4.58-2.64-7-6.08-7.14-9.54h0v-5Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.75,396.24c6.24,0,12.48,1.37,17.24,4.12a15.76,15.76,0,0,1,5.83,5.39h1.31v5h0c-.18,3.46-2.55,6.9-7.13,9.54-4.76,2.75-11,4.12-17.24,4.12Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.07,398.53a26.11,26.11,0,0,1,3.92,1.83,15.76,15.76,0,0,1,5.83,5.39h1.31v5h0c-.18,3.46-2.55,6.9-7.13,9.54a27.17,27.17,0,0,1-3.92,1.84Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.44,398.53a26.58,26.58,0,0,0-3.92,1.83,15.76,15.76,0,0,0-5.83,5.39h-1.31v5h0c.17,3.46,2.56,6.9,7.14,9.54a27.68,27.68,0,0,0,3.92,1.84Z",
    style: {
      fill: "#8E4DFE",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478,395.8c9.53,5.5,9.52,14.41,0,19.9-8.33,4.81-21.18,5.41-30.65,1.81h0l-.38-.15a25.42,25.42,0,0,1-3.44-1.66c-7.94-4.58-9.26-11.54-4-16.91h0a18.65,18.65,0,0,1,4-3C453,390.3,468.47,390.3,478,395.8Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478,395.8c9.53,5.5,9.52,14.41,0,19.9-8.33,4.81-21.18,5.41-30.65,1.81h0l-.38-.15a25.42,25.42,0,0,1-3.44-1.66c-7.94-4.58-9.26-11.54-4-16.91h0a18.65,18.65,0,0,1,4-3C453,390.3,468.47,390.3,478,395.8Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.56,398.79a10.66,10.66,0,0,0-2.55,8.68c.85,4.84,7.62,8.91,9.95,9.89a25.42,25.42,0,0,1-3.44-1.66C435.58,411.12,434.26,404.16,439.56,398.79Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482,412.71A10.65,10.65,0,0,0,484.5,404c-.84-4.84-7.62-8.91-9.95-9.89A26.67,26.67,0,0,1,478,395.8C485.93,400.38,487.25,407.34,482,412.71Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 460.77,
    cy: 405.73,
    rx: 22.66,
    ry: 13.08,
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 460.77,
    cy: 405.73,
    rx: 22.66,
    ry: 13.08,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.13,409.64c-1.82-3.37-1.23-7.08,1.78-10.23a16,16,0,0,1,1.92-1.68,20.21,20.21,0,0,1,1.84-1.21q.54-.31,1.11-.6c-.94,1.55-.59,3.21,4.74,3.52,10.45.61-2.79,10.59-2.79,10.59S441,406.78,439.13,409.64Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.21,406.88c-1.57-.18-2.34-1.79-1.74-3.6a4.15,4.15,0,0,1,3.95-3c1.56.18,2.34,1.79,1.73,3.6A4.14,4.14,0,0,1,440.21,406.88Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.73,415.2c.52-3.88,17.47-14.62,17.47-14.62s3.76-1.51,2.51-4.14a21.16,21.16,0,0,1,1.82,1.18c.39.28.75.57,1.1.87,5,4.37,5.05,10.11,0,14.49-.34.29-.7.59-1.09.87a18.22,18.22,0,0,1-1.69,1.09,20.19,20.19,0,0,1-1.79.94q-.75.36-1.53.66c-.52.21-1,.4-1.59.58a34,34,0,0,1-5.06,1.21l-1.14.17a39.74,39.74,0,0,1-11.24-.19S457.22,417.75,456.73,415.2Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.73,415.2c.52-3.88,17.47-14.62,17.47-14.62s3.76-1.51,2.51-4.14a21.16,21.16,0,0,1,1.82,1.18c.39.28.75.57,1.1.87,5,4.37,5.05,10.11,0,14.49-.34.29-.7.59-1.09.87a18.22,18.22,0,0,1-1.69,1.09,20.19,20.19,0,0,1-1.79.94q-.75.36-1.53.66c-.52.21-1,.4-1.59.58a34,34,0,0,1-5.06,1.21l-1.14.17a39.74,39.74,0,0,1-11.24-.19S457.22,417.75,456.73,415.2Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.71,398.84c6.33,3.65,6.58,9.48.77,13.31-.24.16-.5.32-.77.47-6.59,3.81-17.28,3.81-23.88,0s-6.59-10,0-13.78c.27-.16.55-.31.83-.45C456.29,395,466.39,395.19,472.71,398.84Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.71,398.84c6.33,3.65,6.58,9.48.77,13.31-.24.16-.5.32-.77.47-6.59,3.81-17.28,3.81-23.88,0s-6.59-10,0-13.78c.27-.16.55-.31.83-.45C456.29,395,466.39,395.19,472.71,398.84Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.18,399.14c6.3,3.64,6.3,9.54,0,13.18s-16.53,3.64-22.83,0-6.3-9.54,0-13.18S465.87,395.5,472.18,399.14Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.18,399.14c6.3,3.64,6.3,9.54,0,13.18s-16.53,3.64-22.83,0-6.3-9.54,0-13.18S465.87,395.5,472.18,399.14Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.18,401.74c-6.31-3.64-16.53-3.64-22.83,0-2.57,1.49-4.1,3.36-4.57,5.29.47,1.94,2,3.8,4.57,5.29,6.3,3.64,16.52,3.64,22.83,0,2.57-1.49,4.09-3.35,4.56-5.29C476.27,405.1,474.75,403.23,472.18,401.74Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.18,401.74c-6.31-3.64-16.53-3.64-22.83,0-2.57,1.49-4.1,3.36-4.57,5.29.47,1.94,2,3.8,4.57,5.29,6.3,3.64,16.52,3.64,22.83,0,2.57-1.49,4.09-3.35,4.56-5.29C476.27,405.1,474.75,403.23,472.18,401.74Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.93,408.54v-1.93c0-.79-.55-1.55-1.72-2.24l0,0a8.26,8.26,0,0,0-6.41-.58h0c-.85.21-1.66.49-2.39.74a23.78,23.78,0,0,1-2.56.79h0a4.4,4.4,0,0,1-1.22.11,2.57,2.57,0,0,1-1-.27l.08-.05.26-.16a5.19,5.19,0,0,1,.67-.33,4.62,4.62,0,0,1,3.59-.08l2.07-2.09v-1.92a9.83,9.83,0,0,0-5.66-.2,11.63,11.63,0,0,0-1.8.62l-2.06-1.2-2.47,1.43v1.92l.84.48a2.08,2.08,0,0,0-.36,1.12v1.91c0,.79.57,1.56,1.76,2.24a7.14,7.14,0,0,0,3.41,1h.68a13.7,13.7,0,0,0,3.67-.79l.71-.24-2.08,2.08v1.92a10.09,10.09,0,0,0,8-.35l2.05,1.18,2.47-1.42v-1.92l-.85-.49A2.2,2.2,0,0,0,470.93,408.54Zm-5.21-.17a5.1,5.1,0,0,1-.57.29,5.33,5.33,0,0,1-4,.06c1.93-.68,3.55-1.28,4.92-.55A2.36,2.36,0,0,1,465.72,408.37Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.76,403.76h0c-.85.21-1.66.49-2.39.74a23.78,23.78,0,0,1-2.56.79h0a4.4,4.4,0,0,1-1.22.11,2.45,2.45,0,0,1-1.17-.35c-.8-.46-.91-1.13.24-1.89l.26-.15a5.28,5.28,0,0,1,.67-.34,4.67,4.67,0,0,1,3.59-.08l2.07-2.09a9.83,9.83,0,0,0-5.66-.2,11.63,11.63,0,0,0-1.8.62l-2.06-1.2-2.47,1.43,2,1.18,0,0c-2.07,1.57-2.12,3.21.22,4.56a7.24,7.24,0,0,0,3.41,1h0c.23,0,.46,0,.68,0a13.7,13.7,0,0,0,3.67-.79c2.36-.8,4.28-1.73,5.88-.81,1.07.62.77,1.39-.4,2.07a5.1,5.1,0,0,1-.57.29,5.33,5.33,0,0,1-4.12,0l-2.16,2.17a10.14,10.14,0,0,0,8-.34l2.05,1.18,2.47-1.43-2.05-1.18c2.06-1.59,2.29-3.32-.1-4.72l0,0A8.26,8.26,0,0,0,462.76,403.76Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M462.76,403.76h0c-.85.21-1.66.49-2.39.74a23.78,23.78,0,0,1-2.56.79h0a4.4,4.4,0,0,1-1.22.11,2.45,2.45,0,0,1-1.17-.35c-.8-.46-.91-1.13.24-1.89l.26-.15a5.28,5.28,0,0,1,.67-.34,4.67,4.67,0,0,1,3.59-.08l2.07-2.09a9.83,9.83,0,0,0-5.66-.2,11.63,11.63,0,0,0-1.8.62l-2.06-1.2-2.47,1.43,2,1.18,0,0c-2.07,1.57-2.12,3.21.22,4.56a7.24,7.24,0,0,0,3.41,1h0c.23,0,.46,0,.68,0a13.7,13.7,0,0,0,3.67-.79c2.36-.8,4.28-1.73,5.88-.81,1.07.62.77,1.39-.4,2.07a5.1,5.1,0,0,1-.57.29,5.33,5.33,0,0,1-4.12,0l-2.16,2.17a10.14,10.14,0,0,0,8-.34l2.05,1.18,2.47-1.43-2.05-1.18c2.06-1.59,2.29-3.32-.1-4.72l0,0A8.26,8.26,0,0,0,462.76,403.76Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "450.24 401.16 452.73 400.03 454.77 400.93 452.71 399.74 450.24 401.16",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.29,400.39a11.61,11.61,0,0,1,5.3.17l-1.43,2,2.07-2.09A9.83,9.83,0,0,0,456.29,400.39Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.17,404.34l0,0c2.39,1.4,2.16,3.13.1,4.72,1.82-2,1.5-3.36-.48-4.5a9.33,9.33,0,0,0-6.07-.83A8.26,8.26,0,0,1,469.17,404.34Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "469.31 409.09 470.88 410.3 468.89 411.7 471.36 410.27 469.31 409.09",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.15,408.66a5.3,5.3,0,0,1-3.94.34l-2.34,1.86,2.16-2.17A5.33,5.33,0,0,0,465.15,408.66Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.79,405.3a3.25,3.25,0,0,1-3-.28c-.71-.62-.25-1.28.81-1.85-1.15.76-1,1.43-.24,1.89a2.45,2.45,0,0,0,1.17.35A4.4,4.4,0,0,0,457.79,405.3Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.26,402.36c-.17.15-1.66,1.54-1,2.92s2.87,2.43,4.63,2.62h0a7.24,7.24,0,0,1-3.41-1C450.14,405.57,450.19,403.93,452.26,402.36Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "439.22 403.27 439.84 398.61 440.45 403.27 448.53 403.63 440.45 403.98 439.84 408.64 439.22 403.98 431.14 403.63 439.22 403.27",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-104"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M390.69,438.05a15.76,15.76,0,0,1,5.83-5.39c9.52-5.49,25-5.49,34.47,0a15.76,15.76,0,0,1,5.83,5.39h1.32v5h0c-.18,3.46-2.55,6.9-7.13,9.54-9.52,5.5-24.95,5.5-34.47,0-4.58-2.64-7-6.08-7.14-9.54h0v-5Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.69,438.05a15.76,15.76,0,0,1,5.83-5.39c9.52-5.49,25-5.49,34.47,0a15.76,15.76,0,0,1,5.83,5.39h1.32v5h0c-.18,3.46-2.55,6.9-7.13,9.54-9.52,5.5-24.95,5.5-34.47,0-4.58-2.64-7-6.08-7.14-9.54h0v-5Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.75,428.54c6.24,0,12.48,1.38,17.24,4.12a15.76,15.76,0,0,1,5.83,5.39h1.32v5h0c-.18,3.46-2.55,6.9-7.13,9.54-4.76,2.75-11,4.12-17.24,4.12Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.07,430.83a26.11,26.11,0,0,1,3.92,1.83,15.76,15.76,0,0,1,5.83,5.39h1.32v5h0c-.18,3.46-2.55,6.9-7.13,9.54a27.17,27.17,0,0,1-3.92,1.84Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.44,430.83a26.58,26.58,0,0,0-3.92,1.83,15.76,15.76,0,0,0-5.83,5.39h-1.31v5h0c.17,3.46,2.56,6.9,7.14,9.54a27.68,27.68,0,0,0,3.92,1.84Z",
    style: {
      fill: "#8E4DFE",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431,428.1c9.52,5.5,9.51,14.41,0,19.91-8.34,4.8-21.19,5.41-30.66,1.8h0l-.38-.15a26.62,26.62,0,0,1-3.44-1.65c-7.94-4.59-9.26-11.55-4-16.92h0a18.32,18.32,0,0,1,3.95-3C406,422.6,421.47,422.6,431,428.1Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431,428.1c9.52,5.5,9.51,14.41,0,19.91-8.34,4.8-21.19,5.41-30.66,1.8h0l-.38-.15a26.62,26.62,0,0,1-3.44-1.65c-7.94-4.59-9.26-11.55-4-16.92h0a18.32,18.32,0,0,1,3.95-3C406,422.6,421.47,422.6,431,428.1Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.56,431.09a10.68,10.68,0,0,0-2.55,8.68c.85,4.84,7.62,8.91,9.95,9.89a26.62,26.62,0,0,1-3.44-1.65C388.58,443.42,387.26,436.46,392.56,431.09Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435,445a10.69,10.69,0,0,0,2.55-8.69c-.84-4.84-7.62-8.91-9.95-9.89A28,28,0,0,1,431,428.1C438.93,432.68,440.25,439.64,435,445Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 413.77,
    cy: 438.03,
    rx: 22.66,
    ry: 13.08,
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 413.77,
    cy: 438.03,
    rx: 22.66,
    ry: 13.08,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.13,441.94c-1.82-3.37-1.22-7.08,1.78-10.23a16,16,0,0,1,1.92-1.68,20.21,20.21,0,0,1,1.84-1.21q.54-.31,1.11-.6c-.94,1.55-.59,3.21,4.74,3.52,10.45.61-2.79,10.59-2.79,10.59S394,439.08,392.13,441.94Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.21,439.18c-1.57-.18-2.34-1.79-1.74-3.6a4.16,4.16,0,0,1,3.95-3c1.56.18,2.34,1.79,1.73,3.61S394.78,439.36,393.21,439.18Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.73,447.5c.52-3.88,17.47-14.62,17.47-14.62s3.76-1.51,2.51-4.14a21.16,21.16,0,0,1,1.82,1.18c.39.28.75.57,1.1.87,5.05,4.37,5.05,10.11,0,14.49-.35.29-.71.59-1.1.87a18.22,18.22,0,0,1-1.69,1.09c-.57.34-1.17.65-1.79.95s-1,.45-1.53.65-1,.4-1.59.58a32.77,32.77,0,0,1-5.06,1.21l-1.14.17a39.74,39.74,0,0,1-11.24-.19S410.22,450.05,409.73,447.5Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.73,447.5c.52-3.88,17.47-14.62,17.47-14.62s3.76-1.51,2.51-4.14a21.16,21.16,0,0,1,1.82,1.18c.39.28.75.57,1.1.87,5.05,4.37,5.05,10.11,0,14.49-.35.29-.71.59-1.1.87a18.22,18.22,0,0,1-1.69,1.09c-.57.34-1.17.65-1.79.95s-1,.45-1.53.65-1,.4-1.59.58a32.77,32.77,0,0,1-5.06,1.21l-1.14.17a39.74,39.74,0,0,1-11.24-.19S410.22,450.05,409.73,447.5Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.71,431.14c6.33,3.65,6.58,9.48.77,13.31-.24.16-.5.32-.77.48-6.59,3.8-17.28,3.8-23.87,0s-6.6-10,0-13.79l.83-.45C409.29,427.34,419.39,427.49,425.71,431.14Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.71,431.14c6.33,3.65,6.58,9.48.77,13.31-.24.16-.5.32-.77.48-6.59,3.8-17.28,3.8-23.87,0s-6.6-10,0-13.79l.83-.45C409.29,427.34,419.39,427.49,425.71,431.14Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 413.76,
    cy: 438.03,
    rx: 16.14,
    ry: 9.32,
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 413.76,
    cy: 438.03,
    rx: 16.14,
    ry: 9.32,
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.18,434c-6.31-3.64-16.52-3.64-22.83,0-2.57,1.49-4.1,3.36-4.57,5.29.47,1.94,2,3.8,4.57,5.29,6.31,3.64,16.52,3.64,22.83,0,2.57-1.49,4.09-3.35,4.56-5.29C429.27,437.4,427.75,435.53,425.18,434Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.18,434c-6.31-3.64-16.52-3.64-22.83,0-2.57,1.49-4.1,3.36-4.57,5.29.47,1.94,2,3.8,4.57,5.29,6.31,3.64,16.52,3.64,22.83,0,2.57-1.49,4.09-3.35,4.56-5.29C429.27,437.4,427.75,435.53,425.18,434Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.93,440.84v-1.93c0-.79-.55-1.55-1.72-2.24l0,0a8.31,8.31,0,0,0-6.41-.58h0c-.85.21-1.66.49-2.39.74a26.73,26.73,0,0,1-2.56.8h0a4.4,4.4,0,0,1-1.22.11,2.79,2.79,0,0,1-1-.26l.08-.06.26-.16a5.19,5.19,0,0,1,.67-.33,4.67,4.67,0,0,1,3.59-.08l2.07-2.09v-1.92a9.83,9.83,0,0,0-5.66-.2,11.63,11.63,0,0,0-1.8.62L405.71,432l-2.47,1.42v1.92l.84.49a2,2,0,0,0-.36,1.11v1.91c0,.8.57,1.56,1.76,2.25a7.24,7.24,0,0,0,3.41,1h0c.23,0,.46,0,.68,0a13.33,13.33,0,0,0,3.67-.79l.71-.24-2.08,2.09v1.91a10.17,10.17,0,0,0,8-.34l2,1.17,2.47-1.42v-1.92l-.85-.49A2.2,2.2,0,0,0,423.93,440.84Zm-5.21-.17a5.1,5.1,0,0,1-.57.29,5.29,5.29,0,0,1-4,.06c1.93-.68,3.55-1.28,4.92-.55A2.36,2.36,0,0,1,418.72,440.67Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.76,436.06h0c-.85.21-1.66.49-2.39.74a26.73,26.73,0,0,1-2.56.8h0a4.4,4.4,0,0,1-1.22.11,2.49,2.49,0,0,1-1.17-.35c-.8-.46-.91-1.13.24-1.89l.26-.15a7,7,0,0,1,.67-.34,4.71,4.71,0,0,1,3.59-.08l2.07-2.09a9.83,9.83,0,0,0-5.66-.2,11.63,11.63,0,0,0-1.8.62L405.71,432l-2.47,1.42,2,1.18,0,0c-2.07,1.58-2.12,3.21.22,4.56a7.24,7.24,0,0,0,3.41,1h.68a13.7,13.7,0,0,0,3.67-.79c2.37-.79,4.28-1.73,5.88-.81,1.07.62.77,1.4-.4,2.07a5.1,5.1,0,0,1-.57.29,5.33,5.33,0,0,1-4.12,0l-2.16,2.18a10.21,10.21,0,0,0,8-.35l2,1.18,2.47-1.43-2.05-1.18c2.06-1.59,2.3-3.32-.1-4.72l0,0A8.31,8.31,0,0,0,415.76,436.06Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M415.76,436.06h0c-.85.21-1.66.49-2.39.74a26.73,26.73,0,0,1-2.56.8h0a4.4,4.4,0,0,1-1.22.11,2.49,2.49,0,0,1-1.17-.35c-.8-.46-.91-1.13.24-1.89l.26-.15a7,7,0,0,1,.67-.34,4.71,4.71,0,0,1,3.59-.08l2.07-2.09a9.83,9.83,0,0,0-5.66-.2,11.63,11.63,0,0,0-1.8.62L405.71,432l-2.47,1.42,2,1.18,0,0c-2.07,1.58-2.12,3.21.22,4.56a7.24,7.24,0,0,0,3.41,1h.68a13.7,13.7,0,0,0,3.67-.79c2.37-.79,4.28-1.73,5.88-.81,1.07.62.77,1.4-.4,2.07a5.1,5.1,0,0,1-.57.29,5.33,5.33,0,0,1-4.12,0l-2.16,2.18a10.21,10.21,0,0,0,8-.35l2,1.18,2.47-1.43-2.05-1.18c2.06-1.59,2.3-3.32-.1-4.72l0,0A8.31,8.31,0,0,0,415.76,436.06Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "403.24 433.46 405.73 432.33 407.77 433.23 405.71 432.04 403.24 433.46",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.29,432.69a11.49,11.49,0,0,1,5.3.18l-1.43,2,2.07-2.09A9.83,9.83,0,0,0,409.29,432.69Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.17,436.64l0,0c2.4,1.4,2.16,3.13.1,4.72,1.82-2,1.5-3.36-.48-4.5a9.33,9.33,0,0,0-6.07-.83A8.31,8.31,0,0,1,422.17,436.64Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "422.31 441.39 423.88 442.6 421.89 444 424.36 442.57 422.31 441.39",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.15,441a5.3,5.3,0,0,1-3.94.34l-2.34,1.87L414,441A5.33,5.33,0,0,0,418.15,441Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.79,437.6a3.25,3.25,0,0,1-3-.28c-.71-.62-.25-1.27.81-1.85-1.15.76-1,1.43-.24,1.89a2.49,2.49,0,0,0,1.17.35A4.4,4.4,0,0,0,410.79,437.6Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.26,434.66c-.17.15-1.66,1.54-1,2.92s2.87,2.43,4.63,2.62h0a7.24,7.24,0,0,1-3.41-1C403.14,437.87,403.19,436.24,405.26,434.66Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.22 435.57 392.84 430.91 393.45 435.57 401.53 435.93 393.45 436.28 392.84 440.94 392.22 436.28 384.15 435.93 392.22 435.57",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coins-1--inject-104"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-104"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.85,419.16A15.63,15.63,0,0,0,67,413.78c-9.52-5.5-25-5.5-34.48,0a15.63,15.63,0,0,0-5.82,5.38H25.41v5h0c.17,3.47,2.54,6.9,7.12,9.54,9.52,5.5,25,5.5,34.48,0,4.58-2.64,7-6.07,7.14-9.54h0v-5Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.85,419.16A15.63,15.63,0,0,0,67,413.78c-9.52-5.5-25-5.5-34.48,0a15.63,15.63,0,0,0-5.82,5.38H25.41v5h0c.17,3.47,2.54,6.9,7.12,9.54,9.52,5.5,25,5.5,34.48,0,4.58-2.64,7-6.07,7.14-9.54h0v-5Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.79,409.65c-6.24,0-12.48,1.38-17.24,4.13a15.63,15.63,0,0,0-5.82,5.38H25.41v5h0c.17,3.47,2.54,6.9,7.12,9.54,4.76,2.75,11,4.12,17.24,4.12Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.47,411.94a26.09,26.09,0,0,0-3.92,1.84,15.63,15.63,0,0,0-5.82,5.38H25.41v5h0c.17,3.47,2.54,6.9,7.12,9.54a26.09,26.09,0,0,0,3.92,1.84Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1,411.94A25.75,25.75,0,0,1,67,413.78a15.63,15.63,0,0,1,5.82,5.38h1.32v5h0c-.18,3.47-2.56,6.9-7.14,9.54a25.75,25.75,0,0,1-3.93,1.84Z",
    style: {
      fill: "#8E4DFE",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.55,409.21c-9.52,5.5-9.52,14.41,0,19.91,8.33,4.81,21.19,5.41,30.65,1.8h0l.38-.15A26.76,26.76,0,0,0,67,429.12c7.94-4.59,9.26-11.55,4-16.92h0a18.32,18.32,0,0,0-4-3C57.51,403.72,42.07,403.71,32.55,409.21Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.55,409.21c-9.52,5.5-9.52,14.41,0,19.91,8.33,4.81,21.19,5.41,30.65,1.8h0l.38-.15A26.76,26.76,0,0,0,67,429.12c7.94-4.59,9.26-11.55,4-16.92h0a18.32,18.32,0,0,0-4-3C57.51,403.72,42.07,403.71,32.55,409.21Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71,412.2a10.62,10.62,0,0,1,2.55,8.69c-.84,4.83-7.61,8.91-10,9.88A26.76,26.76,0,0,0,67,429.12C75,424.53,76.29,417.57,71,412.2Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6,426.13a10.62,10.62,0,0,1-2.55-8.69c.84-4.83,7.61-8.91,10-9.88a26.76,26.76,0,0,0-3.45,1.65C24.61,413.8,23.29,420.75,28.6,426.13Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.82,428.4c8.85-5.11,8.85-13.4,0-18.51s-23.2-5.11-32,0-8.85,13.4,0,18.51S57,433.51,65.82,428.4Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.82,428.4c8.85-5.11,8.85-13.4,0-18.51s-23.2-5.11-32,0-8.85,13.4,0,18.51S57,433.51,65.82,428.4Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.43,423.05c1.82-3.36,1.23-7.08-1.78-10.22a14.57,14.57,0,0,0-1.92-1.69,20,20,0,0,0-1.83-1.21c-.36-.21-.74-.41-1.12-.6.94,1.55.6,3.21-4.74,3.52-10.44.61,2.79,10.59,2.79,10.59S69.56,420.19,71.43,423.05Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.35,420.29c1.57-.17,2.35-1.79,1.74-3.6s-2.38-3.14-3.94-3-2.35,1.78-1.74,3.6S68.79,420.47,70.35,420.29Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.83,428.61C53.32,424.73,36.36,414,36.36,414s-3.76-1.51-2.51-4.13A17.63,17.63,0,0,0,32,411c-.39.28-.76.57-1.1.87-5.05,4.37-5.06,10.11,0,14.49.34.3.71.59,1.1.87a19.51,19.51,0,0,0,1.68,1.1c.57.33,1.17.65,1.8.94s1,.45,1.52.66,1.05.39,1.59.57a32.77,32.77,0,0,0,5.06,1.21l1.14.17a40.44,40.44,0,0,0,5.06.32,39.64,39.64,0,0,0,6.18-.51S53.35,431.16,53.83,428.61Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.83,428.61C53.32,424.73,36.36,414,36.36,414s-3.76-1.51-2.51-4.13A17.63,17.63,0,0,0,32,411c-.39.28-.76.57-1.1.87-5.05,4.37-5.06,10.11,0,14.49.34.3.71.59,1.1.87a19.51,19.51,0,0,0,1.68,1.1c.57.33,1.17.65,1.8.94s1,.45,1.52.66,1.05.39,1.59.57a32.77,32.77,0,0,0,5.06,1.21l1.14.17a40.44,40.44,0,0,0,5.06.32,39.64,39.64,0,0,0,6.18-.51S53.35,431.16,53.83,428.61Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.85,412.25c-6.32,3.65-6.58,9.48-.77,13.31l.77.48c6.6,3.8,17.28,3.8,23.88,0s6.59-10,0-13.79l-.83-.45C54.27,408.45,44.18,408.6,37.85,412.25Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.85,412.25c-6.32,3.65-6.58,9.48-.77,13.31l.77.48c6.6,3.8,17.28,3.8,23.88,0s6.59-10,0-13.79l-.83-.45C54.27,408.45,44.18,408.6,37.85,412.25Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.39,412.56c-6.3,3.63-6.3,9.53,0,13.17s16.52,3.64,22.82,0,6.3-9.54,0-13.17S44.69,408.92,38.39,412.56Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.39,412.56c-6.3,3.63-6.3,9.53,0,13.17s16.52,3.64,22.82,0,6.3-9.54,0-13.17S44.69,408.92,38.39,412.56Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.39,415.15c6.3-3.63,16.52-3.63,22.82,0,2.58,1.49,4.1,3.36,4.57,5.29-.47,1.94-2,3.8-4.57,5.29-6.3,3.64-16.52,3.64-22.82,0-2.58-1.49-4.1-3.35-4.57-5.29C34.29,418.51,35.81,416.64,38.39,415.15Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.39,415.15c6.3-3.63,16.52-3.63,22.82,0,2.58,1.49,4.1,3.36,4.57,5.29-.47,1.94-2,3.8-4.57,5.29-6.3,3.64-16.52,3.64-22.82,0-2.58-1.49-4.1-3.35-4.57-5.29C34.29,418.51,35.81,416.64,38.39,415.15Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,422V420c0-.79-.55-1.55-1.72-2.24l0,0a8.28,8.28,0,0,0-6.4-.58h0c-.85.22-1.65.49-2.39.74a23.44,23.44,0,0,1-2.56.8h0a4.36,4.36,0,0,1-1.21.11,2.52,2.52,0,0,1-1-.26l.08-.06.25-.15a4.31,4.31,0,0,1,.68-.34,4.64,4.64,0,0,1,3.58-.08l2.07-2.09v-1.92a9.88,9.88,0,0,0-5.65-.2,11.28,11.28,0,0,0-1.8.62l-2.07-1.19-2.47,1.42v1.92l.85.49a2,2,0,0,0-.37,1.11c0,.32,0,1.59,0,1.92,0,.79.57,1.55,1.76,2.24a7.27,7.27,0,0,0,3.41,1h.69a13.55,13.55,0,0,0,3.66-.8l.71-.24-2.08,2.09v1.91a10.17,10.17,0,0,0,8-.34l2,1.18,2.47-1.43v-1.91l-.85-.49A2.25,2.25,0,0,0,60,422Zm-5.21-.16a5,5,0,0,1-.57.28,5.29,5.29,0,0,1-4,.06c1.94-.68,3.55-1.28,4.93-.54Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8,417.17h0c-.85.22-1.65.49-2.39.74a23.44,23.44,0,0,1-2.56.8h0a4.36,4.36,0,0,1-1.21.11,2.52,2.52,0,0,1-1.18-.35c-.79-.45-.91-1.13.25-1.88l.25-.16a7.18,7.18,0,0,1,.68-.34,4.69,4.69,0,0,1,3.58-.08l2.07-2.09a9.88,9.88,0,0,0-5.65-.2,11.28,11.28,0,0,0-1.8.62l-2.07-1.19-2.47,1.42,2,1.18v0c-2.08,1.58-2.12,3.21.21,4.56a7.16,7.16,0,0,0,3.41,1h.69a13.55,13.55,0,0,0,3.66-.79c2.37-.79,4.29-1.73,5.88-.81,1.07.62.78,1.4-.4,2.08a5,5,0,0,1-.57.28,5.26,5.26,0,0,1-4.11,0l-2.17,2.18a10.12,10.12,0,0,0,8-.35l2,1.18,2.47-1.42-2-1.18c2-1.59,2.29-3.32-.11-4.73l0,0A8.28,8.28,0,0,0,51.8,417.17Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.8,417.17h0c-.85.22-1.65.49-2.39.74a23.44,23.44,0,0,1-2.56.8h0a4.36,4.36,0,0,1-1.21.11,2.52,2.52,0,0,1-1.18-.35c-.79-.45-.91-1.13.25-1.88l.25-.16a7.18,7.18,0,0,1,.68-.34,4.69,4.69,0,0,1,3.58-.08l2.07-2.09a9.88,9.88,0,0,0-5.65-.2,11.28,11.28,0,0,0-1.8.62l-2.07-1.19-2.47,1.42,2,1.18v0c-2.08,1.58-2.12,3.21.21,4.56a7.16,7.16,0,0,0,3.41,1h.69a13.55,13.55,0,0,0,3.66-.79c2.37-.79,4.29-1.73,5.88-.81,1.07.62.78,1.4-.4,2.08a5,5,0,0,1-.57.28,5.26,5.26,0,0,1-4.11,0l-2.17,2.18a10.12,10.12,0,0,0,8-.35l2,1.18,2.47-1.42-2-1.18c2-1.59,2.29-3.32-.11-4.73l0,0A8.28,8.28,0,0,0,51.8,417.17Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "39.27 414.57 41.76 413.44 43.81 414.34 41.74 413.15 39.27 414.57",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.32,413.8a11.53,11.53,0,0,1,5.31.18l-1.44,2,2.07-2.08A9.76,9.76,0,0,0,45.32,413.8Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2,417.75l0,0c2.4,1.41,2.16,3.14.11,4.73,1.82-2,1.49-3.37-.49-4.51a9.31,9.31,0,0,0-6.06-.83A8.28,8.28,0,0,1,58.2,417.75Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "58.35 422.51 59.91 423.71 57.92 425.11 60.39 423.69 58.35 422.51",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.18,422.07a5.34,5.34,0,0,1-3.94.35l-2.34,1.86,2.17-2.18A5.26,5.26,0,0,0,54.18,422.07Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.82,418.71a3.2,3.2,0,0,1-3-.28c-.72-.62-.26-1.27.81-1.84-1.16.75-1,1.43-.25,1.88a2.52,2.52,0,0,0,1.18.35A4.36,4.36,0,0,0,46.82,418.71Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3,415.77c-.18.16-1.67,1.54-1,2.93s2.88,2.42,4.63,2.61h0a7.16,7.16,0,0,1-3.41-1C39.18,419,39.22,417.35,41.3,415.77Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coins--inject-104"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-104"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.12,424.84a15.76,15.76,0,0,0-5.83-5.39c-9.52-5.49-24.95-5.49-34.47,0A15.76,15.76,0,0,0,21,424.84H19.68v5h0c.18,3.46,2.55,6.89,7.13,9.54,9.52,5.49,25,5.49,34.47,0,4.58-2.64,7-6.08,7.14-9.54h0v-5Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.12,424.84a15.76,15.76,0,0,0-5.83-5.39c-9.52-5.49-24.95-5.49-34.47,0A15.76,15.76,0,0,0,21,424.84H19.68v5h0c.18,3.46,2.55,6.89,7.13,9.54,9.52,5.49,25,5.49,34.47,0,4.58-2.64,7-6.08,7.14-9.54h0v-5Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.06,415.33c-6.24,0-12.48,1.37-17.24,4.12A15.76,15.76,0,0,0,21,424.84H19.68v5h0c.18,3.46,2.55,6.89,7.13,9.54,4.76,2.75,11,4.12,17.24,4.12Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.74,417.62a26.11,26.11,0,0,0-3.92,1.83A15.76,15.76,0,0,0,21,424.84H19.68v5h0c.18,3.46,2.55,6.89,7.13,9.54a27.17,27.17,0,0,0,3.92,1.84Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.37,417.62a26.58,26.58,0,0,1,3.92,1.83,15.76,15.76,0,0,1,5.83,5.39h1.31v5h0c-.17,3.46-2.56,6.89-7.14,9.54a27.68,27.68,0,0,1-3.92,1.84Z",
    style: {
      fill: "#8E4DFE",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.82,414.89c-9.53,5.49-9.52,14.41,0,19.9,8.33,4.81,21.18,5.41,30.65,1.81h0l.38-.15a25.42,25.42,0,0,0,3.44-1.66c7.94-4.58,9.26-11.54,4-16.91h0a18.65,18.65,0,0,0-4-3C51.77,409.39,36.34,409.39,26.82,414.89Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.82,414.89c-9.53,5.49-9.52,14.41,0,19.9,8.33,4.81,21.18,5.41,30.65,1.81h0l.38-.15a25.42,25.42,0,0,0,3.44-1.66c7.94-4.58,9.26-11.54,4-16.91h0a18.65,18.65,0,0,0-4-3C51.77,409.39,36.34,409.39,26.82,414.89Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.25,417.88a10.66,10.66,0,0,1,2.55,8.68c-.85,4.84-7.62,8.91-9.95,9.89a25.42,25.42,0,0,0,3.44-1.66C69.23,430.21,70.55,423.25,65.25,417.88Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.86,431.8a10.66,10.66,0,0,1-2.55-8.68c.84-4.84,7.62-8.91,10-9.89a26.67,26.67,0,0,0-3.44,1.66C18.88,419.47,17.56,426.43,22.86,431.8Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.09,434.07c8.85-5.11,8.85-13.39,0-18.5s-23.2-5.11-32.05,0-8.85,13.39,0,18.5S51.24,439.18,60.09,434.07Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.09,434.07c8.85-5.11,8.85-13.39,0-18.5s-23.2-5.11-32.05,0-8.85,13.39,0,18.5S51.24,439.18,60.09,434.07Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7,428.73c1.82-3.37,1.22-7.08-1.78-10.23A16,16,0,0,0,62,416.82a20.21,20.21,0,0,0-1.84-1.21q-.54-.32-1.11-.6c.94,1.55.59,3.21-4.74,3.52-10.45.61,2.79,10.59,2.79,10.59S63.83,425.87,65.7,428.73Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.62,426c1.57-.18,2.34-1.79,1.73-3.6a4.14,4.14,0,0,0-3.94-3c-1.57.18-2.34,1.79-1.73,3.6A4.14,4.14,0,0,0,64.62,426Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1,434.29c-.52-3.88-17.47-14.62-17.47-14.62s-3.76-1.51-2.51-4.14c-.66.38-1.26.77-1.82,1.17-.39.29-.76.58-1.1.88-5.05,4.37-5.05,10.11,0,14.49.34.29.71.58,1.1.87A19.46,19.46,0,0,0,28,434c.58.34,1.18.65,1.8.94s1,.46,1.53.66,1.05.4,1.59.57A32.79,32.79,0,0,0,38,437.42l1.13.17a38.73,38.73,0,0,0,5.06.31,37.38,37.38,0,0,0,6.19-.51S47.61,436.84,48.1,434.29Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1,434.29c-.52-3.88-17.47-14.62-17.47-14.62s-3.76-1.51-2.51-4.14c-.66.38-1.26.77-1.82,1.17-.39.29-.76.58-1.1.88-5.05,4.37-5.05,10.11,0,14.49.34.29.71.58,1.1.87A19.46,19.46,0,0,0,28,434c.58.34,1.18.65,1.8.94s1,.46,1.53.66,1.05.4,1.59.57A32.79,32.79,0,0,0,38,437.42l1.13.17a38.73,38.73,0,0,0,5.06.31,37.38,37.38,0,0,0,6.19-.51S47.61,436.84,48.1,434.29Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.12,417.93c-6.33,3.65-6.58,9.48-.77,13.3a8.36,8.36,0,0,0,.77.48c6.59,3.81,17.28,3.81,23.87,0s6.6-10,0-13.78c-.27-.16-.55-.31-.83-.45C48.53,414.13,38.44,414.28,32.12,417.93Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.12,417.93c-6.33,3.65-6.58,9.48-.77,13.3a8.36,8.36,0,0,0,.77.48c6.59,3.81,17.28,3.81,23.87,0s6.6-10,0-13.78c-.27-.16-.55-.31-.83-.45C48.53,414.13,38.44,414.28,32.12,417.93Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.65,418.23c-6.3,3.64-6.3,9.54,0,13.18s16.52,3.64,22.83,0,6.3-9.54,0-13.18S39,414.59,32.65,418.23Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.65,418.23c-6.3,3.64-6.3,9.54,0,13.18s16.52,3.64,22.83,0,6.3-9.54,0-13.18S39,414.59,32.65,418.23Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.65,420.83c6.31-3.64,16.52-3.64,22.83,0,2.57,1.49,4.09,3.35,4.56,5.29-.47,1.93-2,3.8-4.56,5.29-6.31,3.64-16.52,3.64-22.83,0-2.57-1.49-4.1-3.36-4.57-5.29C28.55,424.18,30.08,422.32,32.65,420.83Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.65,420.83c6.31-3.64,16.52-3.64,22.83,0,2.57,1.49,4.09,3.35,4.56,5.29-.47,1.93-2,3.8-4.56,5.29-6.31,3.64-16.52,3.64-22.83,0-2.57-1.49-4.1-3.36-4.57-5.29C28.55,424.18,30.08,422.32,32.65,420.83Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.23,427.63c0-.32,0-1.6,0-1.93,0-.79-.55-1.56-1.73-2.24l0,0a8.23,8.23,0,0,0-6.4-.58h0c-.85.21-1.66.49-2.39.74a23.19,23.19,0,0,1-2.57.79h0a4.89,4.89,0,0,1-1.22.11,2.53,2.53,0,0,1-1-.27l.08-.05a2.26,2.26,0,0,1,.26-.16,5.19,5.19,0,0,1,.67-.33,4.67,4.67,0,0,1,3.59-.09l2.07-2.08V419.6a9.83,9.83,0,0,0-5.66-.2,11.63,11.63,0,0,0-1.8.62L36,418.82l-2.47,1.43v1.91l.85.49a2.08,2.08,0,0,0-.36,1.12v1.91c0,.79.57,1.56,1.76,2.24a7.26,7.26,0,0,0,3.41,1h0c.23,0,.46,0,.68,0a13.55,13.55,0,0,0,3.66-.79l.72-.25L42.16,430v1.92a10.12,10.12,0,0,0,8-.35l2,1.18,2.47-1.42v-1.92l-.85-.49A2.28,2.28,0,0,0,54.23,427.63ZM49,427.46a5.1,5.1,0,0,1-.57.29,5.33,5.33,0,0,1-4,.06c1.93-.68,3.55-1.28,4.92-.55A2.36,2.36,0,0,1,49,427.46Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.06,422.85h0c-.85.21-1.66.49-2.39.74a23.19,23.19,0,0,1-2.57.79h0a4.89,4.89,0,0,1-1.22.11,2.45,2.45,0,0,1-1.17-.35c-.8-.46-.91-1.13.24-1.89l.26-.15a5.28,5.28,0,0,1,.67-.34,4.67,4.67,0,0,1,3.59-.08l2.07-2.09a9.83,9.83,0,0,0-5.66-.2,11.63,11.63,0,0,0-1.8.62L36,418.82l-2.47,1.43,2,1.18,0,0c-2.07,1.57-2.12,3.21.22,4.56a7.24,7.24,0,0,0,3.41,1h.68a13.93,13.93,0,0,0,3.66-.79c2.37-.8,4.29-1.73,5.89-.81,1.07.62.77,1.39-.4,2.07a5.1,5.1,0,0,1-.57.29,5.33,5.33,0,0,1-4.12,0L42.16,430a10.17,10.17,0,0,0,8-.34l2,1.18,2.47-1.43-2-1.18c2.06-1.59,2.29-3.32-.11-4.72l0,0A8.23,8.23,0,0,0,46.06,422.85Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.06,422.85h0c-.85.21-1.66.49-2.39.74a23.19,23.19,0,0,1-2.57.79h0a4.89,4.89,0,0,1-1.22.11,2.45,2.45,0,0,1-1.17-.35c-.8-.46-.91-1.13.24-1.89l.26-.15a5.28,5.28,0,0,1,.67-.34,4.67,4.67,0,0,1,3.59-.08l2.07-2.09a9.83,9.83,0,0,0-5.66-.2,11.63,11.63,0,0,0-1.8.62L36,418.82l-2.47,1.43,2,1.18,0,0c-2.07,1.57-2.12,3.21.22,4.56a7.24,7.24,0,0,0,3.41,1h.68a13.93,13.93,0,0,0,3.66-.79c2.37-.8,4.29-1.73,5.89-.81,1.07.62.77,1.39-.4,2.07a5.1,5.1,0,0,1-.57.29,5.33,5.33,0,0,1-4.12,0L42.16,430a10.17,10.17,0,0,0,8-.34l2,1.18,2.47-1.43-2-1.18c2.06-1.59,2.29-3.32-.11-4.72l0,0A8.23,8.23,0,0,0,46.06,422.85Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "33.54 420.25 36.03 419.12 38.07 420.02 36.01 418.82 33.54 420.25",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.59,419.47a11.62,11.62,0,0,1,5.3.18l-1.43,2,2.07-2.09A9.92,9.92,0,0,0,39.59,419.47Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.46,423.43l0,0c2.4,1.4,2.17,3.13.11,4.72,1.82-2,1.49-3.36-.48-4.51a9.39,9.39,0,0,0-6.07-.82A8.23,8.23,0,0,1,52.46,423.43Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "52.61 428.18 54.18 429.39 52.19 430.79 54.66 429.36 52.61 428.18",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.45,427.75a5.3,5.3,0,0,1-3.94.34L42.16,430l2.17-2.17A5.33,5.33,0,0,0,48.45,427.75Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.09,424.39a3.22,3.22,0,0,1-3-.29c-.71-.61-.25-1.27.81-1.84-1.15.76-1,1.43-.24,1.89a2.45,2.45,0,0,0,1.17.35A4.89,4.89,0,0,0,41.09,424.39Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.56,421.45c-.17.15-1.66,1.54-1,2.92s2.87,2.43,4.63,2.62h0a7.24,7.24,0,0,1-3.41-1C33.44,424.66,33.49,423,35.56,421.45Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-104"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.53,409.85a15.79,15.79,0,0,0-5.82-5.38c-9.53-5.5-25-5.5-34.48,0a15.75,15.75,0,0,0-5.83,5.38H23.09v5h0c.17,3.47,2.54,6.9,7.12,9.54,9.52,5.5,25,5.5,34.48,0,4.57-2.64,7-6.07,7.14-9.54h0v-5Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.53,409.85a15.79,15.79,0,0,0-5.82-5.38c-9.53-5.5-25-5.5-34.48,0a15.75,15.75,0,0,0-5.83,5.38H23.09v5h0c.17,3.47,2.54,6.9,7.12,9.54,9.52,5.5,25,5.5,34.48,0,4.57-2.64,7-6.07,7.14-9.54h0v-5Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.47,400.34c-6.24,0-12.48,1.38-17.24,4.13a15.75,15.75,0,0,0-5.83,5.38H23.09v5h0c.18,3.47,2.55,6.9,7.13,9.54,4.76,2.75,11,4.12,17.24,4.12Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.15,402.63a25.64,25.64,0,0,0-3.92,1.84,15.75,15.75,0,0,0-5.83,5.38H23.09v5h0c.18,3.47,2.55,6.9,7.13,9.54a26.62,26.62,0,0,0,3.92,1.84Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.78,402.63a25.75,25.75,0,0,1,3.93,1.84,15.79,15.79,0,0,1,5.82,5.38h1.32v5h0c-.18,3.47-2.57,6.9-7.14,9.54a26.74,26.74,0,0,1-3.93,1.84Z",
    style: {
      fill: "#8E4DFE",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.23,399.9c-9.52,5.5-9.52,14.41,0,19.91,8.33,4.81,21.19,5.41,30.65,1.8h0l.38-.15a26.76,26.76,0,0,0,3.45-1.65c7.93-4.59,9.25-11.55,4-16.92h0a18.57,18.57,0,0,0-4-3C55.19,394.4,39.75,394.4,30.23,399.9Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.23,399.9c-9.52,5.5-9.52,14.41,0,19.91,8.33,4.81,21.19,5.41,30.65,1.8h0l.38-.15a26.76,26.76,0,0,0,3.45-1.65c7.93-4.59,9.25-11.55,4-16.92h0a18.57,18.57,0,0,0-4-3C55.19,394.4,39.75,394.4,30.23,399.9Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.66,402.89a10.69,10.69,0,0,1,2.55,8.69c-.84,4.83-7.62,8.9-9.95,9.88a26.76,26.76,0,0,0,3.45-1.65C72.64,415.22,74,408.26,68.66,402.89Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.27,416.82a10.69,10.69,0,0,1-2.55-8.69c.85-4.84,7.62-8.91,10-9.89a27.5,27.5,0,0,0-3.45,1.66C22.29,404.48,21,411.44,26.27,416.82Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5,419.09c8.85-5.11,8.85-13.4,0-18.51s-23.2-5.11-32,0-8.85,13.4,0,18.51S54.65,424.2,63.5,419.09Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5,419.09c8.85-5.11,8.85-13.4,0-18.51s-23.2-5.11-32,0-8.85,13.4,0,18.51S54.65,424.2,63.5,419.09Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.11,413.74c1.82-3.37,1.23-7.08-1.78-10.22a15.24,15.24,0,0,0-1.92-1.69,18.91,18.91,0,0,0-1.84-1.21q-.54-.31-1.11-.6c.94,1.55.59,3.21-4.74,3.52-10.45.61,2.79,10.59,2.79,10.59S67.24,410.88,69.11,413.74Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68,411c1.57-.17,2.35-1.79,1.74-3.6a4.14,4.14,0,0,0-4-3c-1.56.17-2.34,1.78-1.73,3.6S66.46,411.16,68,411Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.51,419.3C51,415.42,34,404.68,34,404.68s-3.76-1.51-2.51-4.13a19,19,0,0,0-1.82,1.17c-.39.28-.75.57-1.1.87-5,4.37-5.05,10.11,0,14.49a13.85,13.85,0,0,0,1.09.87c.52.38,1.08.74,1.69,1.1s1.17.64,1.79.94,1,.45,1.53.65,1.05.4,1.59.58a32.77,32.77,0,0,0,5.06,1.21l1.14.17a40.4,40.4,0,0,0,5.05.32,39.67,39.67,0,0,0,6.19-.51S51,421.85,51.51,419.3Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.51,419.3C51,415.42,34,404.68,34,404.68s-3.76-1.51-2.51-4.13a19,19,0,0,0-1.82,1.17c-.39.28-.75.57-1.1.87-5,4.37-5.05,10.11,0,14.49a13.85,13.85,0,0,0,1.09.87c.52.38,1.08.74,1.69,1.1s1.17.64,1.79.94,1,.45,1.53.65,1.05.4,1.59.58a32.77,32.77,0,0,0,5.06,1.21l1.14.17a40.4,40.4,0,0,0,5.05.32,39.67,39.67,0,0,0,6.19-.51S51,421.85,51.51,419.3Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.53,402.94c-6.33,3.65-6.58,9.48-.77,13.31.24.16.5.32.77.48,6.6,3.8,17.28,3.8,23.88,0s6.59-10,0-13.79l-.83-.45C52,399.14,41.85,399.29,35.53,402.94Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.53,402.94c-6.33,3.65-6.58,9.48-.77,13.31.24.16.5.32.77.48,6.6,3.8,17.28,3.8,23.88,0s6.59-10,0-13.79l-.83-.45C52,399.14,41.85,399.29,35.53,402.94Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.48,
    cy: 409.83,
    rx: 16.14,
    ry: 9.32,
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.48,
    cy: 409.83,
    rx: 16.14,
    ry: 9.32,
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.07,405.84c6.3-3.63,16.52-3.63,22.82,0,2.58,1.49,4.1,3.36,4.57,5.29-.47,1.94-2,3.8-4.57,5.29-6.3,3.64-16.52,3.64-22.82,0-2.58-1.49-4.1-3.35-4.57-5.29C32,409.2,33.49,407.33,36.07,405.84Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.07,405.84c6.3-3.63,16.52-3.63,22.82,0,2.58,1.49,4.1,3.36,4.57,5.29-.47,1.94-2,3.8-4.57,5.29-6.3,3.64-16.52,3.64-22.82,0-2.58-1.49-4.1-3.35-4.57-5.29C32,409.2,33.49,407.33,36.07,405.84Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.64,412.64v-1.93c0-.79-.55-1.55-1.72-2.24l0,0a8.28,8.28,0,0,0-6.4-.58h0c-.85.21-1.65.49-2.39.74a24.14,24.14,0,0,1-2.56.8h0a4.4,4.4,0,0,1-1.22.11,2.79,2.79,0,0,1-1-.26l.08-.06.26-.16a5.19,5.19,0,0,1,.67-.33,4.67,4.67,0,0,1,3.59-.08l2.07-2.09v-1.92a9.91,9.91,0,0,0-5.66-.2,11.18,11.18,0,0,0-1.79.62l-2.07-1.19L37,405.26v1.92l.84.49a2.05,2.05,0,0,0-.36,1.11v1.92c0,.79.57,1.55,1.76,2.24a7.27,7.27,0,0,0,3.41,1h0c.23,0,.46,0,.68,0a13.33,13.33,0,0,0,3.67-.79l.71-.24L45.58,415v1.91a10.17,10.17,0,0,0,8-.34l2,1.18,2.47-1.43v-1.92l-.85-.48A2.25,2.25,0,0,0,57.64,412.64Zm-5.21-.16c-.19.1-.38.2-.57.28a5.29,5.29,0,0,1-4,.06c1.93-.68,3.55-1.28,4.92-.54Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.48,407.86h0c-.85.21-1.65.49-2.39.74a24.14,24.14,0,0,1-2.56.8h0a4.4,4.4,0,0,1-1.22.11,2.49,2.49,0,0,1-1.17-.35c-.8-.46-.91-1.13.24-1.88a2.26,2.26,0,0,1,.26-.16,7,7,0,0,1,.67-.34,4.71,4.71,0,0,1,3.59-.08l2.07-2.09a9.91,9.91,0,0,0-5.66-.2,11.18,11.18,0,0,0-1.79.62l-2.07-1.19L37,405.26l2,1.18,0,0c-2.07,1.58-2.12,3.21.22,4.56a7.16,7.16,0,0,0,3.41,1h.68a13.7,13.7,0,0,0,3.67-.79c2.37-.79,4.29-1.73,5.88-.81,1.07.62.77,1.4-.4,2.08-.19.1-.38.2-.57.28a5.26,5.26,0,0,1-4.11,0L45.58,415a10.12,10.12,0,0,0,8-.35l2,1.18,2.47-1.43-2-1.18c2-1.58,2.29-3.32-.11-4.72l0,0A8.28,8.28,0,0,0,49.48,407.86Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.48,407.86h0c-.85.21-1.65.49-2.39.74a24.14,24.14,0,0,1-2.56.8h0a4.4,4.4,0,0,1-1.22.11,2.49,2.49,0,0,1-1.17-.35c-.8-.46-.91-1.13.24-1.88a2.26,2.26,0,0,1,.26-.16,7,7,0,0,1,.67-.34,4.71,4.71,0,0,1,3.59-.08l2.07-2.09a9.91,9.91,0,0,0-5.66-.2,11.18,11.18,0,0,0-1.79.62l-2.07-1.19L37,405.26l2,1.18,0,0c-2.07,1.58-2.12,3.21.22,4.56a7.16,7.16,0,0,0,3.41,1h.68a13.7,13.7,0,0,0,3.67-.79c2.37-.79,4.29-1.73,5.88-.81,1.07.62.77,1.4-.4,2.08-.19.1-.38.2-.57.28a5.26,5.26,0,0,1-4.11,0L45.58,415a10.12,10.12,0,0,0,8-.35l2,1.18,2.47-1.43-2-1.18c2-1.58,2.29-3.32-.11-4.72l0,0A8.28,8.28,0,0,0,49.48,407.86Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "36.95 405.26 39.44 404.13 41.49 405.03 39.42 403.84 36.95 405.26",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43,404.49a11.53,11.53,0,0,1,5.31.18l-1.44,2,2.07-2.08A9.76,9.76,0,0,0,43,404.49Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.88,408.44l0,0c2.4,1.4,2.16,3.14.11,4.72,1.82-2,1.49-3.36-.49-4.5a9.31,9.31,0,0,0-6.06-.83A8.28,8.28,0,0,1,55.88,408.44Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "56.02 413.19 57.59 414.4 55.6 415.8 58.07 414.38 56.02 413.19",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.86,412.76a5.34,5.34,0,0,1-3.94.35L45.58,415l2.17-2.18A5.26,5.26,0,0,0,51.86,412.76Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5,409.4a3.22,3.22,0,0,1-3-.28c-.71-.62-.25-1.27.81-1.84-1.15.75-1,1.42-.24,1.88a2.49,2.49,0,0,0,1.17.35A4.4,4.4,0,0,0,44.5,409.4Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39,406.46c-.17.15-1.66,1.54-1,2.93s2.87,2.42,4.63,2.61h0a7.16,7.16,0,0,1-3.41-1C36.85,409.67,36.9,408,39,406.46Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-104"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.41,402a15.71,15.71,0,0,1,5.82-5.38c9.52-5.5,25-5.5,34.48,0A15.87,15.87,0,0,1,68.53,402h1.32v5h0c-.18,3.47-2.55,6.9-7.12,9.54-9.52,5.5-25,5.5-34.48,0-4.58-2.64-7-6.07-7.14-9.54h0v-5Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.41,402a15.71,15.71,0,0,1,5.82-5.38c9.52-5.5,25-5.5,34.48,0A15.87,15.87,0,0,1,68.53,402h1.32v5h0c-.18,3.47-2.55,6.9-7.12,9.54-9.52,5.5-25,5.5-34.48,0-4.58-2.64-7-6.07-7.14-9.54h0v-5Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.47,392.51c6.24,0,12.48,1.37,17.24,4.12A15.87,15.87,0,0,1,68.53,402h1.32v5h0c-.18,3.47-2.55,6.9-7.12,9.54-4.76,2.75-11,4.13-17.24,4.13Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.78,394.79a25.75,25.75,0,0,1,3.93,1.84A15.87,15.87,0,0,1,68.53,402h1.32v5h0c-.18,3.47-2.55,6.9-7.12,9.54a25.75,25.75,0,0,1-3.93,1.84Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.15,394.79a26.09,26.09,0,0,0-3.92,1.84A15.71,15.71,0,0,0,22.41,402H21.09v5h0c.17,3.47,2.56,6.9,7.14,9.54a26.09,26.09,0,0,0,3.92,1.84Z",
    style: {
      fill: "#8E4DFE",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.71,392.06c9.52,5.5,9.52,14.41,0,19.91-8.33,4.81-21.19,5.41-30.66,1.8h0l-.37-.15A26.14,26.14,0,0,1,28.23,412c-7.94-4.59-9.26-11.54-4-16.92h0a18.65,18.65,0,0,1,3.95-3C37.75,386.57,53.19,386.57,62.71,392.06Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.71,392.06c9.52,5.5,9.52,14.41,0,19.91-8.33,4.81-21.19,5.41-30.66,1.8h0l-.37-.15A26.14,26.14,0,0,1,28.23,412c-7.94-4.59-9.26-11.54-4-16.92h0a18.65,18.65,0,0,1,3.95-3C37.75,386.57,53.19,386.57,62.71,392.06Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.27,395.05a10.69,10.69,0,0,0-2.55,8.69c.85,4.83,7.62,8.91,10,9.88A26.14,26.14,0,0,1,28.23,412C20.29,407.38,19,400.43,24.27,395.05Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.66,409a10.69,10.69,0,0,0,2.55-8.69c-.84-4.83-7.62-8.91-9.95-9.88a26.76,26.76,0,0,1,3.45,1.65C70.64,396.65,72,403.61,66.66,409Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.48,
    cy: 402,
    rx: 22.66,
    ry: 13.08,
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.48,
    cy: 402,
    rx: 22.66,
    ry: 13.08,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.84,405.9c-1.82-3.36-1.22-7.07,1.78-10.22A15.19,15.19,0,0,1,27.54,394a18.3,18.3,0,0,1,1.84-1.21c.36-.22.73-.42,1.11-.61-.94,1.55-.59,3.21,4.74,3.52,10.45.61-2.79,10.6-2.79,10.6S25.71,403.05,23.84,405.9Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.92,403.14c-1.57-.17-2.34-1.78-1.73-3.6s2.37-3.14,3.94-3,2.34,1.78,1.73,3.6S26.49,403.32,24.92,403.14Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.44,411.46c.52-3.88,17.47-14.62,17.47-14.62s3.76-1.5,2.51-4.13a17.8,17.8,0,0,1,1.82,1.17c.39.28.76.57,1.1.87,5,4.37,5,10.11,0,14.49-.34.3-.71.59-1.1.87a19.51,19.51,0,0,1-1.68,1.1c-.58.33-1.18.65-1.8.94s-1,.45-1.53.66-1,.39-1.59.57a34,34,0,0,1-5.06,1.22l-1.13.16a40.56,40.56,0,0,1-5.06.32,39.67,39.67,0,0,1-6.19-.51S41.93,414,41.44,411.46Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.44,411.46c.52-3.88,17.47-14.62,17.47-14.62s3.76-1.5,2.51-4.13a17.8,17.8,0,0,1,1.82,1.17c.39.28.76.57,1.1.87,5,4.37,5,10.11,0,14.49-.34.3-.71.59-1.1.87a19.51,19.51,0,0,1-1.68,1.1c-.58.33-1.18.65-1.8.94s-1,.45-1.53.66-1,.39-1.59.57a34,34,0,0,1-5.06,1.22l-1.13.16a40.56,40.56,0,0,1-5.06.32,39.67,39.67,0,0,1-6.19-.51S41.93,414,41.44,411.46Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.42,395.1c6.33,3.65,6.58,9.48.77,13.31-.24.16-.5.32-.77.48-6.59,3.81-17.28,3.81-23.87,0s-6.6-10,0-13.79l.83-.44C41,391.3,51.1,391.45,57.42,395.1Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.42,395.1c6.33,3.65,6.58,9.48.77,13.31-.24.16-.5.32-.77.48-6.59,3.81-17.28,3.81-23.87,0s-6.6-10,0-13.79l.83-.44C41,391.3,51.1,391.45,57.42,395.1Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.48,
    cy: 402,
    rx: 16.14,
    ry: 9.32,
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.48,
    cy: 402,
    rx: 16.14,
    ry: 9.32,
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.89,398c-6.31-3.64-16.52-3.64-22.83,0-2.57,1.48-4.1,3.35-4.56,5.29.46,1.93,2,3.8,4.56,5.28,6.31,3.64,16.52,3.64,22.83,0,2.57-1.48,4.1-3.35,4.57-5.29C61,401.36,59.46,399.49,56.89,398Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.89,398c-6.31-3.64-16.52-3.64-22.83,0-2.57,1.48-4.1,3.35-4.56,5.29.46,1.93,2,3.8,4.56,5.28,6.31,3.64,16.52,3.64,22.83,0,2.57-1.48,4.1-3.35,4.57-5.29C61,401.36,59.46,399.49,56.89,398Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.64,404.8v-1.92c0-.79-.55-1.56-1.72-2.25l0,0a8.25,8.25,0,0,0-6.4-.59h0c-.85.22-1.65.49-2.39.74a24.14,24.14,0,0,1-2.56.8h0a4.42,4.42,0,0,1-1.22.12,2.62,2.62,0,0,1-1-.27l.08-.06.26-.15a5.28,5.28,0,0,1,.67-.34,4.67,4.67,0,0,1,3.59-.08l2.07-2.09v-1.91a9.83,9.83,0,0,0-5.66-.21,11.18,11.18,0,0,0-1.79.62L37.42,396,35,397.42v1.92l.84.49a2.06,2.06,0,0,0-.36,1.12v1.91c0,.79.57,1.55,1.76,2.24a7.27,7.27,0,0,0,3.41,1h.68a13.62,13.62,0,0,0,3.67-.79l.71-.25-2.08,2.09V409a10.17,10.17,0,0,0,8-.34l2,1.18,2.47-1.43v-1.91l-.85-.49A2.25,2.25,0,0,0,55.64,404.8Zm-5.21-.16a5,5,0,0,1-.57.28,5.29,5.29,0,0,1-4,.06c1.93-.68,3.55-1.27,4.92-.54Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.48,400h0c-.85.22-1.65.49-2.39.74a24.14,24.14,0,0,1-2.56.8h0a4.42,4.42,0,0,1-1.22.12,2.74,2.74,0,0,1-1.17-.35c-.79-.46-.91-1.13.24-1.89a2.26,2.26,0,0,1,.26-.16,5.19,5.19,0,0,1,.67-.33,4.67,4.67,0,0,1,3.59-.09l2.07-2.08a9.83,9.83,0,0,0-5.66-.21,11.18,11.18,0,0,0-1.79.62L37.42,396,35,397.42l2,1.19h0c-2.07,1.58-2.11,3.22.22,4.56a7.29,7.29,0,0,0,3.41,1h.68a13.62,13.62,0,0,0,3.67-.79c2.37-.79,4.29-1.73,5.88-.8,1.07.61.78,1.39-.4,2.07a5,5,0,0,1-.57.28,5.26,5.26,0,0,1-4.11,0l-2.17,2.18a10.12,10.12,0,0,0,8-.35l2,1.18,2.47-1.42-2-1.18c2-1.59,2.29-3.32-.11-4.73l0,0A8.25,8.25,0,0,0,47.48,400Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.48,400h0c-.85.22-1.65.49-2.39.74a24.14,24.14,0,0,1-2.56.8h0a4.42,4.42,0,0,1-1.22.12,2.74,2.74,0,0,1-1.17-.35c-.79-.46-.91-1.13.24-1.89a2.26,2.26,0,0,1,.26-.16,5.19,5.19,0,0,1,.67-.33,4.67,4.67,0,0,1,3.59-.09l2.07-2.08a9.83,9.83,0,0,0-5.66-.21,11.18,11.18,0,0,0-1.79.62L37.42,396,35,397.42l2,1.19h0c-2.07,1.58-2.11,3.22.22,4.56a7.29,7.29,0,0,0,3.41,1h.68a13.62,13.62,0,0,0,3.67-.79c2.37-.79,4.29-1.73,5.88-.8,1.07.61.78,1.39-.4,2.07a5,5,0,0,1-.57.28,5.26,5.26,0,0,1-4.11,0l-2.17,2.18a10.12,10.12,0,0,0,8-.35l2,1.18,2.47-1.42-2-1.18c2-1.59,2.29-3.32-.11-4.73l0,0A8.25,8.25,0,0,0,47.48,400Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "34.95 397.43 37.44 396.3 39.49 397.19 37.42 396 34.95 397.43",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41,396.65a11.53,11.53,0,0,1,5.31.18l-1.44,2,2.07-2.08A9.76,9.76,0,0,0,41,396.65Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.88,400.61l0,0c2.4,1.41,2.16,3.14.11,4.73,1.82-2,1.49-3.37-.49-4.51a9.31,9.31,0,0,0-6.06-.83A8.25,8.25,0,0,1,53.88,400.61Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "54.03 405.36 55.59 406.56 53.6 407.96 56.07 406.54 54.03 405.36",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.86,404.92a5.34,5.34,0,0,1-3.94.35l-2.34,1.86L45.75,405A5.26,5.26,0,0,0,49.86,404.92Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5,401.56a3.2,3.2,0,0,1-3-.28c-.72-.61-.26-1.27.8-1.84-1.15.76-1,1.43-.24,1.89a2.74,2.74,0,0,0,1.17.35A4.42,4.42,0,0,0,42.5,401.56Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37,398.62c-.17.16-1.66,1.54-1,2.93s2.87,2.42,4.63,2.61h0a7.29,7.29,0,0,1-3.41-1C34.86,401.84,34.9,400.2,37,398.62Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "23.93 399.54 24.55 394.87 25.16 399.54 33.24 399.89 25.16 400.25 24.55 404.91 23.93 400.25 15.86 399.89 23.93 399.54",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coins--inject-104"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-104"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.61,442.7a15.79,15.79,0,0,0-5.82-5.38c-9.52-5.5-25-5.5-34.48,0a15.71,15.71,0,0,0-5.82,5.38H66.17v5h0c.17,3.47,2.54,6.9,7.12,9.54,9.52,5.5,25,5.5,34.48,0,4.58-2.64,7-6.07,7.14-9.54h0v-5Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.61,442.7a15.79,15.79,0,0,0-5.82-5.38c-9.52-5.5-25-5.5-34.48,0a15.71,15.71,0,0,0-5.82,5.38H66.17v5h0c.17,3.47,2.54,6.9,7.12,9.54,9.52,5.5,25,5.5,34.48,0,4.58-2.64,7-6.07,7.14-9.54h0v-5Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.55,433.19c-6.24,0-12.48,1.38-17.24,4.13a15.71,15.71,0,0,0-5.82,5.38H66.17v5h0c.17,3.47,2.54,6.9,7.12,9.54,4.76,2.75,11,4.13,17.24,4.13Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.23,435.48a26.09,26.09,0,0,0-3.92,1.84,15.71,15.71,0,0,0-5.82,5.38H66.17v5h0c.17,3.47,2.54,6.9,7.12,9.54a26.09,26.09,0,0,0,3.92,1.84Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.86,435.48a25.75,25.75,0,0,1,3.93,1.84,15.79,15.79,0,0,1,5.82,5.38h1.32v5h0c-.18,3.47-2.57,6.9-7.14,9.54a25.75,25.75,0,0,1-3.93,1.84Z",
    style: {
      fill: "#8E4DFE",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.31,432.75c-9.52,5.5-9.52,14.41,0,19.91,8.33,4.81,21.19,5.41,30.65,1.8h0l.38-.15a26.76,26.76,0,0,0,3.45-1.65c7.94-4.59,9.26-11.54,3.95-16.92h0a18.32,18.32,0,0,0-3.95-3C98.27,427.26,82.83,427.26,73.31,432.75Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.31,432.75c-9.52,5.5-9.52,14.41,0,19.91,8.33,4.81,21.19,5.41,30.65,1.8h0l.38-.15a26.76,26.76,0,0,0,3.45-1.65c7.94-4.59,9.26-11.54,3.95-16.92h0a18.32,18.32,0,0,0-3.95-3C98.27,427.26,82.83,427.26,73.31,432.75Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.74,435.74a10.69,10.69,0,0,1,2.55,8.69c-.84,4.83-7.62,8.91-10,9.88a26.76,26.76,0,0,0,3.45-1.65C115.73,448.07,117.05,441.12,111.74,435.74Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.36,449.67A10.62,10.62,0,0,1,66.81,441c.84-4.83,7.61-8.91,10-9.88a26.76,26.76,0,0,0-3.45,1.65C65.37,437.34,64.05,444.29,69.36,449.67Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.56,
    cy: 442.69,
    rx: 22.66,
    ry: 13.08,
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.56,
    cy: 442.69,
    rx: 22.66,
    ry: 13.08,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.19,446.59c1.82-3.36,1.23-7.08-1.78-10.22a14.43,14.43,0,0,0-1.92-1.68,18.13,18.13,0,0,0-1.83-1.21c-.37-.22-.74-.42-1.12-.61.94,1.55.6,3.21-4.74,3.52C90.35,437,103.59,447,103.59,447S110.32,443.73,112.19,446.59Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.11,443.83c1.57-.17,2.35-1.79,1.74-3.6s-2.38-3.14-3.94-3-2.35,1.78-1.74,3.6S109.55,444,111.11,443.83Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.59,452.15c-.51-3.88-17.47-14.62-17.47-14.62s-3.76-1.5-2.51-4.13a17.63,17.63,0,0,0-1.81,1.17c-.4.28-.76.57-1.11.87-5,4.37-5,10.11,0,14.49.34.3.71.59,1.1.87a18.07,18.07,0,0,0,1.68,1.1c.57.33,1.17.65,1.79.94s1,.45,1.53.66,1,.39,1.59.57a32.77,32.77,0,0,0,5.06,1.21c.38.07.76.12,1.14.17a40.44,40.44,0,0,0,5.06.32,39.64,39.64,0,0,0,6.18-.51S94.11,454.7,94.59,452.15Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.59,452.15c-.51-3.88-17.47-14.62-17.47-14.62s-3.76-1.5-2.51-4.13a17.63,17.63,0,0,0-1.81,1.17c-.4.28-.76.57-1.11.87-5,4.37-5,10.11,0,14.49.34.3.71.59,1.1.87a18.07,18.07,0,0,0,1.68,1.1c.57.33,1.17.65,1.79.94s1,.45,1.53.66,1,.39,1.59.57a32.77,32.77,0,0,0,5.06,1.21c.38.07.76.12,1.14.17a40.44,40.44,0,0,0,5.06.32,39.64,39.64,0,0,0,6.18-.51S94.11,454.7,94.59,452.15Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.61,435.79c-6.32,3.65-6.58,9.48-.77,13.31l.77.48c6.6,3.8,17.28,3.8,23.88,0s6.59-10,0-13.79l-.83-.44C95,432,84.94,432.14,78.61,435.79Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.61,435.79c-6.32,3.65-6.58,9.48-.77,13.31l.77.48c6.6,3.8,17.28,3.8,23.88,0s6.59-10,0-13.79l-.83-.44C95,432,84.94,432.14,78.61,435.79Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.56,
    cy: 442.68,
    rx: 16.14,
    ry: 9.32,
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.56,
    cy: 442.68,
    rx: 16.14,
    ry: 9.32,
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.15,438.7c6.3-3.64,16.52-3.64,22.82,0,2.58,1.48,4.1,3.35,4.57,5.28-.47,1.94-2,3.81-4.57,5.29-6.3,3.64-16.52,3.64-22.82,0-2.58-1.48-4.1-3.35-4.57-5.29C75.05,442.05,76.57,440.18,79.15,438.7Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.15,438.7c6.3-3.64,16.52-3.64,22.82,0,2.58,1.48,4.1,3.35,4.57,5.28-.47,1.94-2,3.81-4.57,5.29-6.3,3.64-16.52,3.64-22.82,0-2.58-1.48-4.1-3.35-4.57-5.29C75.05,442.05,76.57,440.18,79.15,438.7Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.72,445.49v-1.92c0-.79-.55-1.56-1.72-2.25l0,0a8.25,8.25,0,0,0-6.4-.59h0c-.85.22-1.65.49-2.39.74a23.44,23.44,0,0,1-2.56.8h0a4.81,4.81,0,0,1-1.21.12,2.71,2.71,0,0,1-1-.27l.08-.06.25-.15a5.39,5.39,0,0,1,.68-.34,4.64,4.64,0,0,1,3.58-.08L92,439.38v-1.91a9.8,9.8,0,0,0-5.65-.21,11,11,0,0,0-1.8.62l-2.07-1.19L80,438.11V440l.84.49a2.06,2.06,0,0,0-.36,1.12v1.91c0,.79.57,1.55,1.76,2.24a7.27,7.27,0,0,0,3.41,1h.69A14,14,0,0,0,90,446l.71-.25-2.08,2.09v1.91a10.17,10.17,0,0,0,8-.34l2,1.18,2.47-1.43v-1.91l-.85-.49A2.25,2.25,0,0,0,100.72,445.49Zm-5.21-.16a5,5,0,0,1-.57.28,5.29,5.29,0,0,1-4,.06c1.94-.68,3.55-1.28,4.93-.54Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.56,440.71h0c-.85.22-1.65.49-2.39.74a23.44,23.44,0,0,1-2.56.8h0a4.81,4.81,0,0,1-1.21.12,2.74,2.74,0,0,1-1.18-.35c-.79-.46-.91-1.14.25-1.89l.25-.16a7.18,7.18,0,0,1,.68-.34,4.69,4.69,0,0,1,3.58-.08L92,437.47a9.8,9.8,0,0,0-5.65-.21,11,11,0,0,0-1.8.62l-2.07-1.19L80,438.11l2,1.19h0c-2.07,1.58-2.11,3.21.22,4.56a7.16,7.16,0,0,0,3.41,1h.69a13.63,13.63,0,0,0,3.66-.79c2.37-.79,4.29-1.73,5.88-.8,1.07.61.78,1.39-.4,2.07a5,5,0,0,1-.57.28,5.26,5.26,0,0,1-4.11,0l-2.17,2.18a10.12,10.12,0,0,0,8-.35l2,1.18,2.47-1.42-2-1.18c2-1.59,2.29-3.32-.11-4.73l0,0A8.25,8.25,0,0,0,92.56,440.71Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.56,440.71h0c-.85.22-1.65.49-2.39.74a23.44,23.44,0,0,1-2.56.8h0a4.81,4.81,0,0,1-1.21.12,2.74,2.74,0,0,1-1.18-.35c-.79-.46-.91-1.14.25-1.89l.25-.16a7.18,7.18,0,0,1,.68-.34,4.69,4.69,0,0,1,3.58-.08L92,437.47a9.8,9.8,0,0,0-5.65-.21,11,11,0,0,0-1.8.62l-2.07-1.19L80,438.11l2,1.19h0c-2.07,1.58-2.11,3.21.22,4.56a7.16,7.16,0,0,0,3.41,1h.69a13.63,13.63,0,0,0,3.66-.79c2.37-.79,4.29-1.73,5.88-.8,1.07.61.78,1.39-.4,2.07a5,5,0,0,1-.57.28,5.26,5.26,0,0,1-4.11,0l-2.17,2.18a10.12,10.12,0,0,0,8-.35l2,1.18,2.47-1.42-2-1.18c2-1.59,2.29-3.32-.11-4.73l0,0A8.25,8.25,0,0,0,92.56,440.71Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "80.03 438.11 82.52 436.99 84.57 437.88 82.5 436.69 80.03 438.11",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.08,437.34a11.53,11.53,0,0,1,5.31.18l-1.44,2L92,437.47A9.76,9.76,0,0,0,86.08,437.34Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99,441.3l0,0c2.4,1.41,2.16,3.14.11,4.73,1.82-2,1.49-3.37-.49-4.51a9.31,9.31,0,0,0-6.06-.83A8.25,8.25,0,0,1,99,441.3Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.11 446.05 100.67 447.25 98.68 448.65 101.15 447.23 99.11 446.05",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.94,445.61A5.34,5.34,0,0,1,91,446l-2.34,1.86,2.17-2.18A5.26,5.26,0,0,0,94.94,445.61Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.58,442.25a3.2,3.2,0,0,1-3-.28c-.72-.61-.26-1.27.81-1.84-1.16.75-1,1.43-.25,1.89a2.74,2.74,0,0,0,1.18.35A4.81,4.81,0,0,0,87.58,442.25Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.05,439.31c-.17.16-1.66,1.54-1,2.93s2.88,2.42,4.63,2.61h0a7.16,7.16,0,0,1-3.41-1C79.94,442.52,80,440.89,82.05,439.31Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-104"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.61,436.41A15.83,15.83,0,0,1,77.44,431c9.52-5.5,25-5.5,34.47,0a15.83,15.83,0,0,1,5.83,5.38h1.31v5h0c-.18,3.47-2.55,6.9-7.13,9.54-9.52,5.5-25,5.5-34.47,0-4.58-2.64-7-6.07-7.14-9.54h0v-5Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.61,436.41A15.83,15.83,0,0,1,77.44,431c9.52-5.5,25-5.5,34.47,0a15.83,15.83,0,0,1,5.83,5.38h1.31v5h0c-.18,3.47-2.55,6.9-7.13,9.54-9.52,5.5-25,5.5-34.47,0-4.58-2.64-7-6.07-7.14-9.54h0v-5Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.67,426.91c6.24,0,12.48,1.37,17.24,4.12a15.83,15.83,0,0,1,5.83,5.38h1.31v5h0c-.18,3.47-2.55,6.9-7.13,9.54-4.76,2.75-11,4.13-17.24,4.13Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,429.19a25.2,25.2,0,0,1,3.92,1.84,15.83,15.83,0,0,1,5.83,5.38h1.31v5h0c-.18,3.47-2.55,6.9-7.13,9.54a25.2,25.2,0,0,1-3.92,1.84Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.36,429.19A25.64,25.64,0,0,0,77.44,431a15.83,15.83,0,0,0-5.83,5.38H70.3v5h0c.17,3.47,2.56,6.9,7.14,9.54a25.64,25.64,0,0,0,3.92,1.84Z",
    style: {
      fill: "#8E4DFE",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.91,426.46c9.53,5.5,9.52,14.41,0,19.91-8.33,4.81-21.18,5.41-30.65,1.8h0l-.38-.15a26.62,26.62,0,0,1-3.44-1.65c-7.94-4.59-9.26-11.54-4-16.92h0a19,19,0,0,1,4-3C87,421,102.39,421,111.91,426.46Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.91,426.46c9.53,5.5,9.52,14.41,0,19.91-8.33,4.81-21.18,5.41-30.65,1.8h0l-.38-.15a26.62,26.62,0,0,1-3.44-1.65c-7.94-4.59-9.26-11.54-4-16.92h0a19,19,0,0,1,4-3C87,421,102.39,421,111.91,426.46Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.48,429.45a10.69,10.69,0,0,0-2.55,8.69c.85,4.84,7.62,8.91,9.95,9.88a26.62,26.62,0,0,1-3.44-1.65C69.5,441.78,68.18,434.83,73.48,429.45Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.87,443.38a10.69,10.69,0,0,0,2.55-8.69c-.84-4.83-7.62-8.9-10-9.88a26.62,26.62,0,0,1,3.44,1.65C119.85,431.05,121.17,438,115.87,443.38Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.66,445.65c-8.85-5.11-8.85-13.4,0-18.51s23.2-5.11,32.05,0,8.85,13.4,0,18.51S87.51,450.76,78.66,445.65Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.66,445.65c-8.85-5.11-8.85-13.4,0-18.51s23.2-5.11,32.05,0,8.85,13.4,0,18.51S87.51,450.76,78.66,445.65Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.05,440.3c-1.82-3.36-1.23-7.07,1.78-10.22a15.19,15.19,0,0,1,1.92-1.68,18.3,18.3,0,0,1,1.84-1.21c.36-.21.73-.42,1.11-.61-.94,1.55-.59,3.21,4.74,3.52,10.45.61-2.79,10.6-2.79,10.6S74.92,437.45,73.05,440.3Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.13,437.54c-1.57-.17-2.34-1.78-1.74-3.6a4.14,4.14,0,0,1,4-3c1.56.17,2.34,1.79,1.73,3.6S75.7,437.72,74.13,437.54Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.65,445.86c.52-3.88,17.47-14.62,17.47-14.62s3.76-1.5,2.51-4.13a19,19,0,0,1,1.82,1.17c.39.28.75.57,1.1.87,5,4.37,5,10.11,0,14.49-.35.3-.71.59-1.1.87a18.26,18.26,0,0,1-1.69,1.1c-.57.33-1.17.65-1.79.94s-1,.45-1.53.66-1,.39-1.59.57a34,34,0,0,1-5.06,1.22l-1.14.16a40.4,40.4,0,0,1-5.05.32,38.49,38.49,0,0,1-6.19-.51S91.14,448.41,90.65,445.86Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.65,445.86c.52-3.88,17.47-14.62,17.47-14.62s3.76-1.5,2.51-4.13a19,19,0,0,1,1.82,1.17c.39.28.75.57,1.1.87,5,4.37,5,10.11,0,14.49-.35.3-.71.59-1.1.87a18.26,18.26,0,0,1-1.69,1.1c-.57.33-1.17.65-1.79.94s-1,.45-1.53.66-1,.39-1.59.57a34,34,0,0,1-5.06,1.22l-1.14.16a40.4,40.4,0,0,1-5.05.32,38.49,38.49,0,0,1-6.19-.51S91.14,448.41,90.65,445.86Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.63,429.5c6.33,3.66,6.58,9.48.77,13.31-.24.16-.5.32-.77.48-6.59,3.81-17.28,3.81-23.87,0s-6.6-10,0-13.79l.83-.44C90.21,425.7,100.31,425.85,106.63,429.5Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.63,429.5c6.33,3.66,6.58,9.48.77,13.31-.24.16-.5.32-.77.48-6.59,3.81-17.28,3.81-23.87,0s-6.6-10,0-13.79l.83-.44C90.21,425.7,100.31,425.85,106.63,429.5Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.1,429.81c6.3,3.64,6.3,9.54,0,13.17s-16.53,3.64-22.83,0-6.3-9.53,0-13.17S99.79,426.17,106.1,429.81Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.1,429.81c6.3,3.64,6.3,9.54,0,13.17s-16.53,3.64-22.83,0-6.3-9.53,0-13.17S99.79,426.17,106.1,429.81Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.1,432.41c-6.31-3.64-16.53-3.64-22.83,0-2.57,1.48-4.1,3.35-4.57,5.29.47,1.93,2,3.8,4.57,5.28,6.3,3.64,16.52,3.64,22.83,0,2.57-1.48,4.09-3.35,4.56-5.28C110.19,435.76,108.67,433.89,106.1,432.41Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.1,432.41c-6.31-3.64-16.53-3.64-22.83,0-2.57,1.48-4.1,3.35-4.57,5.29.47,1.93,2,3.8,4.57,5.28,6.3,3.64,16.52,3.64,22.83,0,2.57-1.48,4.09-3.35,4.56-5.28C110.19,435.76,108.67,433.89,106.1,432.41Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.85,439.2v-1.92c0-.79-.55-1.56-1.72-2.25l0,0a8.31,8.31,0,0,0-6.41-.59h0c-.85.22-1.66.49-2.39.74a24.14,24.14,0,0,1-2.56.8h0a4.42,4.42,0,0,1-1.22.12,2.57,2.57,0,0,1-1-.27l.08-.06.26-.15a5.28,5.28,0,0,1,.67-.34,4.67,4.67,0,0,1,3.59-.08l2.07-2.09v-1.91a9.83,9.83,0,0,0-5.66-.21,11.63,11.63,0,0,0-1.8.62l-2.06-1.19-2.47,1.42v1.92l.84.49a2.06,2.06,0,0,0-.36,1.12v1.91c0,.79.57,1.55,1.76,2.24a7.24,7.24,0,0,0,3.41,1h.68a13.7,13.7,0,0,0,3.67-.79l.71-.25-2.08,2.09v1.91a10.17,10.17,0,0,0,8-.34l2,1.18,2.47-1.43v-1.91l-.85-.49A2.25,2.25,0,0,0,104.85,439.2ZM99.64,439a5,5,0,0,1-.57.28,5.29,5.29,0,0,1-4,.06c1.93-.68,3.55-1.27,4.92-.54C99.86,438.91,99.75,439,99.64,439Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.68,434.42h0c-.85.22-1.66.49-2.39.74a24.14,24.14,0,0,1-2.56.8h0a4.42,4.42,0,0,1-1.22.12,2.7,2.7,0,0,1-1.17-.35c-.8-.46-.91-1.13.24-1.89a2.26,2.26,0,0,1,.26-.16,5.19,5.19,0,0,1,.67-.33,4.67,4.67,0,0,1,3.59-.09l2.07-2.08a9.83,9.83,0,0,0-5.66-.21,11.63,11.63,0,0,0-1.8.62l-2.06-1.19-2.47,1.42,2,1.19h0c-2.07,1.58-2.12,3.22.22,4.56a7.26,7.26,0,0,0,3.41,1h.68a13.7,13.7,0,0,0,3.67-.79c2.36-.79,4.28-1.73,5.88-.8,1.07.61.77,1.39-.4,2.07a5,5,0,0,1-.57.28,5.29,5.29,0,0,1-4.12,0l-2.16,2.18a10.09,10.09,0,0,0,8-.35l2,1.18,2.47-1.42-2-1.18c2.06-1.59,2.29-3.32-.1-4.73l0,0A8.31,8.31,0,0,0,96.68,434.42Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.68,434.42h0c-.85.22-1.66.49-2.39.74a24.14,24.14,0,0,1-2.56.8h0a4.42,4.42,0,0,1-1.22.12,2.7,2.7,0,0,1-1.17-.35c-.8-.46-.91-1.13.24-1.89a2.26,2.26,0,0,1,.26-.16,5.19,5.19,0,0,1,.67-.33,4.67,4.67,0,0,1,3.59-.09l2.07-2.08a9.83,9.83,0,0,0-5.66-.21,11.63,11.63,0,0,0-1.8.62l-2.06-1.19-2.47,1.42,2,1.19h0c-2.07,1.58-2.12,3.22.22,4.56a7.26,7.26,0,0,0,3.41,1h.68a13.7,13.7,0,0,0,3.67-.79c2.36-.79,4.28-1.73,5.88-.8,1.07.61.77,1.39-.4,2.07a5,5,0,0,1-.57.28,5.29,5.29,0,0,1-4.12,0l-2.16,2.18a10.09,10.09,0,0,0,8-.35l2,1.18,2.47-1.42-2-1.18c2.06-1.59,2.29-3.32-.1-4.73l0,0A8.31,8.31,0,0,0,96.68,434.42Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "84.16 431.82 86.65 430.69 88.69 431.59 86.63 430.4 84.16 431.82",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.21,431.05a11.49,11.49,0,0,1,5.3.18l-1.43,2,2.07-2.08A9.76,9.76,0,0,0,90.21,431.05Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.09,435l0,0c2.39,1.41,2.16,3.14.1,4.73,1.82-2,1.5-3.37-.48-4.51a9.33,9.33,0,0,0-6.07-.83A8.31,8.31,0,0,1,103.09,435Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.23 439.76 104.8 440.96 102.81 442.36 105.28 440.94 103.23 439.76",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.07,439.32a5.34,5.34,0,0,1-3.94.35l-2.34,1.86L95,439.35A5.29,5.29,0,0,0,99.07,439.32Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.71,436a3.19,3.19,0,0,1-3-.28c-.71-.61-.25-1.27.81-1.84-1.15.76-1,1.43-.24,1.89a2.7,2.7,0,0,0,1.17.35A4.42,4.42,0,0,0,91.71,436Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.18,433c-.17.16-1.66,1.54-1,2.93s2.87,2.42,4.63,2.61h0a7.26,7.26,0,0,1-3.41-1C84.06,436.24,84.11,434.6,86.18,433Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "73.14 433.94 73.76 429.27 74.37 433.94 82.45 434.29 74.37 434.64 73.76 439.31 73.14 434.64 65.07 434.29 73.14 433.94",
    style: {
      fill: "#fff"
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNftAmico);
export default __webpack_public_path__ + "static/media/NFT-amico.b66feffc8d32c3aba033464d94758d78.svg";
export { ForwardRef as ReactComponent };